import {
  ACTIONS_CATEGORIES,
  CONFLUENCE,
  DATEV_ACCOUNTING,
  DATEV_HR,
  GOOGLE_CALENDAR,
  GOOGLE_DOCS,
  GOOGLE_DRIVE,
  GOOGLE_GMAIL,
  GOOGLE_SHEETS,
  HUBSPOT,
  JIRA,
  MICROSOFT_D365,
  MICROSOFT_ONEDRIVE,
  MICROSOFT_SHAREPOINT,
  MICROSOFT_TEAMS,
  OUTLOOK_CALENDAR,
  OUTLOOK_EMAIL,
  PERSONA_TYPE,
  SAP_S4HANA,
  SLACK,
  SQL_DATABASE
} from 'src/types/enum';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';
const deJSON = {
  //General
  [T.empowerGPT]: 'EmpowerGPT',
  [T.knowledgeBaseChat]: 'Wissensdatenbank Chat',
  [T.enterprise]: 'Unternehmen',
  [T.worldKnowledge]: 'Weltwissen',
  [T.noKnowledgeAccess]: 'Sie haben keinen Zugriff',
  [T.generalChat]: 'Allgemeiner Chat',
  [T.languageSwitcher]: 'Sprache wählen',
  [T.logout]: 'Abmelden',
  [T.profile]: 'Profil',
  [T.uploadImport]: 'Hochladed / Importieren',
  [T.documents]: 'Dokumente',
  [T.conversations]: 'Erledigte Konversationen',
  [T.valuableInsights]: 'Gewinnen Sie schnell wertvolle Erkenntnisse',
  [T.uploadFiles]: 'Dateien hochladen.',
  [T.clearFilters]: 'Zurücksetzen',
  [T.resetFilters]: 'Filter zurücksetzen',
  [T.resetPassword]: 'Kennwort ändern',
  [T.userGroups]: 'Benutzergruppen',
  [T.userGroupName]: 'Benutzergruppenname',
  [T.accountType]: 'Konto Typ',
  [T.email]: 'E-Mail',
  [T.expand]: 'Erweitern',
  [T.startChat]: 'Chat starten',
  [T.addToChat]: 'Zum Chat hinzufügen',
  [T.addToAssistant]: 'Zum Assistenten hinzufügen',
  [T.addToDataset]: 'Zum Datensatz hinzufügen',
  [T.createdWithTime]: 'vor {{time}} erstellt',
  [T.modifiedWithTime]: 'vor {{time}} geändert',
  [T.syncedWithTime]: 'Synchronisiert vor {{time}}',
  [T.rolesAndPermissions]: 'Rollen und Berechtigungen',
  [T.selectItemsToDelete]: 'Elemente zum Löschen auswählen',
  [T.selectItemsToTag]: 'Elemente zum Markieren auswählen',
  [T.selectItemsToMove]: 'Elemente zum Verschieben auswählen',
  [T.noPermissionToDelete]: 'Keine Berechtigung zum Löschen',
  [T.noPermissionToView]: 'Keine Berechtigung zum Anzeigen',
  [T.noPermissionToMoveHere]: 'Keine Berechtigung zum Verschieben hierher',
  [T.noPermissionToDownload]: 'Keine Berechtigung zum Herunterladen',
  [T.tagDisabledForWorkspaceChat]:
    'Die Funktion "Tags" steht in Arbeitsbereich-Chats nicht zur Verfügung',
  [T.typeToSearch]: 'tippe um zu suchen',
  [T.usage]: 'Verwendung',
  [T.inPlanUsage]: 'Nutzung im Tarif',
  [T.disclaimerEgpt]:
    'Das KI-Modell kann Fehler machen, bitte prüfen Sie dies anhand der angegebenen Zitate.',
  [T.reprocess]: 'Erneut verarbeiten',
  [T.invalidFileType]: 'Ungültiger Dateityp',
  [T.selectItemsToReprocess]: 'Elemente zum erneuten Verarbeiten auswählen',
  [T.chatGPT]: 'ChatGPT',
  [T.fileProcessing]: 'Dateiverarbeitung',
  [T.enterpriseKnowledgeChat]: 'Unternehmenswissen-Chat',
  [T.worldKnowledgeChat]: 'Weltwissen-Chat',
  [T.ok]: 'OK',
  [T.goBack]: 'Zurück',
  [T.settings]: 'Einstellungen',
  [T.adminConsole]: 'Admin-Konsole',
  [T.llmsSettingsHeading]: 'AI-Modelle verfügbar im Chat',
  [T.selectModels]: 'Modelle auswählen',
  [T.modelsWarning]: 'Bitte wählen Sie mindestens ein Modell aus.',
  [T.version]: 'Version',
  [T.configure]: 'Konfigurieren',
  [T.tenantKnowledgeBase]: '{{tenant}}wissen',
  [T.noInternet]:
    'Keine Internetverbindung. Bitte überprüfen Sie Ihr Internet und versuchen Sie es erneut.',
  [T.loading]: 'Laden',
  [T.addMore]: 'Mehr hinzufügen',
  [T.usageAndAnalytics]: 'Nutzung und Analysen',
  [T.analytics]: 'Analytik',
  [T.userAndRoles]: 'Benutzer und Rollen',
  [T.menu]: 'Menü',
  [T.noFileName]: 'Kein Dateiname',
  [T.inviteTeammates]: 'Laden Sie Ihre Teammitglieder ein',
  [T.inviteTeammatesDescription]:
    'Verschaffen Sie Ihren Teammitgliedern schnellen Zugang zu wichtigem Wissen',
  [T.newestToOldest]: 'Neueste zuerst',
  [T.oldestToNewest]: 'Älteste zuerst',
  [T.aToZ]: 'A–Z',
  [T.zToA]: 'Z–A',
  [T.count]: 'Anzahl',
  //filters
  [T.search]: 'Suchen',
  [T.searchUser]: 'Benutzer suchen',
  [T.searchTenant]: 'Mieter suchen',
  [T.searching]: 'Ich suche...',
  [T.accountTypeSelect]: 'Wählen Sie den Kontotyp aus',
  [T.selected]: `Ausgewählt`,
  [T.noOptions]: 'Keine Optionen',
  [T.filters]: 'Filtern',
  [T.revokeAccess]: 'Zugang widerrufen',

  // Documents
  [T.uploadDocs]: 'Dokumente hochladen',
  [T.allDocuments]: 'Alle Dokumente',
  [T.docName]: 'Dokument name',
  [T.uploadedBy]: 'Hochgeladen von',
  [T.uploadedOn]: 'Hochgeladen am',
  [T.uploadedContent]: 'Hochgeladene Inhalte',
  [T.actions]: 'Aktionen',
  [T.view]: 'Ansehen',
  [T.share]: 'Teilen',
  [T.shared]: 'Geteilt',
  [T.sync]: 'Synchronisieren',
  [T.sharedWith]: 'Geteilt mit',
  [T.invite]: 'Einladen',
  [T.details]: 'KI-Übersicht',
  [T.documentType]: 'Dokumenttyp',
  [T.size]: 'Größe',
  [T.length]: 'Länge',
  [T.description]: 'Beschreibung',
  [T.descriptionOptional]: 'Beschreibung (optional)',
  [T.rowsPerPage]: 'Zeilen pro Seite',
  [T.noRowsFound]: 'Keine Zeilen gefunden.',
  [T.uploadTimeAndDateWithUser]: 'Am {{time}} von {{user}} hochgeladen',
  [T.download]: 'Herunterladen',
  [T.uploadProgress]: 'Upload-Fortschritt',
  [T.docsDropMessage]:
    'Ziehen Sie die Dokumente hierhin, um mit dem Hochladen zu beginnen.',
  [T.uploadDocFailed]: 'Fehler beim Hochladen der Dokumente',
  [T.uploadDocsFailed]: 'Fehler beim Hochladen der Dokument',
  [T.uploadMessage]: 'Sie haben {{count}} Dokumente hochgeladen.',
  [T.dropDocsMessage1]:
    'Ziehen Sie die Dokumente hierhin, um mit dem Hochladen zu beginnen.',
  [T.dropDocsMessage2]: 'Dokumente hierher ziehen und ablegen.',
  [T.uploadDocsText]: 'Sie können Dokumente, Audios und Videos hochladen.',
  [T.dropDocsRestriction]: 'Sie können diese Dokumenttypen nicht hochladen.',
  [T.dropDocsPartialRestriction]:
    'Einige ungültige Dokumenttypen wurden abgelehnt',
  [T.uploadDocSuccess]: '{{count}} Dokument erfolgreich hochgeladen.',
  [T.uploadDocsSuccess]: '{{count}} Dokument(e) erfolgreich hochgeladen.',
  [T.uploadStatusBoxMessage]: `{{count}} Dokument(e) wurden erfolgreich hochgeladen. Sie können das Fenster schließen.`,
  [T.uploadDocsWarningMessage]:
    '{{count}} Dokument(e) erfolgreich hochgeladen und {{failed}} sind fehlgeschlagen. Wiederholen...',
  [T.documentsUploadSuccess]: 'Dokumente erfolgreich hochgeladen.',
  [T.failedFetchingDocuments]: 'Dokumente konnten nicht abgerufen werden',
  [T.searchDocuments]: 'Dokumente durchsuchen',
  [T.tagDocuments]: 'Tag-Dokumente',
  [T.docTaggedSuccess]: 'Dokumente erfolgreich getaggt!',
  [T.docTaggedError]: 'Fehler beim Taggen der Dokumente!',
  [T.docTagsUpdatedSuccess]: 'Tags erfolgreich aktualisiert!',
  [T.docTagsUpdatedError]: 'Tags konnten nicht aktualisiert werden!',
  [T.docTagsDeleteSuccess]: 'Tags erfolgreich gelöscht!',
  [T.docTagsDeleteError]: 'Tags konnten nicht gelöscht werden!',
  [T.enterTagName]: 'Geben Sie den Tag-Namen ein.',
  [T.selectTags]: 'Auswählen von Tags',
  [T.selectedTags]: 'Ausgewählte Tags',
  [T.tags]: 'Schlagwörter', //'Tags also available'
  [T.selectUploadTags]:
    'Wählen Sie Tags aus, um sie auf hochgeladene Dokumente anzuwenden',
  [T.maxDocSize]:
    'Die Dokumentenname-Länge von "{{ name }}" überschreitet das maximale Limit von 200 Zeichen.',
  [T.uploaded]: 'Hochgeladen',
  [T.modifiedBy]: 'Geändert von',
  [T.syncedBy]: 'Synchronisiert von',
  [T.syncedOn]: 'Synchronisiert am',
  [T.syncing]: 'Wird gerade synchronisiert...',
  [T.syncingInGridView]:
    'Bitte warten, während der Ordner synchronisiert wird...',
  [T.syncingFailed]: 'Synchronisierungsversuch fehlgeschlagen',
  [T.syncingFileLimitReached]:
    'Maximale Datei-Synchronisierungsgrenze erreicht',
  [T.modifiedOn]: 'Geändert am',
  [T.status]: 'Status',
  [T.documentDeletionFailed]: 'Dokument konnte nicht gelöscht werden',
  [T.attachedFile]: 'Angehängte Dateien',
  [T.excelOnlySelectionTitle]: 'Sie können nur Excel-Dateien auswählen.',
  [T.excelOnlySelectionDescription]:
    'Die Datenanalyse ist nur mit Excel-Dateien möglich. Bitte verwenden Sie ausschließlich Excel-Dateien.',
  [T.attachmentsMoreCount]: '{{count}} weitere',
  [T.clearAllFiles]: 'Alle entfernen',
  [T.maxAttachFiles]:
    'Es sind maximal 5 Dateianhänge erlaubt, deren Gesamtgröße 7 MB nicht überschreiten darf.',
  [T.duplicateFileError]:
    'Datei(en) mit demselben Namen wurden bereits angehängt.',
  [T.documentNotEmptyError]:
    'Das Löschen eines nicht leeren Ordners ist nicht erlaubt.',
  [T.uploadFolder]: 'Ordner hochladen',
  [T.documentDeleteSuccess]: 'Dokument erfolgreich gelöscht.',
  [T.documentsDeleteSuccess]: 'Dokumente erfolgreich gelöscht.',
  [T.documentDeleteConfirmation]:
    'Sind Sie sicher, dass Sie das Dokument löschen möchten?',
  [T.resourceDeleteConfirmation]:
    'Sind Sie sicher, dass Sie die Ressource löschen möchten?',
  [T.collectionDeleteSuccess]: 'Sammlung erfolgreich gelöscht!',
  [T.collectionDeleteConfirmation]:
    'Möchten Sie die Sammlung wirklich löschen?',
  [T.collectionDeletionFailed]: 'Löschen der Sammlung fehlgeschlagen.',
  [T.workspaceDeletionFailed]: 'Löschen des Arbeitsbereichs fehlgeschlagen.',
  [T.workspaceDeleteSuccess]: 'Arbeitsbereich erfolgreich gelöscht!',
  [T.workspaceDeleteConfirmation]:
    'Möchten Sie den Arbeitsbereich wirklich löschen?',
  [T.multipleDocumentDeleteConfirmation]:
    'Sind Sie sicher, dass Sie die ausgewählten Dokumente löschen möchten?',
  [T.genericConfirmation]: 'Sind Sie sich sicher?',
  [T.retrialFailed]:
    'Das Hochladen einiger Dokumente ist fehlgeschlagen. Bitte versuchen Sie es später erneut.',
  [T.deleteDocuments]: 'Dokumente löschen',
  [T.nestedFolderDelete]:
    'Diese Aktion löscht alle ausgewählten Ordner, Unterordner und Dateien. Möchten Sie fortfahren?',
  [T.multipleFilesReprocessConfirmation]:
    'Sind Sie sicher, dass Sie das ausgewählte Dokument erneut verarbeiten möchten?',
  [T.cancelUploadConfirmation]:
    'Möchten Sie das Hochladen der verbleibenden Dateien wirklich abbrechen?',
  [T.retryFailedDocuments]:
    'Versuchen Sie es erneut mit fehlgeschlagenen Dokumente',
  [T.processingFailed]: 'Verarbeitung fehlgeschlagen',
  [T.processLastTransaction]: 'Letzte Transaktion verarbeiten',
  [T.processAllTransactions]: 'alle Transaktionen abwickeln',
  [T.documentDownloadError]:
    'Das Dokument konnte nicht heruntergeladen werden.',
  [T.destinationFolder]: 'Wählen Sie den Zielordner',
  [T.move]: 'Bewegen',
  [T.moveDuplicateError]: 'Datei/Ordner existiert bereits.',
  [T.moveSuccess]: 'Datei/Ordner erfolgreich verschoben.',
  [T.moveFailed]: 'Fehler beim Verschieben von Datei/Ordner.',
  [T.reprocessSuccess]:
    'Dateien erfolgreich für erneute Verarbeitung in die Warteschlange gestellt.',
  [T.reprocessFailed]: 'Fehler beim erneuten Verarbeiten der Dateien.',
  [T.reprocessCountInfo]: 'Erneutes Verarbeiten von {{count}} Dateien.',
  [T.syncSuccess]: 'Ressource erfolgreich in die Warteschlange gestellt.',
  [T.syncFailed]: 'Fehler beim Synchronisieren der Ressource.',
  [T.nameCharacterLengthError]:
    'Der Name sollte zwischen 1 und 200 Zeichen liegen.',
  [T.name]: 'Bezeichnung',
  [T.resourceSharingSuccessMessage]:
    'Ressourcenberechtigungen erfolgreich aktualisiert',
  [T.resourceSharingErrorMessage]: 'Fehler beim Teilen der Ressource.',
  [T.userOrUserGroup]: 'Benutzer oder Benutzergruppe',
  [T.searchForUserOrUserGroup]: 'Suche nach Benutzer oder Benutzergruppe',
  [T.message]: 'Nachricht',
  [T.addMessage]: 'Nachricht hinzufügen',
  [T.sendEmailNotificationToRecipients]:
    'E-Mail-Benachrichtigung an Empfänger senden',
  [T.advanced]: 'Erweitert',
  [T.keepManuallyAssignedRolesOnSubFoldersFiles]:
    'Die bereits zugewiesenen Rollen in Unterordnern/Dateien beibehalten',
  [T.assignRoleToAllSubFoldersFiles]:
    'Rolle allen Unterordnern/Dateien zuweisen',
  [T.assignRoleOnFilesOnly]: 'Rolle nur auf Dateien zuweisen',
  [T.noUserOrUserGroupHasAccessToResource]:
    'Kein Benutzer oder Benutzergruppe hat Zugriff auf die Ressource.',
  [T.noMatchingUsersOrUserGroupsFound]:
    'Keine übereinstimmenden Benutzer oder Benutzergruppen gefunden',
  [T.controllerRoleAssignmentToRegularUserAtWorkspace]:
    'Die ausgewählte Rolle kann nicht regulären Benutzern in Arbeitsbereichen zugewiesen werden.',
  [T.regularUserAssignmentToWorkspace]:
    'Normale Benutzer können nicht als Arbeitsbereichs-Controller ernannt werden. Befördere den Kontotyp von der Benutzerseite aus.',
  [T.contollerAssignmentError]:
    'Nicht berechtigt, Benutzer als Controller in Arbeitsbereichen einzuladen.',
  [T.authorizedToRemoveLowTierAccountTypesOnly]:
    'Berechtigt, Zuweisungen für Kontotypen niedrigerer Stufe zu entfernen.',
  [T.containsCollection]: 'Enthält: {{count}} Sammlungen',
  [T.containsItems]: 'Enthält: {{count}} Elemente',
  [T.createPermissionDenied]: 'Berechtigung zum Erstellen nicht gefunden',
  [T.uploadPermissionDenied]: 'Berechtigung zum Hochladen nicht gefunden',
  [T.createCollection]: 'Erstellen Sie eine Sammlung',
  [T.collectionPlaceholder]:
    'Hinzufügen von Dokumenten innerhalb einer Sammlung, um mit ihnen zu chatten',
  [T.createFolder]: 'Erstellen Sie einen Ordner',
  [T.folderPlaceholder]:
    'Fügen Sie Inhalte hinzu, um Ihr Wissensgebiet aufzubauen',
  [T.assignViewerSubtitle]: 'Abfragen und den Inhalt lesen.',
  [T.assignControllerSubtitle]:
    'Abfragen, bearbeiten und den Zugriff auf den Inhalt verwalten.',
  [T.assignContributorSubtitle]: 'Abfragen, lesen und zum Inhalt hinzufügen.',
  [T.assignAssistantViewer]: 'Chatte mit dem Assistenten',
  [T.assignAssignController]:
    'Mit dem Assistenten chatten und ihn kontrollieren',
  [T.emptyWorkspace]: 'Kein Arbeitsbereich verfügbar',
  [T.emptyCollection]: 'Keine Sammlung verfügbar',
  [T.workspaces]: 'Arbeitsbereiche',
  [T.browseWorkspaceDescription]:
    'Durchsuchen Sie Ihren Arbeitsbereich und wählen Sie die Inhalte aus, die Sie hinzufügen möchten.',
  [T.collections]: 'Sammlungen',
  [T.url]: 'Url',
  [T.webLink]: 'Web Link',
  [T.limitationUrl]: 'Es können maximal 5 Web links hinzugefügt werden',
  [T.urlLong]: 'Web link ist zu lang',
  [T.inValidUrl]: 'Muss eine gültige Web link sein',
  [T.restrictionUrl]: 'Web link nicht erlaubt (Login, Captcha, Auth etc)',
  [T.urlRequired]: 'Web link ist erforderlich',
  [T.duplicateUrls]: 'Doppelte Web links können nicht hinzugefügt werden',
  [T.questionnaireWebLinkPlaceholder]: 'Geben Sie eine Web link ein',
  [T.extensionNotAllowed]: 'Dateien wie "{{disallowedExt}}" sind nicht erlaubt',
  [T.folderName]: 'Geben Sie den Namen für den Ordner ein',
  [T.licenseLimitReached]: 'Lizenzlimit erreicht',
  [T.licenseExpired]: 'Lizenz abgelaufen!',
  [T.licenseExpiredMessage]:
    'Ihre Lizenz ist abgelaufen. Bitte wenden Sie sich an den Administrator, um eine Verlängerung oder Erneuerung zu beantragen.',

  [T.author]: 'Autor',
  [T.importExternalDocs]: 'Import aus externer Anwendung',
  [T.documentDetailsDisclaimer]: `Die von der KI generierte Dokumentübersicht kann Fehler enthalten.`,
  [T.disableImportMessage]:
    'Das Importieren aus externen Anwendungen ist in "{{workspaceName}}" deaktiviert',
  [T.importNotAllowed]:
    'Import ist im öffentlichen/privaten Arbeitsbereich nicht erlaubt',

  [T.workspace]: 'Arbeitsbereich',
  [T.file]: 'Datei',
  [T.collection]: 'Sammlung',
  [T.folder]: 'Ordner',
  [T.folders]: 'Ordner',
  [T.reasonNotAvailable]: 'Grund nicht verfügbar',
  [T.languageError]:
    'Die Sprache wird bei der Bearbeitung nicht unterstützt. Die Sprachen Deutsch, Englisch und Italienisch werden derzeit für die Bearbeitung unterstützt.',
  [T.rateLimitError]:
    'AI-Modell-Ratengrenze erreicht. Bitte bearbeiten Sie das Dokument später erneut.',
  [T.permissionsError]:
    'Sie haben keinen Vollzugriffsrecht auf diese Ressource.',
  [T.unsupportedFiles]: 'Die Sammlung enthält nicht unterstützte Dateien',
  [T.maxLengthError]:
    'Die Kontextgrenze des AI-Modells wurde bei der Verarbeitung erreicht.',
  [T.noTextFoundError]:
    'Das Dokument scheint beschädigt zu sein. Bitte laden Sie ein gültiges Dokument hoch.',

  // Chat
  [T.Chat]: 'Chat',
  [T.chat]: 'Chat',
  [T.chats]: 'Chats',
  [T.chatsUntranslated]: 'Chats',
  [T.createNewChat]: 'Neuer Chat',
  [T.send]: 'Schicken',
  [T.queryPlaceholder]: 'Fragen Sie ',
  [T.queryPlaceholderWorldKnowledge]: `Verwenden Sie ‚/‘ für hilfreiche Befehle.`,
  [T.chatConfigurations]: 'Chat-Konfiguration',
  [T.parameterDialogTitle]: 'Parameter',
  [T.parameterDialogSubtitle]:
    'Aktualisieren Sie Chat-Parameter, um effizient nach Dokumenten zu suchen',
  [T.updateParameters]: 'Parameter aktualisieren',
  [T.cancel]: 'Abbrechen',
  [T.submit]: 'Senden',
  [T.save]: 'Speichern',
  [T.confirm]: 'Bestätigen',
  [T.add]: 'Hinzufügen',
  [T.previouslyAdded]: 'Bereits hinzugefügt',
  [T.parametersUpdateSuccess]: 'Chat-Parameter erfolgreich aktualisiert!',
  [T.parametersUpdateError]: 'Fehler beim Aktualisieren der Chat-Parameter!',
  [T.temperature]: 'Temperatur',
  [T.tokens]: 'Maximale Länge (Token)',
  [T.sequences]: 'Stop-Sequenzen',
  [T.probabilities]: 'Top-Wahrscheinlichkeiten',
  [T.frequency]: 'Frequenzstrafe',
  [T.presence]: 'Präsenzstrafe',
  [T.chatRenameSuccess]: 'Chat erfolgreich umbenannt!',
  [T.chatRenameFailed]: 'Fehler beim Umbenennen des Chats!',
  [T.chatDeleteSuccess]: 'Chat erfolgreich gelöscht!',
  [T.chatDeleteFailed]: 'Fehler beim Löschen des Chats!',
  [T.generatingResponse]: 'Generiere Antwort',
  [T.executing]: 'Wird ausgeführt',
  [T.executingPlan]: 'Plan wird ausgeführt',
  [T.errorGeneratingResponse]:
    'Konnte keine Antwort generieren! Bitte versuchen Sie es erneut.',
  [T.chatGptSlogan]:
    'Unterstützt beim Schreiben, Programmieren und Recherchieren.',
  [T.empowerGptSlogan]: 'Stellen Sie Ihre Fragen in der Wissensdatenbank.',
  [T.empowerGptKnowledgeSwitchSlogan]:
    'Durchsuchen Sie alle Ihre Unternehmensdaten',
  [T.chatGptKnowledgeSwitchSlogan]:
    'Durchsuchen Sie das gesamte Internet oder schreiben Sie mit LLM-geschulten Daten.',
  [T.messagesLoadingFailed]:
    'Fehler beim Abrufen der Nachrichten. Bitte versuchen Sie es erneut!',
  [T.responseFailedMessage]:
    'Es ist ein Fehler bei der Generierung einer Antwort aufgetreten.',
  [T.responseStreamingFailedMessage]:
    'Es gab einen Fehler in der Streaming-Antwort. Bitte aktualisieren Sie die Seite.',
  [T.regenerateResponse]: 'Antwort erneut generieren',
  [T.errorAddingReaction]: 'Fehler beim Hinzufügen der Reaktion.',
  [T.errorUpdatingChatContext]: 'Fehler beim Aktualisieren des Chat-Kontexts.',
  [T.chatDeleteConfirmation]:
    'Sind Sie sicher, dass Sie den Chat löschen möchten?',
  [T.samplePrompt1]:
    'Welche Prüfungen sollte ich vor der Installation der Etaprime L-Pumpe durchführen?',
  [T.samplePrompt2]:
    'Welcher zulässige Viskositätsbereich hat Rohöl für das L27/38S Kraftwerk?',
  [T.samplePrompt4]:
    'Richtlinien für die Erstellung einer Pivot-Tabelle in Microsoft Excel.',
  [T.samplePrompt5]:
    'Tipps zur Zusammenarbeit und Kommunikation in Remote-Teams.',
  [T.samplePrompt7]:
    'Vorschläge für Optimierungsstrategien in der Lieferkette.',
  [T.samplePrompt8]:
    'Best Practices zur Identifizierung von Unternehmensrisiken.',
  [T.capabilities1]:
    'Erhalte Antworten auf deine Fragen ausschließlich basierend auf den hochgeladenen Dokumenten.',
  [T.capabilities2]:
    'Behält den Kontext der vorherigen Fragen innerhalb eines Chats bei.',
  [T.limitations1]:
    'Kann Schwierigkeiten haben, Attribute zu vergleichen, die über die Datenbank verteilt sind.',
  [T.limitations2]:
    'Wissen beschränkt auf den Umfang der hochgeladenen Dokumente.',
  [T.stickToDocs]: 'Begrenzt die Suche auf im Viewer geöffnete Dokumente.',
  [T.includeChatHistory]:
    'Klicken Sie, um die Chat-Kontextverbindung zu trennen.',
  [T.excludeChatHisory]:
    'Klicken Sie, um den Kontext der letzten Abfrage erneut herzustellen.',
  [T.resourceUnavailable]: 'Ressource nicht verfügbar',
  [T.referenceDocumentDeleted]: 'Referenzdokument gelöscht',
  [T.modelBeingUsed]: 'Dieses Modell wird in der App verwendet',
  [T.stickDocMessage]:
    'Begrenzt die Suche auf im Viewer geöffnete Dokumente. (Keine Dokumente geöffnet)',

  [T.disclaimerChatgpt]:
    'Das KI-Modell kann Fehler machen, bitte prüfen Sie dies anhand der angegebenen Zitate.',

  [T.copy]: 'Kopieren',
  [T.copied]: 'Kopiert',
  [T.errorCopyingResponse]: 'Fehler beim Kopieren der Antwort',
  [T.contentFilteringErrorMsg]: `Die Antwort wurde gefiltert, weil die Eingabeaufforderung die Azure-Richtlinie zur Inhaltsverwaltung auslöst. Bitte ändern Sie Ihren Prompt und versuchen Sie es erneut.`,
  [T.generalErrorMsg]: `Die KI konnte nicht rechtzeitig eine Antwort generieren. Versuche es erneut oder vereinfache deine Anfrage.`,
  [T.shareChatTitle]: `Diesen Chat teilen`,
  [T.shareChatText]: `EmpowerGPT-Nutzer mit dem Link`,
  [T.shareChatDisclaimer]:
    'Alle Nachrichten, die Sie nach der Freigabe hinzufügen, bleiben privat.',
  [T.copyLink]: 'Link kopieren',
  [T.errorCopyingLink]: 'Fehler beim Kopieren des Links',
  [T.sharedBy]: 'Geteilt von: ',
  [T.chatInitiationError]: `Konnte keine Anfrage initiieren. Bitte überprüfen Sie, ob die Modellkonfiguration korrekt ist.`,
  [T.unsupportedLanguage]: `Die als {{detectedLanguage}} erkannte Eingabesprache wird derzeit für den Enterprise Knowledge Chat nicht unterstützt. Bitte wechseln Sie zu einer unterstützten Sprache, die derzeit Englisch, Deutsch und Italienisch umfasst.\nWenn Sie glauben, dass diese Erkennung falsch ist, geben Sie bitte einen längeren Satz ein oder formulieren Sie Ihre Eingabe neu.`,
  [T.chatContextLengthExceed]:
    'Die eingegebene Nachricht überschreitet die zulässige Länge für das ausgewählte KI-Modell. Bitte kürzen Sie die Nachricht und versuchen Sie es erneut.',
  [T.contentPolicyViolation]:
    'Das Bild, das Sie erstellen möchten, verstößt gegen unsere Inhaltsrichtlinien. Bitte versuchen Sie es erneut.',
  [T.rateLimit]:
    'Ihre Organisation hat das Limit für die Anzahl der Anfragen pro Minute erreicht. Bitte versuchen Sie es später noch einmal.',
  [T.webSearchTooltip]: 'Durchsucht das Internet nach Antworten',
  [T.webSearchDescription]: 'Suchen Sie im Internet nach Ergebnissen',
  [T.canvasDescription]: 'Schreiben und zusammenarbeiten',
  [T.searchPlusDescription]: 'Fortschrittliche KI für intelligente Antworten',
  [T.searchPlusLimitReached]:
    'Sie haben das Search+-Abfragelimit Ihres Plans erreicht.',
  [T.tools]: 'Werkzeuge',
  [T.beta]: 'Beta',

  [T.stickToDoc]: 'An die Dokumente halten',
  [T.webSearch]: 'Suche im Internet',
  [T.imageGeneration]: 'Bilderzeugung',
  [T.imageGenerationDescription]: 'Bilder aus Textbeschreibungen generieren',
  [T.nanoBananaDescription]:
    'Schnelles und ressourcenschonendes Generieren von Bildern',
  [T.generatingImage]: 'Bild generieren',
  [T.imageGenerated]: 'Bild erfolgreich generiert',
  [T.generatedImage]: 'Erzeugtes Bild',
  [T.failedToLoadImage]: 'Bild konnte nicht geladen werden',
  [T.imageCopied]: 'Bild kopiert',
  [T.failedToCopyImage]: 'Bild konnte nicht kopiert werden',
  [T.failedToDownloadImage]: 'Bild konnte nicht heruntergeladen werden',
  [T.clickToZoomIn]: 'Zum Vergrößern anklicken',
  [T.clickToZoomOut]: 'Zum Verkleinern klicken',
  [T.copyImage]: 'Kopieren',
  [T.downloadImage]: 'Herunterladen',
  [T.maximizeImage]: 'Maximieren',
  [T.noAuthorizedFilesForChat]:
    'Entschuldigung, keine Dokumente gegen die ausgewählte Ressource sind im Chat verfügbar. Bitte stellen Sie sicher, dass sie nicht leer ist und verarbeitete Dokumente enthält, die für Sie zugänglich sind.',
  [T.assistantDeletedError]: 'Assistent wurde gelöscht',
  // workspace
  [T.workspaceName]: 'Arbeitsbereichs name',
  [T.collectionName]: 'Sammlungs name',
  [T.workspaceColor]: 'Arbeitsbereichsfarbe',
  [T.workspaceController]: 'Arbeitsbereichs-Controller',
  [T.createWorkspace]: 'Arbeitsbereich erstellen',
  [T.updateWorkspace]: 'Arbeitsbereich aktualisieren',
  [T.updateName]: 'Aktualisieren Name',
  [T.newWorkspace]: 'Neuer Arbeitsbereich',
  [T.newCollection]: 'Neue Sammlung',
  [T.newFolder]: 'Neuer Ordner',
  [T.documentUpdateConfirmation]:
    'Arbeitsbereich umbenennen und Hintergrundfarbe aktualisieren',
  [T.backgroundColor]: 'Hintergrundfarbe',
  [T.updatesOn]: 'Aktualisierung',
  [T.updatedBy]: 'Aktualisiert von',
  [T.workspaceUpdateSuccess]: 'Arbeitsbereich erfolgreich aktualisiert!',
  [T.workspaceUpdateFailed]: 'Fehler beim Aktualisieren des Arbeitsbereichs!',
  [T.sortBy]: 'Sortiere nach',
  [T.sort]: 'Sortieren',
  [T.ascending]: 'Aufsteigend',
  [T.descending]: 'Absteigend',
  [T.lastUpdated]: 'Letzte Aktualisierung',
  [T.ago]: 'vor',
  [T.day]: 'Tag',
  [T.days]: 'Tage',
  [T.hour]: 'Stunde',
  [T.hours]: 'Std.',
  [T.min]: 'Minute',
  [T.mins]: 'Protokoll',
  [T.sec]: 'zweite',
  [T.secs]: 'Sekunden',
  [T.publicDisclaimer]:
    'Öffentliche Inhalte sind für alle Benutzer zugänglich.',
  [T.privateDisclaimer]:
    'Die Inhalte in Mein Arbeitsbereich sind nur für Sie zugänglich.',
  [T.moreActions]: 'Weitere Aktionen',
  [T.addFilesDescription]: 'Fügen Sie Dateien für gezielte Antworten hinzu',
  [T.selectFile]: 'Datei auswählen',
  [T.documentsInFocus]: 'Dokumente im Fokus',
  [T.resourcesInFocus]: 'Ressourcen im Fokus',
  [T.resourcesInFocusDescription]:
    'Dokumente im Fokus aus der Unternehmenswissensdatenbank.',
  [T.oneResourceInFocus]: '1 Ressource',
  [T.resourcesInFocusCount]: '{{count}} Ressourcen',
  [T.addMoreDocuments]: 'Weitere Dokumente hinzufügen',
  [T.advancedSearchButtonText]: 'Zur erweiterten Suche wechseln',
  [T.showInFolder]: 'Im Ordner anzeigen',
  [T.findDocumentsText]:
    'Geben Sie ein, um Dokumente in Arbeitsbereichen zu finden',
  [T.noResultsFound]: 'Keine Ergebnisse gefunden',
  [T.tryAdjustingFilters]:
    'Keine Elemente entsprechen den ausgewählten Filtern. Passen Sie sie an oder setzen Sie sie zurück.',
  [T.inputLimitReachedError]:
    'Die Suchphrase darf nicht länger als {{inputLimit}} Zeichen sein.',
  [T.startChatOnSelectedFiles]: 'Chat über ausgewählte Dateien starten',
  [T.addSelectedFilesToChat]: 'Ausgewählte Dateien zum Chat hinzufügen',
  [T.addSelectedFilesToAssistant]:
    'Ausgewählte Dateien zum Assistenten hinzufügen',
  [T.addSelectedFilesToMiniExpertDataset]:
    'Hinzufügen ausgewählter Dateien zu Ihrem Dataset',
  [T.noResultsTitle]: 'Keine Ergebnisse für',
  [T.noResultsDescription]:
    'Versuchen Sie eine andere Suchphrase, überprüfen Sie auf Tippfehler oder ändern Sie aktive Filter.',
  [T.advancedSearch]: 'Erweiterte Suche',
  [T.advancedSearchDefaultDescription]:
    'Fügen Sie ganz einfach Dateien und Ordner hinzu, indem Sie nach einem beliebigen Schlüsselwort aus dem Dokument suchen.',
  [T.addedFileAndSelectedMoreToAddInSearch]:
    'Sie haben {{addedCount}} Datei oder Ordner hinzugefügt, die als „bereits hinzugefügt“ markiert ist, und {{newCount}} weitere zum Hinzufügen ausgewählt.',
  [T.addedFilesAndSelectedMoreToAddInSearch]:
    'Sie haben {{addedCount}} Dateien und Ordner hinzugefügt, die als „bereits hinzugefügt“ markiert sind, und {{newCount}} weitere zum Hinzufügen ausgewählt.',
  [T.advancedSearchTitle]: 'KI-gestützte Suche in Ihrem Unternehmenswissen',
  [T.advancedSearchDescription]:
    'Finden Sie relevante Dokumente und Informationen in zugänglichen Inhalten in Workspaces.',
  [T.recentUploads]: 'Zuletzt hochgeladen',
  [T.noRecentUploads]: 'Sie haben keine kürzlich hochgeladenen Dateien.',
  [T.uploadRecentFilesPrompt]:
    'Laden Sie Dateien in Ihren Arbeitsbereich hoch oder verwenden Sie die Suchleiste und Filter, um Dateien oder Dokumente zu finden.',
  [T.readMore]: 'Mehr lesen',
  [T.readLess]: 'Weniger lesen',
  [T.foundResults]: '{{count}} Ergebnisse gefunden',
  [T.filterByConnector]: 'Nach Connector filtern',
  [T.allSources]: 'Alle Quellen',
  [T.fileDeletedOrInaccessibleDesc]:
    'wurde gelöscht oder ist für Sie nicht mehr zugänglich.',
  [T.imageAnalysisNotSupported]: `Das ausgewählte Modell unterstützt keine Bilder. Bitte wechseln Sie zu einem Modell, das die Bildanalyse unterstützt`,
  [T.chatResponseTimeoutError]:
    'AI Model hat zu lange gebraucht, um Ihre Anfrage zu beantworten. Bitte versuchen Sie es in Kürze erneut.',
  [T.chatModelUsageLimitReachedMessage]:
    'Du hast das Nutzungslimit für KI-Modelle in der Stufe {{modelTier}} erreicht. Wechsle zu einem anderen Modell, bis das Nutzungslimit für diese Stufe nach {{availableAt}} zurückgesetzt wird.',
  [T.source]: 'Quelle',
  [T.type]: 'Typ',

  // Speech-to-text err
  [T.microphoneAccessError]:
    'Zugriff auf das Mikrofon ist erforderlich. Bitte erlauben Sie ihn in Ihrem Browser.',
  [T.noSpeechRecognized]: 'Keine Sprache erkannt.',
  [T.creditUsageError]: 'Fehler bei der Berechnung des Credit-Verbrauchs',
  [T.exemptedTokens]:
    'Sie sind von der Erfassung des Token-Verbrauchs ausgenommen.',
  [T.maxRecordingTimeExceeded]: `Maximale Aufnahmezeit überschritten.`,
  [T.stopMicError]: `Fehler beim Stoppen des Mikrofons.`,
  [T.tooLongSilence]: 'Zu lange Stille erkannt',
  [T.inputLanguageMsg]: 'Eingabesprache verstehen',

  [T.default]: 'Standard',
  [T.markAsDefault]: 'Als Standard festlegen',
  [T.defaultModelFallback]:
    'Das Standardmodell {{prevModel}} ist nicht mehr verfügbar. Stattdessen wurde {{newModel}} als Standardmodell für neue Chats festgelegt.',
  [T.defaultModelAlreadySelected]:
    '{{modelName}} ist bereits als Standardmodell ausgewählt.',
  [T.defaultModelUpdated]: 'Standardmodell erfolgreich festgelegt!',
  [T.defaultModelSetError]: 'Fehler beim Aktualisieren des Standardmodells!',
  [T.defaultModelUpdateError]: 'Fehler beim Aktualisieren des Standardmodells',
  [T.errorGettingModel]: 'Fehler beim Abrufen der Modelldetails',
  [T.errorConfiguringModel]: 'Fehler beim Konfigurieren des Modells',
  [T.errorConfiguringChatModel]:
    'Fehler beim Konfigurieren des Standard-Chatmodells',
  [T.errorConfiguringModelProperties]:
    'Fehler beim Konfigurieren der Modelleigenschaften',

  // Chat Steps
  [T.understandingInput]: `Verstehen der Eingabe`,
  [T.thinking]: `Denken`,
  [T.searchingContent]: `Durchsuchen von Arbeitsbereichen`,
  [T.searchingEnterpriseKnowledge]:
    'Durchsuchen des Unternehmenswissens nach relevanten Informationen',
  [T.listingRelevantDocuments]: 'Relevante Dokumente werden aufgelistet',
  [T.retrievingWebpageContent]: 'Webseiteninhalt wird abgerufen',
  [T.searchingWeb]: `Durchsuchen des Webs`,
  [T.searchingAttachments]: 'Suche in den Anhängen',
  [T.attachedDocuments]: 'Dokument(e)',
  [T.link]: `link`,
  [T.generatingResponseUsingReceivedExcerpts]:
    'Antwort wird anhand der abgerufenen Auszüge generiert',
  [T.excerptsFrom]: `Auszüge aus`,
  [T.contentSearched]: 'Gesuchtes Unternehmenswissen',
  [T.webSearched]: 'Durchsuchtes Web',
  [T.searchedAttachments]: 'Gesucht in Anlage(n)',
  [T.joiningResponseFromPreviousTasks]:
    'Antwort wird aus vorherigen Aufgaben zusammengeführt',

  // Chat feedback ...
  [T.feedbackTitle]: 'Zusätzliches Feedback geben',
  [T.feedback1]: 'Die Antwort zitiert das falsche Dokument.',
  [T.feedback2]:
    'Die Antwort ist außerhalb des Geltungsbereichs der Dokumente.',
  [T.feedback3]: 'Die Antwort ist schädlich/unsicher.',
  [T.feedback4]: 'Die Antwort ist nicht hilfreich.',
  [T.submitFeedback]: 'Feedback senden',
  [T.sources]: 'Quellen',
  [T.feedbackCommentPlaceholder]:
    'Was ist mit der Antwort schiefgelaufen? Wie kann sie verbessert werden?',
  [T.feedbackValidationError]: 'Bitte wählen Sie mindestens 1 Option aus.',

  // Context window and usage
  [T.contextWindowMenuTitle]: 'Kontextfenster und Nutzung',
  [T.contextWindow]: 'Kontextfenster',
  [T.usageThisMonth]: 'Nutzung diesen Monat',
  [T.freeSpace]: 'Freier Platz',
  [T.contextWindowSummary]: '{{used}} / {{total}} Token für {{model}}',
  [T.tokensWithPercentage]: '{{tokens}} Tok · {{percentage}}',
  [T.labelWithCount]: '{{label}} ({{count}})',
  [T.contextWindowTooltipContext]:
    'Kontext: {{percentage}} · {{used}} / {{total}}',
  [T.systemPrompt]: 'System-Prompt',
  [T.workspaceFileRetrieval]: 'Workspace-Dateiabruf',
  [T.memory]: 'Speicher',
  [T.systemTools]: 'Systemwerkzeuge',
  [T.tokensUsedOfTotal]: '{{used}} / {{total}} Token',

  [T.createAWorkspace]: 'Erstellen Sie einen Arbeitsbereich',
  [T.newWorkspaceDescription]:
    'Erstellen Sie eine separate Wissensbasis für jede Abteilung',
  [T.createCollection]: 'Erstellen Sie eine Sammlung',

  //Users/Roles
  [T.userName]: 'Username',
  [T.rolesTitle]: 'Rollen',
  [T.role]: 'Rolle',
  [T.permissions]: 'Berechtigungen',
  [T.users]: 'Benutzer',
  [T.contentRole]: 'Ressourcenrolle',
  [T.userRole]: 'Benutzerrolle',
  [T.userRoles]: 'Benutzerrollen',
  [T.userRolesDescription]:
    'Wiederverwendbare Funktionszugriffssets, die Sie Benutzern und Benutzergruppen zuweisen können',
  [T.noOfEnabledFeature]: 'Anzahl aktivierter Berechtigungen',
  [T.assignedTo]: 'Zugewiesen an',
  [T.createUserRole]: 'Benutzerrolle erstellen',
  [T.userRoleNamePlaceholder]: 'z. B. Standardberechtigungen',
  [T.userRoleDescriptionPlaceholder]: 'Beschreibung angeben',
  [T.userRoleCreateRequirementsTooltip]:
    'Name und mindestens eine Berechtigung sind erforderlich, um eine Benutzerrolle zu erstellen',
  [T.corePermissions]: 'Kernberechtigungen.',
  [T.corePermissionsDescription]:
    'Aktivieren Sie diese zuerst — Funktionen sind davon abhängig',
  [T.enabledCountBadge]: '{{enabled}}/{{total}} aktiviert',
  [T.editUserRole]: 'Benutzerrolle bearbeiten',
  [T.viewUserRole]: 'Benutzerrolle anzeigen',
  [T.assignedToRoleTitle]: 'Zugewiesen an "{{name}}"',
  [T.deleteUserRoleConfirmation]:
    'Dadurch wird die Benutzerrolle "{{name}}" endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  [T.assignedUsersCountLabel]: '{{count}} Benutzer zugewiesen',
  [T.assignedUserGroupsCountLabel]: '{{count}} Benutzergruppe zugewiesen',
  [T.members]: 'Mitglieder',
  [T.searchUsersOrGroupsPlaceholder]: 'Benutzer oder Gruppen suchen...',
  [T.assignUsersRowTitle]: 'Benutzer zuweisen',
  [T.assignUsersRowDescription]:
    'Sie werden zum Benutzerbildschirm weitergeleitet',
  [T.assignUserGroupsRowTitle]: 'Benutzergruppen zuweisen',
  [T.assignUserGroupsRowDescription]:
    'Sie werden zum Benutzergruppenbildschirm weitergeleitet',
  [T.expandAll]: 'Alle erweitern',
  [T.collapseAll]: 'Alle einklappen',
  [T.searchPermissionsPlaceholder]:
    'Bereiche, Funktionen, Berechtigungen durchsuchen',
  [T.discardChanges]: 'Änderungen verwerfen',
  [T.saveChanges]: 'Änderungen speichern',
  [T.needsCapabilityPrefix]: 'Erfordert',
  [T.coreCapabilityLabelPrefix]: 'Kern',

  // Benutzerrollenvorlage – Fähigkeitskontrollen
  [T.localFileUploads]: 'Lokale Datei-Uploads',
  [T.attachmentsCapability]: 'Anhänge',
  [T.enterpriseKnowledgeCapabilityDescription]:
    'Container für Unternehmenswissen — erforderlich für Chat-EK, Smart Meet, Dokumentenanalyst und EK-Funktionen überall — eng mit Workspace verbunden.',
  [T.localFileUploadsCapabilityDescription]:
    'Lokaler Datei-Upload ist eine Funktion, mit der Benutzer Dateien direkt von ihrem Gerät hochladen können.',
  [T.attachmentsCapabilityDescription]:
    'Anhänge ist eine Funktion, mit der Benutzer im Chat Dateien direkt von ihrem Gerät hochladen können.',
  [T.worldKnowledgeCapabilityDescription]:
    'Konversations-KI mit aktuellem Weltwissen aus dem Internet. Vollständig unabhängig von Arbeitsbereichen.',

  // Benutzerrollenvorlage – Funktionen/Unterfunktionen
  [T.integrationsFeature]: 'Integrationen',
  [T.assistantChatSubFeature]: 'Assistenten-Chat',
  [T.buildAssistantsSubFeature]: 'Assistenten erstellen',
  [T.manageAssistantsSubFeature]: 'Assistenten verwalten',
  [T.projectChatSubFeature]: 'Projekt-Chat',
  [T.manageProjectSubFeature]: 'Projekt verwalten',
  [T.manageWorkflowSubFeature]: 'Workflow verwalten',
  [T.sharePointSubFeature]: 'SharePoint',
  [T.oneDriveSubFeature]: 'OneDrive',
  [T.confluenceSubFeature]: 'Confluence',
  [T.googleDriveSubFeature]: 'Google Drive',

  // Benutzerrollenvorlage – Berechtigungen
  [T.enableFeaturePermission]: 'Funktion aktivieren',
  [T.enableSubfeaturePermission]: 'Unterfunktion aktivieren',
  [T.uploadLocalFilesPermission]: 'Lokale Dateien hochladen',
  [T.modelComparisonPermission]: 'Modellvergleich',
  [T.manageProjectsPermission]: 'Projekte verwalten',
  [T.manageWorkflowsPermission]: 'Workflows verwalten',
  [T.runWorkflowsPermission]: 'Workflows ausführen',
  [T.versionControlPermission]: 'Versionskontrolle',
  [T.shareWorkflowsPermission]: 'Workflows teilen',
  [T.codeExecutionPermission]: 'Codeausführung',
  [T.attachmentsPermission]: 'Anhänge',
  [T.attachmentsPermissionDescription]:
    'Vorhandene Unternehmensinhalte durchsuchen und anhängen.',
  [T.projectSourcePermission]: 'Projektquelle',
  [T.disableAllPermissions]: 'Alle deaktivieren',
  [T.create]: 'Erstellen',
  [T.update]: 'Aktualisieren',
  [T.new]: 'Neu',
  [T.edit]: 'Bearbeiten',
  [T.editName]: 'Namen bearbeiten',
  [T.delete]: 'Löschen',
  [T.tag]: 'Schlagwort',
  [T.upload]: 'hochladen',
  [T.createRole]: 'Rolle erstellen',
  [T.updateRole]: 'Rolle aktualisieren',
  [T.createUser]: 'Benutzer erstellen',
  [T.updateUser]: 'Benutzer aktualisieren',
  [T.searchRole]: 'Benutzerrolle suchen',
  [T.availableRole]: 'Verfügbare Benutzerrolle',
  [T.assignedRole]: 'Zugewiesene Benutzerrolle',
  [T.confirmDeleteRole]:
    'Sind Sie sicher, dass Sie diese Rolle löschen möchten?',
  [T.confirmDeleteUser]:
    'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
  [T.confirmDeleteYourAccount]:
    'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
  [T.confirmDeleteMultipleUsers]:
    'Sind Sie sicher, dass Sie diese Benutzer löschen möchten?',
  [T.roleDeleteSuccess]: 'Rolle erfolgreich gelöscht!',
  [T.deleteRow]: 'Zeile löschen',
  [T.deleteChat]: 'Chat löschen',
  [T.confirmDeleteChat]:
    'Sind Sie sicher, dass Sie diesen Chat löschen möchten?',
  [T.yesDeleteIt]: 'Ja, löschen',
  [T.randomError]: 'Ein Fehler ist aufgetreten!',
  [T.noRecordFound]: 'Kein Eintrag gefunden!',
  [T.errorDeletingRole]: 'Fehler beim Löschen der Rolle.',
  [T.roleUpdateSuccess]: 'Rolle erfolgreich aktualisiert!',
  [T.roleUpdateError]: 'Fehler beim Aktualisieren der Rolle!',
  [T.roleCreateSuccess]: 'Rolle erfolgreich erstellt!',
  [T.roleCreateError]: 'Fehler beim Erstellen der Rolle!',
  [T.userRoleTemplateFetchError]:
    'Fehler beim Abrufen der Benutzerrollenvorlage!',
  [T.userRolesFetchError]: 'Fehler beim Abrufen der Benutzerrollen!',
  [T.userRoleCreateSuccess]: 'Benutzerrolle erfolgreich erstellt!',
  [T.userRoleCreateError]: 'Fehler beim Erstellen der Benutzerrolle!',
  [T.userRoleAssignedCannotDelete]:
    'Diese Rolle ist mindestens einem Benutzer oder einer Gruppe zugewiesen. Bitte heben Sie die Zuweisung der Rolle auf, bevor Sie sie löschen.',
  [T.userRoleAlreadyExists]:
    'Eine Benutzerrolle mit diesem Namen existiert bereits.',
  [T.userInviteError]: 'Fehler beim Einladen von Benutzern.',
  [T.userInviteSuccess]:
    'Eine E-Mail-Einladung wurde an eingeladene Benutzer gesendet.',
  [T.userUpdateSuccess]: 'Benutzer erfolgreich aktualisiert!',
  [T.userUpdateFailed]: 'Fehler beim Aktualisieren des Benutzers.',
  [T.userDeleteSuccess]: 'Benutzer erfolgreich gelöscht!',
  [T.usersDeleteSuccess]: 'Benutzer erfolgreich gelöscht!',
  [T.userDeleteError]:
    'Benutzer konnte nicht gelöscht werden. Bitte versuchen Sie es erneut!',
  [T.duplicateUserError]: 'E-Mail ist bereits vergeben',
  [T.duplicateFolderError]: 'Datei/Ordner existiert bereits.',
  [T.duplicateCollectionError]: 'Die Sammlung existiert bereits.',
  [T.duplicateWorkspaceError]: 'Der Arbeitsbereich existiert bereits.',
  [T.renameSuccess]: 'Erfolgreich umbenannt!',
  [T.rename]: 'Umbenennen',
  [T.renameFailed]: 'Fehler beim Umbenennen!',
  [T.emptySpaceError]: 'Der Name darf nicht leer sein!',
  [T.folderCreateSuccess]: 'Ordner erfolgreich erstellt!',
  [T.folderAndUrlSuccess]:
    'Ordner erfolgreich erstellt! Die Weblink-Erstellung läuft.',
  [T.workspaceCreateSuccess]: 'Arbeitsbereich erfolgreich erstellt!',
  [T.collectionCreateSuccess]: 'Sammlung erfolgreich erstellt!',
  [T.folderCreateError]: 'Fehler beim Erstelen der Ressource!',
  [T.folderCreateSuccessAccesError]:
    'Ordner erfolgreich erstellt! Aktualisierung der Zugriffsberechtigungen fehlgeschlagen.',
  [T.folderUpdateSuccessAccessError]:
    'Ordner erfolgreich aktualisiert! Aktualisierung der Zugriffsberechtigungen fehlgeschlagen.',
  [T.enterRoleName]: 'Rollenname eingeben',
  [T.enterRoleDescription]: 'Rollenbeschreibung eingeben',
  [T.roleName]: 'Rollenname',
  [T.invalidRoleName]: 'Ungültiger Rollenname',
  [T.fullName]: 'Vollständiger Name',
  [T.enterFullName]: 'Vollständigen Namen eingeben',
  [T.enterEmailAddress]: 'E-Mail Adresse eingeben',
  [T.enterUserName]: 'Benutzernamen eingeben',
  [T.moveSelectedRight]: 'Ausgewählte nach rechts bewegen',
  [T.moveSelectedLeft]: 'Ausgewählte nach links bewegen',
  [T.applyTags]: 'Tags anwenden.',
  [T.dataLibrary]: 'Datenbibliothek',
  [T.dataLibraryResourceNotFoundTitle]:
    'Wir können diesen Inhalt nicht anzeigen',
  [T.dataLibraryResourceNotFoundDescription]:
    'Sie haben keine Berechtigung, ihn anzuzeigen. Wenden Sie sich an Ihren Administrator, um Zugang anzufragen.',
  [T.dataLibraryBackToWorkspace]: 'Zurück zum Arbeitsbereich',
  [T.language]: 'Sprache',
  [T.documentsStatus]: 'Status der hochgeladenen Dokumente',
  [T.statusFailedText]: 'Status: Fehlgeschlage',
  [T.statusUploadedText]: 'Status: Hochgeladen',
  [T.startDate]: 'Startdatum',
  [T.endDate]: 'Enddatum',
  [T.selectStatus]: 'Status auswählen',
  [T.document]: 'Dokument',
  [T.pages]: 'Seiten',
  [T.addARole]: 'Fügen Sie eine Rolle hinzu',
  [T.editRole]: 'Rolle bearbeiten',
  [T.organizationAdminSubtitle]:
    'Kann Arbeitsbereiche erstellen und zuweisen, Admins/Benutzer einladen, benutzerdefinierte Rollen hinzufügen.',
  [T.organizationOwnerSubtitle]:
    'Vollzugriff auf alle Arbeitsbereiche zusätzlich zu den Administratorrechten der Organisation.',
  [T.workspaceAdminSubtitle]:
    'Kann komplette Arbeitsbereiche verwalten, Benutzergruppen und reguläre Benutzer hinzufügen.',
  [T.regularUserSubtitle]:
    'Kann auf zugängliche Dokumente zugreifen, Inhalte hochladen und mit anderen Benutzern teilen.',

  // File Statuses
  [T.F_S_UP]: 'In Bearbeitung',
  [T.F_S_RE]: 'Wieder versuchend',
  [T.F_S_PR]: 'Verarbeitet',
  [T.F_S_US]: 'Nicht unterstützte',
  [T.F_S_LLR]: 'Lizenzlimit erreicht',
  [T.F_S_WF]: 'Warten auf Datei',
  [T.moveSelectedRight]: 'Ausgewählte nach rechts bewegen',
  [T.moveSelectedLeft]: 'Ausgewählte nach links bewegen',
  [T.workSpaceDocumentsDropError]:
    'Fügen Sie eine Sammlung hinzu, um die Dokumente darin hochzuladen.',
  // User Groups
  [T.failedToDeleteUserGroups]:
    'Benutzergruppen konnten nicht gelöscht werden.',
  [T.failedToDeleteUserGroup]: 'Benutzergruppe konnte nicht gelöscht werden.',
  [T.userGroupDeletedSuccessfully]: 'Benutzergruppe erfolgreich gelöscht.',
  [T.userGroupsDeletedSuccessfully]: 'Benutzergruppen erfolgreich gelöscht.',
  [T.userGroupCreatedSuccessfully]: 'Benutzergruppe erfolgreich erstellt.',
  [T.failedToCreateUserGroup]: 'Benutzergruppe konnte nicht erstellt werden.',
  [T.failedToUpdateUserGroup]:
    'Benutzergruppe konnte nicht aktualisiert werden.',
  [T.userGroupUpdatedSuccessfully]: 'Benutzergruppe erfolgreich aktualisiert.',
  [T.addUserGroup]: 'Fügen Sie eine Benutzergruppe hinzu',
  [T.editUserGroup]: 'Benutzergruppe bearbeiten',
  [T.searchUsers]: 'Benutzer suchen',
  [T.createdBy]: 'Erstellt von',
  [T.userGroupDeleteConfirmationMsg]:
    'Sind Sie sicher, dass Sie Benutzergruppen löschen?',

  // no_data_components
  [T.noDataNameSpaceMessage]:
    'Erstellen Sie einen Arbeitsbereich, um mit dem Hochladen von Daten zu beginnen.',

  [T.noDataWorkspaceMessage]:
    'Laden Sie einen Ordner hoch oder erstellen Sie eine Sammlung, um Daten hochzuladen.',
  [T.noDataCollectionMessage]: 'Dateien/Ordner hochladen',
  [T.noDataNoPermissionMessage]:
    'Fordern Sie den Administrator auf, Zugriff auf Dokumente zu erhalten.',
  [T.noData]: 'Keine Daten',
  [T.noDataExists]: 'Keine Daten vorhanden.',
  [T.documentGraphPlaceholder]:
    'Diese Grafik würde die Chat-Aktivität anzeigen, sobald Antworten eingehen',
  [T.workSpaceInfoMessage]:
    'Neue Arbeitsbereiche können nur von Organisationsadministratoren erstellt werden.',
  [T.moveDialogInfo]:
    'Verschobene Inhalte behalten ihre ursprünglichen Quellenberechtigungen bei.',
  // validations
  [T.maxLength]: '{{name}} darf nicht länger als {{length}} Zeichen sein',
  [T.required]: '{{name }} ist erforderlich',
  [T.valueCannotBeZero]: '{{name}} darf nicht Null sein',
  [T.enterPositiveValue]: 'Geben Sie einen positiven Wert ein',
  [T.tagHelperText]:
    'Drücken Sie die Eingabetaste, um ein neues Tag zu erstellen oder eines aus der Liste auszuwählen.',

  [T.maxCompanyLength]:
    '{{company}} darf nicht länger als {{length}} Zeichen sein',
  [T.maxDepartmentLength]:
    '  {{department}} darf nicht länger als {{length}} Zeichen sein',
  [T.maxJobLength]: '{{jobRole}} darf nicht länger als {{length}} Zeichen sein',
  [T.maxCountryength]:
    '{{country}} darf nicht länger als {{length}} Zeichen sein',

  //no_content_msg
  [T.noContentAvailable]: 'Kein Inhalt verfügbar.',

  // Error Messages
  [T.namespaceError]: 'Namespace-Fehler ist aufgetreten.',
  [T.resourceNotFoundError]: 'Ressource nicht gefunden.',
  [T.userNotFoundError]: 'Benutzer existiert nicht.',
  [T.noPermissionsAgainstResourceError]:
    'Keine Berechtigungen für die Ressource.',
  [T.insufficientPrivileges]:
    'Berechtigung zur Ausführung der Aktion nicht gefunden.',
  [T.invalidCredentialsError]: 'Ungültige Anmeldedaten angegeben!',
  [T.appRoleTemplateNotFoundError]: 'Vorlagenrolle der App nicht gefunden.',
  [T.uploadTypeError]: 'Ungültiger Dateityp für den Upload bereitgestellt.',
  [T.transactionIdError]: 'Ungültige Transaktions-ID bereitgestellt.',
  [T.uploadToRootError]: 'Fehler beim Hochladen in das Stammverzeichnis.',
  [T.blobWriteError]: 'Fehler beim Schreiben des Blobs.',
  [T.uploadToFoundError]:
    "Sie dürfen keine Dateien und Ordner im Ordner 'FOUND' hochladen.",
  [T.uploadToFileError]:
    'Dateien können nur in gültigen Ordnern hochgeladen werden.',
  [T.fileUploadToWorkspaceError]:
    'Dateien können auf der Workspace-Ebene nicht hochgeladen werden.',
  [T.uploadSessionFileDirectToWorkspaceError]:
    'In einen Workspace können nur Ordner direkt hochgeladen werden. Bitte legen Sie Ihre Dateien in einem Ordner ab, bevor Sie hochladen.',
  [T.uploadSessionInvalidTransition]:
    'Diese Statusänderung der Sitzung ist nicht erlaubt.',
  [T.uploadSessionTerminalState]:
    'Diese Upload-Sitzung wurde bereits beendet und kann nicht mehr geändert werden.',
  [T.uploadSessionStatusNotSupported]:
    'Der angeforderte Sitzungsstatus wird nicht unterstützt.',
  [T.uploadSessionNotEditable]:
    'Diese Upload-Sitzung kann nicht bearbeitet werden.',
  [T.uploadSessionEmptyManifest]:
    'Die ausgewählten Dateien wurden bereits hochgeladen. Um weitere Dateien hochzuladen, wählen Sie bitte neue Dateien aus.',
  [T.uploadSessionManifestInvalid]:
    'Das Upload-Manifest ist ungültig. Bitte erneut versuchen.',
  [T.uploadSessionPathConflict]:
    'Im Upload-Pfad wurde ein Dateikonflikt erkannt. Bitte Konflikte lösen und erneut versuchen.',
  [T.uploadSessionNotFound]: 'Upload-Sitzung nicht gefunden.',
  [T.uploadSessionPermissionDenied]:
    'Sie haben keine Berechtigung, diese Aktion an der Upload-Sitzung durchzuführen.',
  [T.uploadSessionInvalidClientHints]:
    'Die angegebenen Client-Hinweise sind ungültig.',
  [T.uploadSessionInvalidStatusFilter]:
    'Der Statusfilterwert wird nicht erkannt. Bitte einen gültigen Status verwenden.',
  [T.uploadSessionInvalidParent]:
    'Der Zielordner existiert nicht. Bitte einen gültigen Ordner auswählen.',
  [T.summaryDestinationLabel]: 'Ziel:',
  [T.summarySourceLabel]: 'Quelle (dieses Gerät):',
  [T.summaryProgressLabel]: 'Fortschritt:',
  [T.summaryTotalSizeLabel]: 'Gesamtgröße:',
  [T.summaryProgressText]:
    '{{uploaded}} von {{total}} Dateien hochgeladen – {{percent}}%',
  [T.noFilesAttachedError]:
    'Wählen Sie gültige Dateien aus, um mit dem Hochladen zu beginnen.',
  [T.fileStorageWriteError]: 'Fehler beim Schreiben in die Dateispeicherung.',
  [T.fileStorageReadError]: 'Fehler beim Lesen aus der Dateispeicherung.',
  [T.requestedResourceNotFile]: 'Angeforderte Ressource ist keine Datei.',
  [T.fileStorageDeleteError]: 'Fehler beim Löschen aus der Dateispeicherung.',
  [T.publicFolderDeleteError]:
    'Öffentlicher Ordner kann nicht gelöscht werden.',
  [T.internalServerError]: 'Etwas ist schiefgegangen.',
  [T.serverNotReachable]:
    'Server ist derzeit nicht erreichbar, bitte versuchen Sie es später erneut',
  [T.failedToSendVerificationEmail]:
    'Verifizierungs-E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
  [T.invalidArgsError]: 'Ungültige Argumente bereitgestellt.',
  [T.folderNotAllowedHere]: 'Sie dürfen hier keinen Ordner erstellen.',
  [T.rolesInsufficientViewPrivileges]:
    'Sie haben keine Berechtigung, Rollen anzuzeigen.',
  [T.userGroupsInsufficientPrivileges]:
    'Sie haben keine Berechtigung, Benutzergruppen anzuzeigen.',
  [T.waCreateUserRestriction]:
    'Workspace-Administratoren können nur normale Benutzer erstellen.',
  [T.readOnlyResourceUpdate]:
    'Sie dürfen die schreibgeschützte Ressource nicht aktualisieren.',
  [T.readOnlyResourceDelete]:
    'Sie dürfen die schreibgeschützte Ressource nicht löschen.',
  [T.rolesUniqueVoilation]: 'Die Rolle mit diesem Namen existiert bereits.',
  [T.addPermissionsAgainstResourceError]:
    'Fehler beim Hinzufügen von Berechtigungen für die Ressource.',
  [T.permissionsUpdatingErrorForRole]:
    'Fehler beim Aktualisieren von Berechtigungen für die Ressource.',
  [T.insufficientCreatePrivileges]:
    'Sie haben keine Berechtigung, eine Ressource zu erstellen.',
  [T.insufficientUpdatePrivileges]:
    'Sie haben keine Berechtigung, die Ressource zu aktualisieren.',
  [T.insufficientDeletePrivileges]:
    'Sie haben keine Berechtigung, die Ressource zu löschen.',
  [T.insufficientDeleteOneOrMorePrivileges]:
    'Sie haben keine Berechtigung, einige Ressourcen zu löschen.',
  [T.usersUniqueVoilation]: 'Benutzer existiert bereits.',
  [T.userGroupUniqueVoilation]:
    'Benutzergruppe mit demselben Namen existiert bereits.',
  [T.selfAssignmentOnResourceRestriction]:
    'Sie können sich selbst keine Ressource zuweisen.',
  [T.ruAssignmentAsControllerRestriction]:
    'Normale Benutzer können nicht als Kontrolleur zugewiesen werden.',
  [T.oaRemovalFromResourceDenied]:
    'Organisationsadministrator kann nicht von der Ressource entfernt werden.',
  [T.insufficientAssignmentPrivileges]:
    'Sie haben nicht genügend Rechte, um diese Aktion auszuführen.',
  [T.peerAccountAssignmentRestriction]:
    'Sie dürfen keine gleichen oder höheren Konten entfernen.',
  [T.messageOnEmptyFolderOrUnavailableFile]:
    'Der Chat kann nicht auf leeren oder nicht verfügbaren Ressourcen gestartet werden.',
  [T.noSharedFilesExist]:
    'Bitte laden Sie Dokumente in die Arbeitsbereiche hoch oder bitten Sie den Administrator um Zugang, um mit der Befragung zu beginnen.',
  [T.itemDetailsNotFoundError]:
    'Details für diese Ressource konnten nicht gefunden werden.',

  [T.operationNotPermitted]:
    'Berechtigung zur Ausführung der Aktion nicht gefunden.',
  [T.uniqueResourceNameError]:
    'Ressource mit demselben Namen ist bereits vorhanden.',
  [T.resourceNameUnchanged]:
    'Der Name muss sich vom aktuellen Namen unterscheiden.',
  [T.pleaseUpdateAtLeastOneField]:
    'Bitte aktualisieren Sie mindestens ein Feld.',
  [T.noResourcesShared]:
    'Nur autorisierte Dokumente sind erlaubt. Bitte laden Sie zuerst ein Dokument hoch.',
  // overLimit messages
  [T.chatCreditLimitExceededOA]:
    'Monatliches Limit für AI-Credits erreicht. Für sofortige Hilfe wenden Sie sich an den Kundensupport unter {{supportEmail}}.',
  [T.chatCreditLimitExceeded100Percent]:
    'Monatliches Limit für AI-Credits erreicht.',
  [T.chatCreditLimitExceeded]:
    'Monatliches Limit für AI-Credits erreicht. Bitte wenden Sie sich an Ihren Administrator.',
  [T.fileCreditLimitExceededOA]:
    'Dokumentenverarbeitung angehalten, monatliches Limit für AI-Credits erreicht. Für sofortige Hilfe wenden Sie sich an den Kundensupport unter “support@empowergpt.ai”.',
  [T.fileCreditLimitExceeded]: `Dokumentenverarbeitung angehalten, monatliches Limit für AI-Credits erreicht. Bitte wenden Sie sich an Ihren Administrator.`,
  [T.fileWordLimitExceededOA]:
    'Die Dokumentverarbeitung wurde angehalten, die Wortbeschränkung für verarbeitete gespeicherte Dokumente wurde erreicht. Bitte löschen Sie nicht mehr benötigte Dokumente, um Speicherplatz freizugeben. Für weitere Unterstützung wenden Sie sich an den Kundensupport unter „support@empowergpt.ai“.',
  [T.fileWordLimitExceeded]: `
  Die Dokumentenverarbeitung wurde angehalten, die Wortbeschränkung für verarbeitete gespeicherte Dokumente wurde erreicht. Bitte löschen Sie nicht mehr benötigte Dokumente, um Speicherplatz freizugeben.`,
  [T.creditLimitExceeded90Percent]:
    'Über 90 % der AI Credits wurden verbraucht.',
  [T.wordLimitExceeded90Percent]:
    'Über 90 % des zugewiesenen Wortlimits für verarbeitete gespeicherte Dokumente wurden erreicht.',
  [T.wordLimitReached100Percent]:
    'Das zugewiesene Wortlimit für verarbeitete gespeicherte Dokumente wurde erreicht. Bitte löschen Sie nicht mehr benötigte Dokumente, um Speicherplatz freizugeben.',
  [T.furtherAssistanceContactSupport]:
    'Wenn Sie weitere Hilfe benötigen, wenden Sie sich bitte an den Kundensupport unter ',
  [T.fileUploadLimitError]:
    'Sie haben das Limit von 100 Dokumenten im Testplan erreicht.',
  // Usage
  [T.processedDocuments]: 'Verarbeitete Dokumente',
  [T.overallUsage]: 'Gesamtnutzung',
  [T.aiUsage]: ' AI-Nutzung',
  [T.monthlyUsage]: 'Monatliche Nutzung',
  [T.dailyUsage]: 'Tägliche Nutzung',
  [T.processedDocumentsInfo]:
    'Geschätzte Anzahl von Wörtern gegenüber gespeicherten verarbeiteten Dokumenten in der Arbeitsbereiche.',
  [T.tokenUsageInfo]:
    '{{consumed}} {{unit}} verarbeiteter Dokumente in der Arbeitsbereiche von dem {{total}} {{unit}} limit.',
  [T.aiUsageInfo]: 'AI-Nutzung für Chat und Dokumentenverarbeitung.',
  [T.creditUsageInfo]:
    '{{consumed}} {{unit}} verwendet von dem {{total}} {{unit}} limit.',
  [T.credits]: 'Credits',
  [T.consumed]: 'Verbraucht',
  [T.date]: 'Datum',
  [T.noCreditsUsedThisMonth]: 'Diesen Monat wurden keine Guthaben verwendet.',
  [T.filesPermission]: 'Dateien sind hier nicht erlaubt',
  [T.unauthorizedFilesError]:
    'Sie haben keine Berechtigung, Dateien/Ordner hochzuladen',

  // users invitations
  [T.inviteUsers]: 'Benutzer einladen',
  [T.emailAddress]: 'E-Mail-Addresse',
  [T.userGroup]: 'Benutzergruppe',
  [T.draft]: 'Entwurf',
  [T.active]: 'Aktiv',
  [T.invited]: 'Eingeladen',
  [T.invitationExpired]: 'Einladung abgelaufen',
  [T.inactive]: 'Inaktiv',
  [T.deActivate]: 'Deaktivieren',
  [T.activate]: 'Aktivieren',
  [T.resendInvite]: 'Erneut senden',
  [T.inviteSentSuccessfully]: 'Einladung erfolgreich gesendet!',
  [T.inviteSentFailed]: 'Fehler beim Senden der Einladung!',
  [T.userActivated]: 'Benutzer erfolgreich aktiviert!',
  [T.userDeactivated]: 'Benutzer erfolgreich deaktiviert!',
  [T.userActivationFailed]: 'Fehler beim Aktivieren des Benutzers!',
  [T.userDeactivationFailed]: 'Fehler beim Deaktivieren des Benutzers!',
  [T.adUserNotFoundError]: 'Benutzer nicht in AD gefunden.',
  [T.invalidEmail]: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  [T.userInviteLimitReachedError]: 'Nutzereinladungslimit erreicht.',

  // SharePoint
  [T.sharePointAuthError]:
    'Du könntest möglicherweise keine Verbindung zu SharePoint herstellen aufgrund eines Konnektivitätsproblems.',
  [T.sharepoint]: 'Importieren von SharePoint',
  [T.sharepointModalTitle]: 'Ordner/Bibliothek auswählen',
  [T.sharepointModalSubtitle]:
    'Navigieren Sie zur gewünschten Site und wählen Sie den Zielordner / die Zielbibliothek für den Import aus',
  [T.availableSites]: 'Verfügbare Sites',
  [T.selectSiteMsg]:
    'Wählen Sie eine Site aus, um verfügbare Site-Inhalte anzuzeigen',
  [T.siteContent]: 'Site-Inhalt',
  [T.showSiteContent]: 'Site-Inhalt anzeigen',
  [T.select]: 'Wählen',
  [T.resourceImportedSuccessfully]: 'Ressource erfolgreich importiert.',
  [T.rootSite]: 'Hauptseiten',
  [T.sharePointSuccessModalTitle]: 'Ordner / Bibliothek erfolgreich verknüpft',
  [T.externalImportSuccessModalLine1]:
    'Alles erledigt! Der ausgewählte Ordner / die Bibliothek sowie ihre Inhalte sind für Sie als Sammlung zugänglich, sobald die Datensynchronisierung abgeschlossen ist.',
  [T.externalImportSuccessModalLine2]:
    'Die Sichtbarkeit der Sammlung basiert ausschließlich auf den Berechtigungen in SharePoint.',
  [T.noSubSiteAvailable]: 'Kein Unterwebsite verfügbar.',
  [T.noFolderFileAvailable]: 'Kein Ordner / Datei verfügbar.',
  [T.openInSharePoint]: 'In SharePoint öffnen',
  [T.Navigate]: 'Navigieren',
  [T.redirectUri]: 'Umleitungs URI',
  [T.confirmationStep1]:
    'Die oben genannten Schritte wurden auf die registrierte Anwendung in Microsoft Entra ID durchgeführt.',
  [T.signInWithMicrosoft]: 'Mit Microsoft anmelden (SSO)',
  [T.allowInvitingExternalUsers]: 'Einladen externer Benutzer erlauben',
  [T.externalDriveIntegration]:
    'Import von Inhalten aus externen Anwendungen zulassen',
  [T.syncFrequency]: 'Synchronisationsfrequenz (Minuten)',
  [T.contentImportFromSharepoint]: 'Microsoft SharePoint',
  [T.letsStart]: 'Lass uns anfangen',
  [T.next]: 'Nächster',
  [T.done]: 'Erledigt',
  [T.apply]: 'Anwenden',
  [T.welcomeScreenHeading1]: 'Schritte für SSO',
  [T.welcomeScreenHeading2]: 'Konfiguration',
  [T.registrationStep]: 'Registrieren Sie "EmpowerGPT" in Microsoft Entra ID',
  [T.azureDetailsStep]:
    'Geben Sie Details gegen die registrierte Anwendung auf Microsoft Entra ID ein',
  [T.configurePermissions]:
    'Geben Sie die erforderlichen Berechtigungen gegen verwendete APIs an die registrierte App in Microsoft Entra ID',
  [T.registrationPoint1]: 'In einem anderen Tab anmelden',
  [T.azurePortal]: 'Azure Portal',
  [T.roleAzurePortal]: 'als admin.',
  [T.registrationPoint2]:
    'Navigieren Sie zu "Microsoft Entra ID" (Azure Active Directory) > "App registrations" als admin.',
  [T.registrationPoint3]: 'Klicken Sie auf "+ Neue Registrierung".',
  [T.registrationPoint4]:
    'Geben Sie "EmpowerGPT" als Namen der Anwendung ein und wählen Sie die erforderlichen unterstützten Kontotypen aus. (Empfohlen: "Accounts in this organizational directory only").',
  [T.registrationPoint5]:
    'Wählen Sie unter dem Abschnitt "Redirect URI" im Anmeldeformular der Anwendung "Web" als Typ aus und fügen Sie die folgende Redirect URI in das entsprechende Feld ein.',
  [T.confirmationStep1]:
    'Die oben genannten Schritte wurden auf die registrierte Anwendung in Microsoft Entra ID durchgeführt.',

  [T.redirectUriRequired]: 'Redirect URI ist erforderlich',
  [T.azureDetailsPoint1]:
    'Sobald die Anwendung registriert ist, werden Sie zur "Overview" der registrierten Anwendung weitergeleitet.',
  [T.azureDetailsPoint2]:
    'Kopieren Sie die "Application (client) ID" und "Directory (tenant) ID" von der "Overview" Seite und geben Sie sie in die jeweiligen Felder unten ein.',
  [T.azureDetailsPoint3]:
    'Navigieren Sie zu "Certificates and secrets" unter dem Abschnitt "Manage" auf der registrierten Anwendung in Microsoft Entra ID.',
  [T.azureDetailsPoint4]:
    'Wählen Sie die Registerkarte "Client secrets" und klicken Sie auf die Schaltfläche "New client secret", um ein neues Client Secret zu erstellen. Geben Sie "EmpowerGPT client secret" in der Beschreibung ein, setzen Sie das Ablaufdatum auf 24 Monate (empfohlen) und klicken Sie auf "add".',
  [T.azureDetailsPoint5]:
    'Kopieren Sie den geheimen "Wert" und fügen Sie ihn in das Feld unten ein. Client Secret-Werte können nicht angezeigt werden. außer unmittelbar nach der Erstellung. Stellen Sie sicher, dass Sie den sicheren Wert beim Erstellen speichern, bevor Sie die Seite verlassen.',
  [T.clientIdRequired]: 'Client Id ist erforderlich',
  [T.labelClientId]: 'Anwendungs (Client) Id:',
  [T.tenantIdRequired]: 'Tenant Id ist erforderlich',
  [T.labelTenantId]: 'Verzeichnis (Mandant) Id:',
  [T.secretValueRequired]: 'Secret Value ist erforderlich',
  [T.labelSecret]: 'Client Secret Value:',
  [T.enter]: 'Geben Sie ein...',
  [T.enterNote]: 'Geben Sie eine Notiz ein...',
  [T.failedToSendEmail]: 'E-Mail nicht gefunden',
  [T.permissionsStep1]:
    'Navigieren Sie zu "API permissions" unter dem Abschnitt "Manage" auf der registrierten Anwendung in Microsoft Entra ID.',
  [T.permissionsStep2]:
    'Klicken Sie auf die Schaltfläche "+ Add a permission" und wählen Sie "Microsoft Graph" unter Microsoft APIs.',
  [T.permissionsStep3]:
    'Wählen Sie "Application permissions", um die folgenden Berechtigungen zu erteilen, und bestätigen Sie dies, indem Sie auf die Schaltfläche "add permission" unten klicken.',
  [T.permissionsStep4]: 'User.ReadBasic.All unter User.',
  [T.permissionsStep5]: 'Group.Read.All unter Group.',
  [T.permissionsStep6]: 'GroupMember.Read.All unter GroupMember.',
  [T.permissionsStep7]:
    'Wiederholen Sie Schritt 2 und wählen Sie "Delegated permissions" aus, um die Berechtigung "profile" zu erteilen. Bestätigen Sie durch Klicken auf die Schaltfläche "add permission" unten.',
  [T.permissionsStep8]:
    'Die oben genannten Schritte wurden auf die registrierte Anwendung in Microsoft Entra ID durchgeführt.',
  [T.adUserSearchQuestion]:
    'Möchten Sie die Suche nach Active Directory-Benutzern aktivieren?',
  [T.adUserSearchEnableOption]: 'Ja, AD-Benutzersuche aktivieren',
  [T.adUserSearchEnableOptionDescription]: 'Fügt User.ReadBasic.All hinzu',
  [T.adUserSearchDisableOption]: 'Nein, AD-Benutzersuche nicht aktivieren',
  [T.adUserSearchDisableOptionDescription]:
    'Personen stattdessen per E-Mail einladen',
  [T.adUserSearchDisclaimer]:
    'Das System kann keine Active Directory-Benutzer durchsuchen. Sie können weiterhin Personen per E-Mail-Adresse zu EmpowerGPT einladen.',
  [T.successDialogTitle]: 'SSO erfolgreich konfiguriert',
  [T.successDialogDescription]:
    'SS0 wurde erfolgreich gegen Benutzer in dem verknüpften Verzeichnis konfiguriert.',
  [T.clickHere]: 'Klicken Sie hier',
  [T.toLogout]: ' um sich abzumelden und die Konfiguration zu testen.',
  [T.collectionSharepointPlaceholder]: 'Importieren aus Sharepoint',
  [T.collectionSharepointDescription]:
    'Importieren Sie Inhalte von Sharepoint nach EmpowerGPT',

  // Realm and Tenant configuration
  [T.continue]: 'Weiter',
  [T.discoverTenant]: 'Anmeldung',
  [T.tenants]: 'Mieter',
  [T.domain]: 'Bereich',
  [T.subDomain]: 'Sottodominio',
  [T.newTenant]: 'Neuer Mandant',
  [T.tenantCreatedSuccessfully]:
    ' E-Mail-Einladung wurde an {{enteredEmail}} gesendet, Mandant wurde für {{parsedDomain}} erstellt',
  [T.emailSendSuccessfully]:
    'E-Mail-Einladung gesendet an {{eingegebeneE-Mail}}',
  [T.tenantDeletedSuccessfully]: 'Mieter erfolgreich gelöscht',
  [T.tenantCreationFailed]: 'Fehler beim Anlegen eines Mieters',
  [T.tenantDeletionFailed]: 'Fehler beim Löschen des Mieters',
  [T.tenantUniqueViolation]: 'Mieter existiert bereits',
  [T.invalidDomain]: 'Keine registrierte email',
  [T.workEmailRequired]: 'Geschäftliche E-Mail erforderlich.',
  [T.specialCharNotAllowed]: 'Sonderzeichen sind nicht erlaubt.',
  [T.domainNameRequired]: 'Domain Name ist erforderlich',
  [T.domainNameLength]: 'Der Domainname darf maximal 20 Zeichen enthalten.',
  [T.domainDisclaimer]:
    'Diese Domain wird verwendet, um sich bei der Anwendung anzumelden.',
  [T.marketingConsentDisclaimer]:
    'Ich stimme zu, E-Mail-Updates zum Onboarding-Leitfaden sowie zu Produkten, Dienstleistungen und Neuigkeiten der INTECH Automation & Intelligence GmbH zu erhalten.',
  [T.signupDisclaimer]:
    'Keine Kreditkarte • Kein Verkaufskontakt • Jederzeit kündbar',
  [T.domainName]: 'Login-URL',
  [T.selfSignupFailed]: 'Self-Service-Registrierung fehlgeschlagen',
  [T.selfSignupConfirmation1]: 'Bitte warten, Konto wird erstellt',
  [T.needHelpContactUs]: 'Benötigen Sie Hilfe? Kontaktieren Sie uns unter ',
  [T.privacySettings]: 'Datenschutzeinstellungen',
  [T.selfSignupConfirmation2]: 'Es wurde eine Einladung an {{email}} gesendet.',
  [T.selfSignupConfirmation3]:
    'Klicken Sie auf die Schaltfläche "Click to Proceed“ in der erhaltenen E-Mail, um Ihr Konto einzurichten. Der Einladungslink läuft nach [7] Tagen ab.',
  [T.back]: 'Zurück',
  [T.confirmDeleteTenant]:
    'Sind Sie sicher, dass Sie den Mieter "{{name}}" löschen wollen?',
  [T.reprocessAllFiles]: 'Alle Dateien erneut verarbeiten',
  [T.reprocessAllFilesConfirmation]:
    'Sind Sie sicher, dass Sie alle Dateien für die Mieter erneut verarbeiten möchten?',
  [T.tenantFileReprocessingFailed]:
    'Wiederaufbereitung der Dateien eines Mieters fehlgeschlagen',
  [T.tenantFileReprocessingTriggered]:
    'Dateiwiederaufbereitung des Mieters erfolgreich gestartet',
  [T.tenantNoFilesToProcess]:
    'Keine Dateien zur Nachbearbeitung des Mieters gefunden',
  [T.confirmReprocessFilesTenant]:
    'Sind Sie sicher, dass Sie alle Dateien für diesen Mandanten erneut verarbeiten möchten?',
  [T.fileIdsToReprocess]:
    'Geben Sie die Datei-IDs ein, die erneut verarbeitet werden sollen (durch Kommas getrennt):',
  [T.onlyReprocessSelectedFiles]: 'Nur ausgewählte Dateien erneut verarbeiten',
  [T.userDomainName]: 'Benutzerdomainname',
  [T.firstSignedUpEmail]: 'Erste registrierte E-Mail',
  [T.totalUsers]: 'Gesamtanzahl Benutzer',
  [T.dateLastSignedUsers]: 'Datum des letzten Benutzer-Logins',
  [T.tenantReprocessFiles]: 'Mandantendateien erneut verarbeiten',
  [T.tenantDelete]: 'Mandant löschen',
  [T.selectTenant]: 'Mieter auswählen',
  [T.block]: 'Blockieren',
  [T.numberGreaterThanZero]: 'Geben Sie eine Zahl größer als 0 ein',
  [T.minimumValueShouldBeOne]: 'Der Mindestwert sollte 1 sein',
  [T.updateTenant]: 'Update Mieter',

  // One Drive
  [T.oneDriveMyFiles]: 'Meine Akten',
  [T.oneDriveShared]: 'Mit Ihnen geteilt',
  [T.oneDrive]: 'Von einem Laufwerk importieren',
  [T.oneDriveModalTitle]: 'Wählen Sie einen Ordner/eine Bibliothek aus',
  [T.oneDriveModalSubtitle]:
    'Navigieren Sie in Ihrem OneDrive und wählen Sie den Zielinhalt für den Import aus',
  [T.content]: 'Inhalt',
  [T.blog]: 'Blog',
  [T.oneDriveSuccessModalTitle]: 'Ordner/Bibliothek erfolgreich verknüpft',
  [T.oneDriveSuccessModalLine1]:
    'Alles bereit! Sobald die Datensynchronisierung abgeschlossen ist, stehen Ihnen der ausgewählte Ordner/die ausgewählte Bibliothek und ihr Inhalt als Sammlung zur Verfügung.',
  [T.oneDriveSuccessModalLine2]:
    'Die Sichtbarkeit der Sammlung basiert ausschließlich auf ihren Berechtigungen bei One Drive.',
  [T.openInOneDrive]: 'In One Drive öffnen',
  [T.contentImportFromOneDrive]: 'Microsoft OneDrive',
  [T.oneDriveResourceProviderWelcomeTitle]:
    'Schritte zum Importieren aus der OneDrive-Konfiguration',
  [T.oneDriveConfigurationSuccessTitle]: 'Import aus OneDrive konfiguriert',
  [T.oneDriveConfigurationSuccessDescription1]:
    'Inhalte können jetzt als Sammlungen aus OneDrive in EmpowerGPT importiert werden.',
  [T.oneDriveConfigurationSuccessDescription2]:
    'Die Sichtbarkeit importierter Inhalte basiert auf ihren Berechtigungen bei OneDrive.',
  [T.collectionOneDrivePlaceholder]: 'Importieren aus OneDrive',
  [T.collectionOneDriveDescription]:
    'Importieren Sie Inhalte von OneDrive nach EmpowerGPT',

  // Common External Resource provider
  [T.collectionExternalResProvPlaceholder]: 'Import aus Sharepoint / OneDrive',
  [T.collectionExternalResProvDescription]:
    'Importieren Sie Inhalte von Sharepoint oder OneDrive in EmpowerGPT',
  [T.externalResourceDisclaimer]:
    "Die Sichtbarkeit des Inhalts basiert ausschließlich auf seinen Berechtigungen an der Quelle, außer in 'Öffentlich' oder 'Mein Arbeitsbereich'.",
  [T.tenantPlanUpdatedSuccess]: 'Mieter plan erfolgreich aktualisiert',
  [T.tenantPlanUpdateFail]: 'Mieter planaktualisierung fehlgeschlagen',

  // resource Provider config
  [T.resourceProviderWelcomeTitle]:
    'Schritte für die Konfiguration des Imports aus SharePoint',
  [T.resourceProviderTitle1]:
    'Laden Sie das generierte Zertifikat in der registrierten Anwendung "EmpowerGPT" auf Microsoft Entra ID hoch',
  [T.resourceProviderStep1Instruction1]:
    'Fügen Sie die Basis-URL für das SharePoint Ihrer Organisation unten ein. (Die Basis-URL für SharePoint Online wird basierend auf Ihrer Eingabe bei der Einrichtung Ihres Microsoft 365-Abonnements bereitgestellt. Wenn Ihr Organisationsname beispielsweise Contoso ist, lautet die Root-Site für SharePoint Online https://contoso.sharepoint.com.).',
  [T.resourceProviderStep1Instruction2]:
    'Klicken Sie unten auf die Schaltfläche, um das erforderliche Zertifikat herunterzuladen.',
  [T.resourceProviderStep1Instruction3]:
    'Melden Sie sich in einem anderen Tab als Administrator im Azure-Portal an.',

  [T.resourceProviderStep1Instruction4]:
    'Navigieren Sie zu "Microsoft Entra ID" (Azure Active Directory) > "App registrations" > "All applications" > "EmpowerGPT".',
  [T.resourceProviderStep1Instruction5]:
    'Wählen Sie die Anwendung aus und navigieren Sie zum Abschnitt "Certificates and secrets" unter "Manage".',
  [T.resourceProviderStep1Instruction6]:
    'Wählen Sie den Tab "Certificates" aus und klicken Sie auf "Upload certificate". Laden Sie das oben generierte Zertifikat, das auf Ihrem Computer heruntergeladen wurde, hoch.',
  [T.resourceProviderStep1Instruction7]:
    'Geben Sie eine passende Beschreibung ein und klicken Sie auf die Schaltfläche "Add", um das Zertifikat hinzuzufügen.',

  [T.resourceProviderTitle2]:
    'Geben Sie die erforderlichen Berechtigungen für die verwendeten APIs an die registrierte App in Microsoft Entra ID weiter',
  [T.resourceProviderGraphPermissionsSectionTitle]:
    'Microsoft Graph API-Berechtigungen',
  [T.resourceProviderSharePointPermissionsSectionTitle]:
    'SharePoint-API-Berechtigungen',
  [T.resourceProviderSitesSelectedAccessDisclaimer]:
    'Die Erteilung von Sites.Selected gewährt allein noch keinen Zugriff. Ein Administrator muss EmpowerGPT jede benötigte Website separat zuweisen, bevor Inhalte von dort importiert werden können. Siehe <guideLink>Microsofts Anleitung</guideLink>.',
  [T.resourceProviderStep0Instruction0Start]: `Melden Sie sich in einer anderen Registerkarte bei `,
  [T.resourceProviderStep0Instruction0End]: ` als Administrator`,
  [T.resourceProviderStep2Instruction1]:
    'Navigieren Sie zu „Microsoft Entra ID“ (Azure Active Directory) > „App-Registrierungen“ > „Alle Anwendungen“ > „EmpowerGPT“ > „API-Berechtigungen“.',
  [T.resourceProviderStep2Instruction2]:
    'Klicken Sie auf die Schaltfläche "+ Add a permission" und wählen Sie "Microsoft Graph" unter Microsoft APIs aus.',
  [T.resourceProviderStep2Instruction3]:
    'Wählen Sie "Application permissions" aus, um die folgenden Berechtigungen zu erteilen, und bestätigen Sie durch Klicken auf die Schaltfläche "add permission" unten.',
  [T.resourceProviderStep2Instruction5]: 'Sites.Read.All.',
  [T.resourceProviderStep2Instruction5Selected]: 'Sites.Selected.',
  [T.resourceProviderSitesReadAllTitle]:
    'EmpowerGPT Zugriff auf alle Websites gewähren',
  [T.resourceProviderSitesReadAllDescription]: 'Verwendet Sites.Read.All',
  [T.resourceProviderSitesSelectedTitle]:
    'EmpowerGPT Zugriff nur auf ausgewählte Websites gewähren',
  [T.resourceProviderSitesSelectedDescription]: 'Verwendet Sites.Selected',
  [T.resourceProviderStep2Instruction6]: 'Files.Read.All.',
  [T.resourceProviderStep2Instruction7]:
    'Wiederholen Sie Schritt 2 und wählen Sie "Delegated permissions" aus, um die folgenden Berechtigungen zu erteilen. Bestätigen Sie durch Klicken auf die Schaltfläche "add permission" unten.',
  [T.resourceProviderStep2Instruction7OneDrive]:
    'Wählen Sie "Delegated permissions" aus, um die folgenden Berechtigungen zu erteilen. Bestätigen Sie durch Klicken auf die Schaltfläche "add permission" unten.',
  [T.resourceProviderStep2Instruction8]:
    'Klicken Sie auf die Schaltfläche "+ Add a permission" und wählen Sie "SharePoint" unter Microsoft APIs aus, um die folgenden "Application permission" zu erteilen. Klicken Sie auf "add permission", um zu bestätigen.',
  [T.sharepointConfigurationSuccessTitle]: 'Import aus SharePoint konfiguriert',
  [T.sharepointConfigurationSuccessDescription1]:
    'Inhalte können jetzt aus SharePoint-Sites in EmpowerGPT als Sammlungen importiert werden.',
  [T.sharepointConfigurationSuccessDescription2]:
    'Die Sichtbarkeit der importierten Inhalte basiert auf den Berechtigungen in SharePoint.',
  [T.downloadCertificate]: 'Zertifikat herunterladen',
  [T.invalidSharePointUrl]: 'Ungültige SharePoint URL bereitgestellt.',
  [T.identityProviderEnabledSuccessfully]:
    'Microsoft (SSO) erfolgreich aktiviert.',
  [T.resourceProviderSharePointEnabledSuccessfully]:
    'SharePoint erfolgreich aktiviert.',
  [T.resourceProviderSharePointDisabledSuccessfully]:
    'SharePoint erfolgreich deaktiviert.',
  [T.resourceProviderOneDriveEnabledSuccessfully]:
    'OneDrive erfolgreich aktiviert.',
  [T.resourceProviderOneDriveDisabledSuccessfully]:
    'OneDrive erfolgreich deaktiviert.',
  [T.identityProviderDisabledSuccessfully]:
    'Microsoft (SSO) erfolgreich deaktiviert.',
  [T.identityProviderUpdateFailed]: 'Fehler beim Aktivieren von SharePoint.',
  [T.identityProviderUpdateFailed]:
    'Fehler beim Aktivieren von Microsoft (SSO).',
  [T.identityProviderCreationFailed]:
    'Fehler beim Aktivieren von Microsoft (SSO).',
  [T.resourceProviderSharePointCreationFailed]:
    'Fehler beim Aktivieren von SharePoint.',
  [T.resourceProviderOneDriveCreationFailed]:
    'Fehler beim Aktivieren von OneDrive.',
  [T.disabledToolTipMicrosoftSSO]:
    'Konfigurieren Sie Microsoft SSO, um zu aktivieren.',
  [T.requiredCheckbox]: 'Dieses Feld ist erforderlich.',
  [T.adminConsent]:
    'Stellen Sie sicher, dass die Administratorzustimmung für Berechtigungen erteilt wird, die dies erfordern, was durch ein "Yes" in der Spalte "Admin consent required" der Tabelle "Configured permissions" angezeigt wird.',

  //Internal Analytics
  [T.overview]: 'Überblick',
  [T.words]: 'Wörter',
  [T.currentMonth]: 'Diesen Monat',
  [T.chatAnalyticsHeading]: 'Funktionsnutzung oder Funktionsbindung',
  [T.dislikes]: 'Abneigungen',
  [T.AF_DAC]: 'Analyse',
  [T.AF_DAQNC]: 'Fragebögen',
  [T.AF_DAQC]: 'Fragen',
  [T.AF_ASQ]: 'Suchanfragen',
  [T.messageSuccessRate]: 'Erfolgsquote bei der Nachrichtenübermittlung',
  [T.currentMonthTooltip]:
    'Vergleicht die Leistung des aktuellen Monats mit dem vorherigen Monat.',
  [T.lastMonthTooltip]:
    'Vergleicht die Leistung des letzten Monats mit dem Monat davor.',
  [T.ytdTooltip]:
    'Vergleicht die Leistung vom Jahresbeginn bis heute mit demselben Zeitraum des Vorjahres.',
  [T.lastWeekTooltip]:
    'Vergleicht die Leistung der letzten 7 Tage mit der vorherigen Woche.',
  [T.lastDayTooltip]:
    'Vergleicht die Leistung der letzten 24 Stunden mit der des Vortages.',
  [T.conversationVsQueries]: 'Gespräche vs. gestellte Fragen',
  [T.creditsTooltip]:
    'Zeigt nur die Credit-Nutzung im Tarif an.\n Die PAYG-Nutzung wird im PAYG-Dashboard angezeigt.',
  [T.processDocTooltip]:
    'Die Anzahl der Wörter, die im ausgewählten Zeitraum in allen Dokumenten verarbeitet wurden, im Vergleich zu Ihrem Gesamtlimit.',
  [T.conversationTooltip]:
    'Chats sind begonnene Unterhaltungen; Nachrichten sind einzelne Anfragen darin. An einem geschäftigen Tag kann es wenige Chats, aber viele Nachrichten geben.',
  [T.questions]: 'Fragen',
  [T.documentsUploaded]: 'Hochgeladene Dokumente',
  [T.assistantsCreated]: 'Assistenten erstellt',
  [T.time]: 'Zeit',
  [T.userOrGroups]: 'Benutzer',
  [T.fetchResourceCountError]:
    'Ressourcenzahlen konnten nicht abgerufen werden',
  [T.chatEngagement]: 'Chatbetrokkenheid',
  [T.lastDay]: 'Letzte 24 Stunden',
  [T.lastWeek]: 'Letzte 7 Tage',
  [T.lastMonth]: 'im letzten Monat',
  [T.selectDate]: 'Wähle einen Zeitraum aus',
  [T.allTime]: 'Alle Zeit',
  [T.thisQuarter]: 'Dieses Quartal',
  [T.lastQuarter]: 'Letztes Quartal',
  [T.thisYear]: 'Dieses Jahr',
  [T.lastYear]: 'Letztes Jahr',
  [T.yearToDate]: 'Seit Jahresbeginn',
  [T.startDateError]: 'Das Startdatum darf nicht nach dem Enddatum liegen',
  [T.resetToCurrentMonth]: 'Aktueller Monat',
  [T.aiUsage]: 'KI-Nutzung',
  [T.processedDocuments]: 'Verarbeitete Dokumente',
  [T.creditSpent]: 'Verbrauchtes Guthaben',
  [T.dateRange]: 'Datumsbereich',
  [T.conversation]: 'Gespräche',
  [T.queriesAsked]: 'Anfragen gestellt',
  [T.messages]: 'Nachrichten',
  [T.documentAnalyst]: 'Dokumentenexperte (Analyse)',
  [T.smartMeetAnalyst]: 'Smart Meet Anzahl der Besprechungen',
  [T.questionnairesCreated]: 'Erstellte Fragebögen',
  [T.assistantName]: 'Assistentenname',
  [T.topAssistants]: 'Top-Assistenten',
  [T.creditsSpentDetail]: 'Details zum Guthabenverbrauch',
  [T.creditConsumption]: 'Guthabenverbrauch',
  [T.user]: 'Benutzer',
  [T.feature]: 'Funktion',
  [T.creditsUsed]: 'Verwendete Guthaben',
  [T.modelUsed]: 'Verwendetes Modell',
  [T.total]: 'Gesamt',
  [T.Unsupported]: 'Nicht unterstützt',
  [T.Processed]: 'Verarbeitet',

  // User Favourites
  [T.favourites]: 'Favoriten',
  [T.markFavourite]: 'Als favorit markieren',
  [T.unmarkFavourite]: 'Markierung als favorit aufheben',
  [T.markedFavourite]: 'Als favorit markiert',
  [T.unmarkedFavourite]: 'Nicht als favorit markiert',
  [T.markFavouriteError]: 'Fehler beim markieren als favorit',
  [T.unmarkFavouriteError]: 'Fehler beim aufheben der markierung als favorit',
  [T.favouriteLimitReached]: 'Das Limit der benutzerfavoriten wurde erreicht',

  // User Onboarding
  [T.welcomeText]: `Willkommen bei`,
  [T.welcomeText1]: `EmpowerGPT ist eine KI-Plattform, die für Unternehmen gemacht ist. Chatten Sie sicher mit hochmodernen LLMs, die Ihr Unternehmens- und Weltwissen einbeziehen.`,
  [T.welcomeText2]: `Erweitern Sie die Wissensbasis Ihres Unternehmens durch Hochladen oder Importieren von Daten aus integrierten Anwendungen.`,
  [T.welcomeText3]: 'Starte jetzt deine EmpowerGPT-Testphase',
  //Chat
  [T.gotIt]: 'Verstanden',
  [T.chatBranched]: 'Chat-Verlauf verzweigt',
  [T.onNext]: 'Klicken Sie auf Weiter, um fortzufahren.',
  [T.chatStep1Title]: 'Plaudern: Wählen Sie den gewünschten Wissensbereich aus',
  [T.chatStep1Description]:
    'Wählen Sie, wie Sie EmpowerGPT antworten lassen wollen. Bleiben Sie beim Unternehmenswissen, um Antworten auf die zugänglichen Unternehmensdokumente zu erhalten. Oder wechseln Sie zu Weltwissen, um Unterstützung bei der Erstellung von Inhalten, Codierung, Recherche und Zugang zu Weltwissen zu erhalten.',
  [T.chatStep2Title]: 'Plaudern: Geben Sie Ihre Anfrage ein.',
  [T.chatStep2Description]: `Verwenden Sie das Eingabefeld unten, um Ihre Fragen einzugeben, und klicken Sie auf die Schaltfläche "Senden" auf der rechten Seite. Der Kontext zu früheren Anfragen und Antworten ist innerhalb eines Chats begrenzt`,
  [T.chatStep3Title]: 'Plaudern: Überprüfen Sie die Fakten.',
  [T.chatStep3Description]: `Chat-Antworten in Unternehmenswissen sind am Ende mit Quellenangaben versehen. Es wird empfohlen, die Authentizität der Antwort durch Einsicht in die Referenzen zu überprüfen.`,
  [T.chatQuery]:
    'Schreibe eine E-Mail, um der Marketingabteilung zu ihrem Umsatzanstieg von 15 % im dritten Quartal 2025 zu gratulieren.',

  [T.today]: 'Heute',
  [T.thisWeek]: 'Diese Woche',
  [T.thisMonth]: 'Diesen Monat und älter',
  [T.chatHistory]: 'Chat-Verlauf',
  [T.noChatHistory]: 'Kein Chat-Verlauf vorhanden',
  [T.chatDeleted]:
    'Kann die Unterhaltung in einem gelöschten Chat nicht fortsetzen',
  [T.imageGenerationLimitReached]: 'Limit für die Bilderzeugung erreicht',
  [T.modelCoolDownTooltip]:
    'Nutzungslimit erreicht. Versuche es später erneut.',
  [T.assistantResourceNotFound]: `Es kann keine Antwort erzeugt werden. Der Assistent wurde aktualisiert. Bitte aktualisieren Sie die Seite, um die Änderungen zu übernehmen.`,

  //Data Library
  [T.documentStep1Title]: 'Hochladen: Navigieren Sie zur Arbeitsbereiche.',
  [T.documentStep1Description]:
    'Data Library enthält Arbeitsbereiche, die für Sie freigegeben wurden. Arbeitsbereiche kategorisieren Dokumente innerhalb einer Organisation.',
  [T.documentStep2Title]:
    'Hochladen: Wählen Sie den gewünschten Arbeitsbereich.',
  [T.documentStep2Description]:
    'Die Aktionen, die in einem Arbeitsbereich verfügbar sind, hängen von der Rolle ab, die Sie dort zugewiesen bekommen haben. "Mein Arbeitsbereich" ist ein persönlicher Arbeitsbereich, dem Sie Dokumente hinzufügen und mit dem Sie chatten können.',
  [T.documentStep3Title]: `Hochladen: Erstellen Sie eine Sammlung.`,
  [T.documentStep3Description]:
    'Sammlungen dienen der weiteren Klassifizierung von Dokumenten in jedem Arbeitsbereich. Erstellen Sie Ihre Sammlung im Arbeitsbereich "Mein", um darin Dokumente hochzuladen.',
  [T.documentStep4Title]: 'Hochladen: Dokumente zum Hochladen auswählen',
  [T.documentStep4Description]:
    'EmpowerGPT unterstützt eine Vielzahl von Dokumentenformaten, die der Wissensdatenbank hinzugefügt werden können, darunter PDFs (auch gescannte Dokumente), Word-Dokumente, Powerpoint-Folien und Excel-Dateien.',
  [T.documentStep5Title]: 'Hochladen: Verständnis des Dokumentenstatus',
  [T.documentStep5Description]:
    'Einmal hochgeladene Dokumente werden für die KI-Verarbeitung in eine Warteschlange gestellt. Sobald sie als „Bearbeitet“ markiert sind, können Benutzer, die Zugang zu diesen Dokumenten haben, mit ihnen chatten.',

  // Projects
  [T.projects]: 'Projekte',
  [T.projectsHeaderText]:
    'Verwenden Sie Projekte, um gemeinsame Anweisungen festzulegen, Dateien anzuhängen und Chats zu organisieren.',
  [T.projectsMoto]:
    'Verwenden Sie Projekte, um Chats zu kombinieren und zu organisieren.',
  [T.newProject]: 'Neues Projekt',
  [T.createProjectPlaceholder]:
    'Erstellen Sie ein neues Projekt, um loszulegen',
  [T.projectDescription]:
    'Projekte helfen Ihnen, gemeinsame Anweisungen festzulegen und Dateien für Gespräche anzuhängen.',
  [T.createProject]: 'Erstellen Sie ein neues Projekt',
  [T.updateProject]: 'Projekt aktualisieren',
  [T.createNewProject]: 'Neues Projekt erstellen',
  [T.createProjectDescription]:
    'Erstellen Sie ein separates Projekt, um Gespräche zu organisieren.',
  [T.projectName]: 'Projektname',
  [T.projectDescriptionPlaceholder]:
    'Fügen Sie eine Beschreibung für Ihr Projekt hinzu',
  [T.removeFromProject]: 'Aus Projekt entfernen',
  [T.addSources]: 'Quellen hinzufügen',
  [T.noSharedProjectsTitle]: 'Noch keine geteilten Projekte',
  [T.noSharedProjectsDescription]:
    'Mit Ihnen geteilte Projekte werden hier angezeigt.',
  [T.noProjectChatsTitle]: 'Sie haben noch keine Chats',
  [T.noProjectChatsDescription]:
    'Starten Sie einen neuen Chat, um Ihr Gespräch zu beginnen. Noch keine Chats!',
  [T.noProjectSourcesTitle]: 'Sie haben noch keine Quellen',
  [T.noProjectSourcesDescription]:
    'Fordern Sie Zugriff an, um Projektquellen anzuzeigen.',
  [T.noExistingProject]: 'Sie haben noch kein Projekt erstellt.',
  [T.noExistingProjectDescription]:
    'Erstellen Sie Ihr erstes Projekt, um Ihre Chats zu organisieren.',
  [T.failedFetchingProject]: 'Fehler beim Abrufen des Projekts.',
  [T.failedFetchingProjects]: 'Fehler beim Abrufen der Projekte.',
  [T.deleteProject]: 'Projekt löschen!',
  [T.projectDeleteConfirmation]:
    'Sind Sie sicher, dass Sie dieses Projekt löschen möchten?',
  [T.failedDeletingProjects]: 'Fehler beim Löschen der Projekte.',
  [T.projectDeleteSuccess]: 'Projekt erfolgreich gelöscht.',
  [T.projectUpdateSuccess]: 'Projekt erfolgreich aktualisiert.',
  [T.projectCreationSuccess]: 'Projekt erfolgreich erstellt.',
  [T.projectShareSuccess]: 'Projekt erfolgreich geteilt.',
  [T.projectForkDisclaimerText]:
    'Diese Konversation findet zwischen EmpowerGPT und {{username}} statt. Eine Antwort wird einen neuen Zweig starten.',
  [T.projectNameAlreadyExists]:
    'Ein Projekt mit demselben Namen existiert bereits.',

  // Invite User
  [T.inviteUserStep1Title]: 'Einladen: Öffnen Sie das Menü',
  [T.inviteUserStep1Description]:
    'Die Menüschaltflächen enthalten Links zu Seiten, die für die Einrichtung und Verwaltung der Anwendung und Ihres Kontos erforderlich sind.',
  [T.inviteUserStep2Title]: 'Einladen: Navigieren Sie zur Benutzerseite',
  [T.inviteUserStep2Description]:
    'Die Seite Benutzer enthält eine Liste aller Personen, die sich derzeit auf der empowerGPT-Plattform befinden. Admins können von dieser Seite aus Benutzer einladen.',
  [T.inviteUserStep3Title]:
    'Einladen: Geben Sie die E-Mail des Eingeladenen ein.',
  [T.inviteUserStep3Description]:
    'Geben Sie die E-Mail-Adressen der Eingeladenen ein, wählen Sie den Kontotyp und ggf. die Benutzergruppe aus, bevor Sie die Einladung versenden.',

  // Chat models comments and descriptions
  [T.mistralLargeComment]: 'Alternative',
  [T.mistralLargeDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.llama370BInstructComment]: 'Offene Quelle',
  [T.llama370BInstructDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.llama38BInstructComment]: 'Offene Quelle',
  [T.llama38BInstructDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.gpt4TurboComment]: 'Demnächst verfügbar',
  [T.gpt4TurboDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.gpt432kComment]: 'Beste',
  [T.gpt432kDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.gpt4oComment]: 'Schnell und genau',
  [T.gpt4oDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.cohereComment]: 'Optimiert für Unternehmen',
  [T.cohereDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.gpt35Turbo16kComment]: 'Schnell',
  [T.gpt35Turbo16kDescription]: 'Gehostet auf Microsoft Azure in der EU',
  [T.deepseekV3Comment]: 'Schnell',
  [T.deepseekV3Description]: 'Gehostet auf Microsoft Azure in der EU',
  [T.accuracy]: 'Genauigkeit',
  [T.speed]: ' Geschwindigkeit',
  [T.price]: 'Preis',
  [T.tokenLimit]: 'Token-Limit',
  [T.imageAnalysis]: 'Bildanalyse',
  [T.knowledgeCutoff]: 'Wissensstichtag',
  // Prompts
  [T.promptTitle1]: 'Kürzer machen',
  [T.promptText1]:
    'Fassen Sie den folgenden Text auf [einfügen_Wort_zahl] Wörter zusammen, wobei alle wichtigen Informationen erhalten bleiben müssen: [einfügen_text_hier].',
  [T.promptTitle2]: 'Länger machen',
  [T.promptText2]:
    'Erweitern Sie den folgenden Text auf [einfügen_Wort_zahl] Wörter und achten Sie darauf, dass keine irrelevanten Details hinzugefügt werden: [einfügen_text_hier].',
  [T.promptTitle3]: 'Ton ändern',
  [T.promptText3]:
    'Schreiben Sie den folgenden Text in einem [spezifizierten_Ton] um und achten Sie darauf, dass die Botschaft klar und wirksam bleibt: [einfügen_text_hier].',
  [T.promptTitle4]: 'Grammatik und Rechtschreibung korrigieren',
  [T.promptText4]:
    'Korrigieren Sie die Grammatik und Rechtschreibung im folgenden Text und heben Sie alle Änderungen hervor, indem Sie die korrigierten Wörter fett markieren: [einfügen_text_hier].',
  [T.promptTitle5]: 'Übersetzen Sie',
  [T.promptText5]:
    'Übersetzen Sie den folgenden Text in die [angegebene_Sprache] und stellen Sie dabei sicher, dass alle benannten Einheiten, Abkürzungen und Akronyme korrekt erhalten bleiben: [einfügen_text_hier].',
  [T.promptTitle6]: 'Zusammenfassend',
  [T.promptText6]:
    'Fassen Sie den folgenden Text auf [Wortanzahl] Wörter zusammen und achten Sie darauf, dass alle wichtigen Informationen erhalten bleiben und die Gesamtaussage unverändert bleibt: [einfügen_text_hier].',
  [T.promptTitle7]: 'Feedback geben',
  [T.promptText7]:
    'Geben Sie ein Feedback zu dem folgenden Text und konzentrieren Sie sich dabei auf die angegebenen Bereiche: [Technik, Tonfall, Grammatik, Format]. Achten Sie darauf, dass Ihr Feedback konstruktiv ist und zur Verbesserung des Textes beiträgt: [einfügen_text_hier].',
  [T.promptTitle8]: 'Brainstorming von Ideen',
  [T.promptText8]:
    'Machen Sie ein Brainstorming mit [Anzahl_der_Ideen] kreativen und praktischen Ideen für die folgende Aufgabe: [Aufgabe+optionale_Beispiele]',
  [T.promptTitle9]: 'Schreiben Sie eine E-Mail',
  [T.promptText9]:
    'Schreiben Sie eine E-Mail auf der Grundlage der folgenden Nachricht: [Nachricht]. Stellen Sie sicher, dass der Ton [specified_tone] und die Länge der E-Mail [specified_length] ist.',
  [T.promptTitle10]: 'Schreiben Sie einen Beitrag für soziale Medien',
  [T.promptText10]:
    'Schreiben Sie einen Social-Media-Beitrag für [spezifizierte_Plattform] in [spezifizierter_Ton], der sich an [ziel_Zielgruppe] richtet. Fügen Sie ansprechende und für die Plattform geeignete Inhalte ein.',

  // Mini Experts - Doc Analyst
  [T.miniExperts]: 'Apps',
  [T.docAnalyst]: 'Dokumentenanalyst',
  [T.docAnalystDescription]: `Analysieren Sie Unternehmensdokumente, um schnell Schlüsselinformationen anhand einer Liste von Fragen zu extrahieren.`,
  [T.docClassifierDescription]:
    'Kategorisierung und Kennzeichnung von Dokumenten auf der Grundlage ihres Inhalts anhand einer Liste von Kennzeichnungen.',
  [T.smartMeetDescription]:
    'Fassen Sie Treffen zusammen, um die wichtigsten Erkenntnisse anhand eines festgelegten Formats schnell zu erfassen.',
  [T.dataAnalystSummary]:
    'Analysieren Sie Excel-Dateien, um Trends, Muster und Erkenntnisse zu erkennen.',
  [T.analysis]: 'Analyse',
  [T.documentClassification]: 'Dokument-Klassifikator',
  [T.comingSoon]: 'Demnächst verfügbar',
  [T.summaryGenerator]: 'Zusammenfassungs-Generator',
  [T.confirmationDialog]: 'Bestätigungsdialog',
  [T.dataCollections]: 'Datensammlungen',
  [T.initiate]: 'Initiieren',
  [T.newAnalysis]: 'Neue Analyse',
  [T.initiateAnalysis]: 'Analyse Initiieren',
  [T.dataset]: 'Datensatz',
  [T.inProcessFiles]: 'Die folgenden Dateien werden bearbeitet.',
  [T.questionnaire]: 'Fragebogen',
  [T.runAnalysis]: 'Analyse Durchführen',
  [T.runAnalysisPlaceholder]:
    'Um die Analyse zu starten, geben Sie den Namen der Analyse ein. \nWählen Sie Datensatz und Fragebogen und klicken Sie dann auf “',
  [T.importFromApp]: 'Aus der App importieren',
  [T.regenerateAnalysis]: 'Analyse Regenerieren',
  [T.saveAnalysis]: 'Analyse Speichern',
  [T.numberOfFiles]: 'Anzahl der Dateien',
  [T.numberOfQuestions]: 'Fragenanzahl',
  [T.clone]: 'Klonen',
  [T.filesImportSuccess]: 'Dateien/Ordner erfolgreich importiert',
  [T.filesImportFailure]: 'Dateien/Ordner-Import fehlgeschlagen',
  [T.spSitePermissionDenied]:
    'Diese SharePoint-Website ist nicht für den Import aktiviert. Wenden Sie sich an Ihren Administrator, um Zugriff zu beantragen.',
  [T.import]: 'Importieren',
  [T.analysisTitle]: 'Analyse Titel',
  [T.enterAnalysisTitle]: 'Titel der Analyse eingeben',
  [T.datasetTitle]: 'Datensatz Titel',
  [T.analysisDeleteConfirmation]:
    'Sind Sie sicher, dass Sie die Analyse löschen wollen?',
  [T.analysisDeleteSuccess]: 'Analyse erfolgreich gelöscht!',
  [T.analysisDeleteFailed]:
    'Das Löschen der Analyse ist fehlgeschlagen. Versuchen Sie es später noch einmal!',
  [T.datasetDeleteConfirmation]:
    'Sind Sie sicher, dass Sie das Dataset löschen wollen?',
  [T.datasetDeleteSuccess]: 'Dataset erfolgreich gelöscht!',
  [T.datasetDeleteFailed]:
    'Das Löschen von Datensätzen ist fehlgeschlagen. Versuchen Sie es später noch einmal!',
  [T.questionnaireDeleteConfirmation]:
    'Sind Sie sicher, dass Sie den Fragebogen löschen wollen?',
  [T.questionnaireDeleteSuccess]: 'Fragebogen erfolgreich gelöscht!',
  [T.questionnaireDeleteFailed]:
    'Die Löschung des Fragebogens ist fehlgeschlagen. Versuchen Sie es später noch einmal!',
  [T.addQuestionnaire]: 'Neuer Fragebogen',
  [T.title]: 'Titel',
  [T.addQuestion]: 'Frage hinzufügen',
  [T.questionnaireTitlePlaceholder]: 'Titel des Fragebogens eingeben',
  [T.questionnaireQuestionPlaceholder]: 'Frage eingeben',
  [T.questionnaireCreationSuccess]: 'Fragebogen erfolgreich erstellt.',
  [T.questionnaireCreationFailure]:
    'Die Erstellung des Fragebogens ist fehlgeschlagen.',
  [T.questionnaireUpdateFailure]: 'Fragebogen Update fehlgeschlagen.',
  [T.datasetCorrupted]: 'Quelldatei gelöscht',
  [T.selectItemsToImport]: 'Elemente zum Importieren auswählen',
  [T.importFilesDisclaimer]: 'Sie können 10 Elemente auswählen',
  [T.analysisCancelSuccess]: 'Analyse erfolgreich abgebrochen!',
  [T.questionUpdatedSuccess]: 'Fragebogen erfolgreich aktualisiert',
  [T.maximumDatasetSize]: 'Maximal 10 Dateien in einem Dataset erlaubt',
  [T.minimumDatasetSize]:
    'Mindestens 1 Datei ist erforderlich, um einen Datensatz zu erstellen',
  [T.questionnaireBlocked]:
    'Fragebogen kann aufgrund der Assoziation nicht bearbeitet werden.',
  [T.analysisFailed]: 'Dokument Analyse fehlgeschlagen',
  [T.analysisResourceFailure]:
    'Fehler! Datensatzressource(n) existiert/existieren nicht.',
  [T.analysisLimit]:
    'Limit für laufende Analysen erreicht! Bitte warten Sie, da gerade eine andere Analyse durchgeführt wird.',
  [T.analysisEditingBlocked]:
    'Die Bearbeitung der Analyse ist blockiert. Bitte warten Sie, während die laufende Analyse abgeschlossen wird.',
  [T.closeAnalysisTitle]: 'Antwort abbrechen/ Im Hintergrund laufen lassen',
  [T.cancelAnalysis]: 'Analyse abbrechen',
  [T.runInBackground]: 'Im Hintergrund ausführen',
  [T.continueAnalysis]: 'Analyse fortsetzen',
  [T.newQuestionnaire]: 'Neuer Fragebogen',
  [T.newDataset]: 'Neuer Datensatz',
  [T.questionnaireDescription]:
    'Erstellen Sie eine Liste mit Fragen, anhand derer Sie Ihre Dokumente analysieren können.',
  [T.analysisDescription]:
    'Analysieren Sie Dokumentendatensätze mit zweckgebundenen Fragebögen.',
  [T.skeletonTitle]: 'Sind Sie bereit, Ihre erste Analyse durchzuführen?',
  [T.skeletonDescription]:
    'Erstellen Sie Fragen, wählen Sie Datensätze aus, und gewinnen Sie Erkenntnisse. Verwandeln Sie Ihre Unternehmensdaten in präzise, umsetzbare Antworten',
  [T.analysisPlaceHolderTitle]: 'Sie haben keine Analyse durchgeführt!',
  [T.datasetPlaceHolderTitle]: 'Sie haben keinen Datensatz zur Verfügung!',
  [T.createDataset]: 'Datensatz erstellen',
  [T.questionnairePlaceHolderTitle]: 'Es ist kein Fragebogen verfügbar!',
  [T.createQuestionnaire]: 'Fragebogen erstellen',
  [T.startAnalysis]: 'Analyse starten',
  [T.uploadFilesText]:
    'Sie können Dokumente, Audios und Videos hochladen. (max. 100 MB)',
  [T.processingFiles]: 'Die hochgeladenen Dateien werden verarbeitet',
  [T.datasetDescription]:
    'Erstellen von Datasets für zu analysierende Dokumente',
  [T.inProgressAnalysis]: 'Analyse abbrechen',
  [T.inProgressAnalysisDescription]:
    'Die Antworten auf die verbleibende Frage werden nicht generiert, wenn die Analyse abgebrochen wird.?',
  [T.regeneratingResponse]: 'Regenerierende Reaktion',
  [T.updateQuestionnaire]: 'Fragebogen aktualisieren',
  [T.updateAssociatedQuestionnaireDescription]:
    'Fragebogen mit vorheriger Verknüpfung kann nicht aktualisiert werden.',
  [T.newQuestionnaireDescription]:
    'Speichern Sie eine neue Kopie des Fragebogens.',
  [T.saveNew]: 'Neu speichern',
  [T.analysisQuestionnaireUpdateLimit]:
    'Fragebögen, die mit anderen Analysen verbunden sind, können nicht aktualisiert werden.',
  [T.newAnalysisTooltip]: 'Analyse ist bereits im Gange',
  [T.analysisDetail]: 'Analyse Detail',
  [T.selectDataset]: 'Datensatz auswählen',
  [T.selectQuestionnaire]: 'Fragebogen auswählen',
  [T.docAnalystDuplicationError]:
    'Es existiert bereits ein Artikel mit demselben Titel.',
  [T.edited]: 'Bearbeitet',
  [T.generating]: 'Generieren',
  [T.updateQuestionnairePending]: 'Aktualisierung Fragebogen ausstehend',
  [T.updateQuestionnairePendingDescription]:
    'Bitte aktualisieren Sie den Fragebogen vor dem Verlassen.',
  [T.dateCreated]: 'Datum der Erstellung',
  [T.clearAll]: 'Alle löschen',
  [T.questionnaireAssociationMsg]: `Sie können den Fragebogen aufgrund seiner Verbindung mit der Analyse nicht bearbeiten.`,
  [T.questionnaireName]: 'Fragebogenname',
  [T.enterQuestionnaireName]: 'Fragebogennamen eingeben',
  [T.updateQuestionnaireDescription]:
    'Fragebogen ist aktualisiert. Klicken Sie auf „Aktualisieren“, um die Änderungen zu speichern.',
  [T.updateQuestionnaireDialogTitle]: 'Änderungen im Fragebogen speichern',
  [T.createdOn]: 'Erstellt am',
  [T.datasetDeletedTooltip]:
    'Der Originaldatensatz wurde vom Eigentümer gelöscht / geändert.',
  [T.mainFeatures]: 'Hauptfunktionen',
  [T.model]: 'Modell',
  [T.fromDate]: 'Von Datum',
  [T.sendQuestionnaire]: 'Fragebogen senden',
  [T.sentTo]: 'Gesendet an',
  [T.questionnaireSendSuccess]: 'Fragebogen erfolgreich gesendet',
  [T.receivedFrom]: 'Erhalten von',
  [T.questionnaireNotSharedYet]: 'Noch nicht mit jemandem geteilt.',
  [T.sentHistory]: 'Gesendete Geschichte',
  [T.byMe]: 'Von mir',
  [T.all]: 'Alle',
  [T.filesDeletedInDatasetDisclaimer]: 'Einige Dateien wurden gelöscht.',
  [T.allFilesDeletedInDatasetDisclaimer]:
    'Alle Dateien im Datensatz wurden gelöscht.',
  [T.resourceName]: 'Ressourcenname',
  [T.received]: 'Empfangen',
  [T.usageLimitReached]:
    'Nutzungslimit erreicht. Versuche es um {{availableAt}} erneut.',
  [T.docAnalystUsageLimitReached]:
    'Nutzungslimit erreicht. Bitte versuche es später erneut.',
  [T.simpleAnalysis]: 'Einfache Analyse',
  [T.scoringAnalysis]: 'Bewertungsanalyse',
  [T.statistics]: 'Statistiken',
  [T.responseRanges]: 'Antwortbereiche zwischen',
  [T.goodResponse]: '81 % – 100 % für gut',
  [T.averageResponse]: '51 % – 80 % für durchschnittlich',
  [T.badResponse]: '0 % – 50 % für schlecht',
  [T.goodResponses]: 'Gute Antworten',
  [T.averageResponses]: 'Durchschnittliche Antworten',
  [T.badResponses]: 'Schlechte Antworten',

  //Smart Meet
  [T.regenerate]: 'Regenerieren',
  [T.short]: 'Kurz',
  [T.medium]: 'Mittel',
  [T.detailed]: 'Detailliert',
  [T.playRecording]: 'Aufnahme abspielen',
  [T.resumeRecording]: 'Aufnahme fortsetzen',
  [T.maxTwoHours]: '(Maximal 2 Stunden)',
  [T.uploadRecording]: 'Aufnahme hochladen',
  [T.askAboutConversation]: 'Fragen Sie Empower zu diesem Gespräch',
  [T.deleteMeetingSuccess]: 'Meeting erfolgreich gelöscht!',
  [T.deleteMeetingError]: 'Fehler beim Löschen des Meetings.',
  [T.notesParsingError]: "Errore nell'analisi delle note",
  [T.stopRecordingError]: 'Fehler beim Stoppen der Aufnahme.',
  [T.storageUnavailableError]:
    'Browser-Speicher ist nicht verfügbar. Bitte überprüfen Sie Ihre Browsereinstellungen und den Speicher.',
  [T.transcriptionGenerationError]:
    'Fehler bei der Generierung der Transkription.',
  [T.summaryRegenerationAlert]:
    'Möchten Sie wirklich fortfahren? Dadurch werden Ihre Besprechungsdaten neu generiert.',
  [T.transcriptRegenerationAlert]:
    'Sind Sie sicher, dass Sie fortfahren möchten? Dadurch werden die Audio- und Datenaufzeichnungen des Meetings erneut verarbeitet.',
  [T.askEmpowerNoDataAlert]:
    'Der Chat ist für geteilte Besprechungen nicht verfügbar.',
  [T.discard]: 'Verwerfen',
  [T.meetingDeleteConfirmation]:
    'Sind Sie sicher, dass Sie dieses Meeting löschen möchten?',
  [T.discardMeetingAlert]:
    'Sind Sie sicher, dass Sie diese Meeting verwerfen möchten? Alle Daten gehen verloren.',
  [T.failedFetchingMeetings]: 'Fehler beim Abrufen der Besprechungen.',
  [T.fileProcessingRequestSubmitted]:
    'Ihre Datei wurde zur Verarbeitung in die Warteschlange gestellt.',
  [T.fileProcessingStarted]: 'Ihre Datei wird verarbeitet.',
  [T.fileProcessingCompleted]: 'Dateiverarbeitung abgeschlossen.',
  [T.embeddingsDeletionRequestSubmitted]:
    'Bereinigung der Besprechungsdaten angefordert.',
  [T.embeddingsDeletionStarted]:
    'Vorherige Verarbeitungsergebnisse werden gelöscht.',
  [T.embeddingsDeletionCompleted]:
    'Vorherige Besprechungsdaten wurden entfernt.',
  [T.smJobInitiationError]:
    'Smart-Meet-Datengenerierung konnte nicht gestartet werden. Bitte klicken Sie auf Erneut versuchen.',
  [T.transcriptionNotFoundError]:
    'Transkription für diese Besprechung konnte nicht gefunden werden.',
  [T.processingMeetingGenericError]:
    'Beim Ausführen dieses Schritts ist ein Fehler aufgetreten. Bitte klicken Sie auf Erneut versuchen, um es erneut zu versuchen.',
  [T.meetingProcessingFailed]:
    'Die Verarbeitung der Besprechung ist fehlgeschlagen. Bitte klicken Sie auf Erneut versuchen, um es erneut zu versuchen.',

  [T.genericNameError]: 'Fehler beim Generieren des Namens',
  [T.smartMeet]: 'Smart Meet',
  [T.newRecording]: 'Neue Aufnahme',
  [T.processRecording]: 'Aufnahme verarbeiten',
  [T.enterTitle]: 'Titel eingeben',
  [T.resume]: 'Fortsetzen',
  [T.pause]: 'Pause',
  [T.resume]: 'Fortsetzen',
  [T.summaryDescription]:
    'Fassen Sie die wichtigsten Punkte des Meetings zusammen, einschließlich Aktionspunkten und Verantwortlichkeiten.',
  [T.summaryMeeting]:
    'Fassen Sie Besprechungen zusammen und erstellen Sie in Sekundenschnelle Aktionspunkte.',
  [T.exportToPdf]: 'In PDF exportieren',
  [T.exportToExcel]: 'In Excel exportieren',
  [T.meetings]: ' Besprechungen',
  [T.thisMeet]: 'Dieses Meeting',
  [T.thisMeetTooltip]:
    'Fassen Sie Besprechungen zusammen und erstellen Sie in Sekundenschnelle Aktionspunkte.',
  [T.askSmartMeet]: 'Smart Meet',
  [T.askSmartMeetTooltip]:
    'Stellen Sie Fragen, lassen Sie sich Zusammenfassungen geben und finden Sie Informationen aus allen Sitzungen. ',
  [T.record]: 'Aufnehmen',
  [T.notes]: 'Anmerkungen',
  [T.stop]: 'Stopp',
  [T.addNotes]: 'Notizen hinzufügen',
  [T.summary]: 'Zusammenfassung',
  [T.transcript]: 'Transkript',
  [T.actionItems]: 'Maßnahmen',
  [T.renameSpeakers]: 'Teilnehmer umbenennen',
  [T.nameYourAttendees]: 'Benennen Sie Ihre Teilnehmer',
  [T.speakerDescription]:
    'In Ihrer Aufnahme gab es {{count}} Sprecher. Benennen Sie Ihre Sprecher, um sie leichter identifizieren zu können.',
  [T.tagSpeakers]: 'Tag-Lautsprecher',
  [T.browseToSelectAudioFiles]: 'Durchsuchen, um Audiodateien auszuwählen',
  [T.onlyMP3FilesAllowed]: 'Es sind nur MP3-Dateien erlaubt.',
  [T.meetingPurpose]: 'Zweck des Treffens',
  [T.keyTakeaways]: 'Wichtige Erkenntnisse',
  [T.addTakeAway]: 'Takeaway hinzufügen',
  [T.topics]: 'Themen',
  [T.nextSteps]: 'Nächste Schritte',
  [T.addSteps]: 'Nächste Schritte hinzufügen',
  [T.noActionItemsFound]: 'Keine Aktionspunkte gefunden',
  [T.noTranscriptionAvailable]: 'Keine Transkription verfügbar.',
  [T.noSummaryAvailable]: 'Keine Zusammenfassung verfügbar',
  [T.inProgressRecordingHeader]: 'Doppelklicken Sie, um den Titel festzulegen.',
  [T.maxRecordingAllowed]: 'Maximale Aufnahmedauer von 120 Minuten erlaubt',
  [T.meetingSummary]: 'Meeting-Zusammenfassung',
  [T.noMeetingPurpose]: 'Kein Besprechungszweck angegeben.',
  [T.noKeyTakeaways]: 'Keine wichtigen Erkenntnisse angegeben.',
  [T.topicsDiscussed]: 'Diskutierte Themen',
  [T.noTopicsListed]: 'Keine aufgelisteten Themen.',
  [T.noTextAvailable]: 'Kein Text verfügbar.',
  [T.noActionItemsRecorded]: 'Keine Maßnahmen aufgezeichnet.',
  [T.noNotesRecorded]: 'Keine Notizen aufgezeichnet.',
  [T.noThoughtProcessRecorded]: 'Kein Denkprozess aufgezeichnet.',
  [T.failedToCreate]: 'Fehler beim Erstellen ',
  [T.failedToUpdate]: 'Aktualisierung fehlgeschlagen',
  [T.updatingMeeting]: 'Besprechung wird aktualisiert',
  [T.regeneratingMeeting]: 'Besprechung wird rigeneriert',
  [T.meetingBeingProcessed]: 'Besprechung wird verarbeitet',
  [T.stoppingRecording]: 'Aufnahme wird gestoppt',
  [T.stoppedRecording]: 'Aufnahme gestoppt.',
  [T.generatingTranscript]: 'Transkript wird generiert',
  [T.generatedTranscript]: 'Transkript generiert.',
  [T.uploadingAudio]: 'Audio wird hochgeladen',
  [T.uploadedAudio]: 'Audio hochgeladen.',
  [T.processingAudio]: 'Audio wird verarbeitet',
  [T.processedAudio]: 'Audio verarbeitet.',
  [T.generatingData]: 'Daten werden generiert',
  [T.generatingMeetingData]: 'Besprechungsdaten werden generiert',
  [T.generatedMeetingData]: 'Besprechungsdaten generiert.',
  [T.meetingCreated]: 'Besprechung erstellt.',
  [T.meetingCreatedDone]: 'Besprechung erstellt.',
  [T.meetingSharedSuccessfully]: 'Besprechung erfolgreich geteilt.',
  [T.recording]: 'Aufnahme...',
  [T.fileNotProcessed]: 'Datei kann nicht verarbeitet werden',
  [T.draftMeetingTooltip]:
    'Diese Besprechung ist als Entwurf gespeichert und kann nicht geöffnet werden.',
  [T.noExistingMeeting]: 'Keine vorhandene Besprechung gefunden.',
  [T.noExistingMeetingDescription]:
    'Importieren Sie eine Datei oder nehmen Sie eine neue Besprechung auf, um Ihr nächstes SmartMeet zu starten.',
  [T.restrictedLimitSmartMeetUpload]:
    'Sie können jeweils nur eine Datei hochladen.',
  [T.askAnything]: 'Fragen Sie alles',
  [T.actionItemsQuery]:
    'Welche Maßnahmen oder nächsten Schritte wurden während des Meetings festgelegt?',
  [T.participantsQuery]:
    'Wie können die Teilnehmer die in der Sitzung angesprochenen Themen weiterverfolgen?',
  [T.mainTopicsQuery]:
    'Was waren die Hauptthemen, die in der Sitzung besprochen wurden?',
  [T.mainTopicsQueryMultiple]:
    'Was waren die Hauptthemen, die in den Sitzungen besprochen wurden?',
  [T.summarizeMeetingQuery]:
    'Können Sie die Sitzung in wenigen Sätzen zusammenfassen?',
  [T.askAboutYourMeeting]: 'Fragen Sie EGPT alles zu diesem Gespräch!',
  [T.askAboutYourMeetings]: 'Fragen Sie EGPT alles zu Ihren Meetings!',
  [T.uploadInProgressWarning]:
    'Ein Upload läuft gerade. Möchten Sie die Seite wirklich verlassen?',
  [T.transcriptInProgressWarning]:
    'Die Transkription läuft gerade. Möchten Sie die Seite wirklich verlassen?',

  // Data Analyst
  [T.dataAnalyst]: 'Datenanalyst',
  [T.dataAnalysis]: 'Datenanalyst Analyse',
  [T.dataAnalystInfo]:
    'Analysieren Sie Ihre Daten mit KI-gestützten Erkenntnissen',
  [T.dataAnalystDescription]:
    'Ihr All-in-One-Gen-AI-Experte zur Analyse von Unternehmensdaten mit benutzerdefinierten Abfragen.',
  [T.noExistingAnalysis]: 'Keine vorhandene Analyse gefunden.',
  [T.noExistingAnalysisDescription]:
    'Starten Sie eine neue Analyse und chatten Sie mit Ihren Unternehmensdaten!',
  [T.dataAnalystWelcomeTitle]:
    'Laden Sie Ihre Excel-Datei hoch und beginnen wir mit der Analyse!',

  // Document Analysis statuses
  [T.L_DA_CM]: 'Abgeschlossen',
  [T.L_DA_IP]: 'Inprogress',
  [T.L_DA_CN]: 'Abgesagt',
  [T.L_DA_FL]: 'Gescheitert',
  [T.L_DA_PC]: 'Teilweise fertiggestellt',
  [T.L_DA_RGR]: 'Regenerierung',
  [T.L_DA_DR]: 'Entwurf',

  // Assistants
  [T.assistants]: 'Assistenten',
  [T.allAssistant]: 'Alle',
  [T.createdByMe]: 'Von mir erstellt',
  [T.creator]: 'Ersteller',
  [T.createAssistant]: 'Assistent erstellen',
  [T.updateAssistant]: 'Assistent aktualisieren',
  [T.assistantName]: 'Assistentenname',
  [T.assistantDescription]: 'Assistentenbeschreibung',
  [T.assistantInstructions]: 'Assistentenanweisungen',
  [T.assistantModal]: 'Assistentenmodal',
  [T.assistantCreatedSuccessfully]: 'Assistent erfolgreich erstellt',
  [T.assistantUpdatedSuccessfully]: 'Assistent erfolgreich aktualisiert',
  [T.assistantDeletedSuccessfully]: 'Assistent erfolgreich gelöscht',
  [T.deleteAssistantTitle]: 'Assistent löschen',
  [T.deleteAssistantConfirmation]:
    'Möchten Sie den Assistenten wirklich löschen?',
  [T.deleteAssistantConfirmButton]: 'Ja, löschen',
  [T.noDescriptionAvailable]: 'Keine Beschreibung verfügbar',
  [T.assistantNotReadyDisclaimer]:
    'Dieser Assistent kann noch keinen Chat starten – er benötigt eine Wissensquelle und ein aktiviertes KI-Modell.',
  [T.noFilePermissionDisclaimer]:
    'Sie haben keine Berechtigung für einige Wissensressourcen dieses Assistenten, daher werden sie nicht verwendet.',
  [T.iconUploadedSuccessfully]: 'Symbol erfolgreich hochgeladen',
  [T.namePlaceholder]: 'Geben Sie Ihrem Assistenten einen Namen',
  [T.descriptionPlaceholder]:
    'Fügen Sie eine kurze Beschreibung über diesen Assistenten hinzu.',
  [T.instructions]: 'Anweisungen',
  [T.instructionsPlaceholder]:
    'Was macht dieser Assistent? Wie sollte er sich verhalten? Was sollte er vermeiden?',
  [T.conversationStarters]: 'Gesprächsanfänge',
  [T.conversationStartersErrorMessage]:
    'Gesprächsanfänge dürfen nicht leer sein',
  [T.conversationStartersPlaceholder]:
    'Beispielaufforderungen für den Benutzer, um das Gespräch zu beginnen.',
  [T.aiModels]: 'KI-Modelle',
  [T.aiModelsPlaceholder]: 'Wählen Sie ein beliebiges KI-Modell',
  [T.personaPlaceholder]: 'Persona auswählen',
  [T.knowledgeAddFiles]: 'Unternehmenswissen (Dateien hinzufügen)',
  [T.addFiles]: 'Dateien hinzufügen',
  [T.knowledgeAddFilesUploaded]:
    '{{totalFiles}}/{{filesLimit}} Dateien hochgeladen',
  [T.enterpriseKnowledge]: 'Unternehmenswissen',
  [T.worldKnowledgeWithWebSearch]: 'Weltwissen mit Websuche',
  [T.knowledge]: 'Wissen',
  [T.addAllWorkspaceContent]: 'Gesamten Workspace-Inhalt hinzufügen',
  [T.addKnowledge]: 'Wissen hinzufügen',
  [T.addKnowledgeDescription]:
    'Laden Sie Dokumente, Texte oder Code hoch, oder durchsuchen Sie vorhandene Besprechungen und Dateien und fügen Sie sie hinzu',
  [T.defaultEnabled]: 'Standardmäßig aktiviert',
  [T.worldKnowledgeDescription]:
    'Lassen Sie den Assistenten Weltwissen nutzen, um Ihre Anfragen zu beantworten.',
  [T.enterpriseKnowledgeDescription]:
    'Lassen Sie den Assistenten alle geteilten Integrationen, Dateien und anderen Assets im Workspace nutzen.',
  [T.conversationStartersCount]: '{{totalCon}}/6 hinzugefügt',
  [T.getStartedByCreatingNewAssistant]:
    'Erstellen Sie einen neuen Assistenten, um zu beginnen',
  [T.noAssistantsEmptyStateDescription]:
    'Sie haben noch keinen Assistenten. Erstellen Sie Assistenten, die durch Anweisungen, Wissen und Multi-Task-Workflows angetrieben werden.',
  [T.loadingAssistants]: 'Assistenten werden geladen...',
  [T.loadingAssistant]: 'Assistent wird geladen...',
  [T.newAssistant]: 'Neuer Assistent',
  [T.selectPersona]: 'Persona auswählen',
  [T.none]: 'Keine',
  [T.selectPersonaDescription]:
    'Wählen Sie eine vordefinierte Persona, um die Anweisungen vorauszufüllen.',
  [T.purposeInstructions]: 'Zweck (Anweisungen)',
  [T.writePurposeInstructionsPlaceholder]:
    'Beschreiben Sie den Zweck, z. B. was dieser Assistent tut, wie er sich verhalten soll und was er vermeiden soll.',
  [T.describeYourAssistantOptional]:
    'Beschreiben Sie Ihren Assistenten (optional)',
  [T.configureTabLabel]: 'Konfigurieren',
  [T.knowledgeTabLabel]: 'Wissen',
  [T.accessTabLabel]: 'Zugriff',
  [T.assistantPageTitle]: 'Assistent',
  [T.assistantPageDescription]:
    'Optimieren Sie Ihren Workflow. Lassen Sie KI-Assistenten Onboarding, Compliance und mehr übernehmen – damit Sie es nicht tun müssen.',
  [T.assistantNameRequired]: 'Der Name des Assistenten ist erforderlich',
  [T.noChangesToSave]: 'Keine Änderungen zum Speichern',
  [T.savingInProgress]: 'Speichern läuft...',
  [T.nameMinLengthError]: 'Der Name muss mindestens 3 Zeichen lang sein',
  [T.nameMaxLengthError]: 'Der Name darf 100 Zeichen nicht überschreiten',
  [T.descriptionMaxLengthError]:
    'Die Beschreibung darf 500 Zeichen nicht überschreiten',
  [T.instructionsMaxLengthError]:
    'Die Anweisungen dürfen 12000 Zeichen nicht überschreiten',
  [T.starterMaxLengthError]: 'Der Starter darf 200 Zeichen nicht überschreiten',
  [T.maxConversationStartersError]: 'Maximal 6 Gesprächsstarter erlaubt',
  [T.assistantPreviewNoFiles]:
    'Bitte fügen Sie Dateien zur Unternehmens-Wissensdatenbank des Assistenten hinzu, um einen Chat zu starten.',
  [T.preview]: 'Vorschau',
  [T.chooseEmojis]: 'Bild auswählen',
  [T.keepItPrivate]: 'Halten Sie es privat',
  [T.emojiDisclaimer]:
    'Um ein Emoji hochzuladen, sollte es weniger als 500 Kb groß sein',
  [T.assistantFilesPermission]:
    'Sie haben keinen Zugriff auf die folgenden Dateien',
  [T.assistantNoFiles]:
    'Die Wissensdateien des Assistenten für Unternehmen wurden gelöscht',
  [T.noFilesDisclaimer]:
    'Dateien, die zum Wissen des Assistenten hinzugefügt wurden, sind aus den Arbeitsbereichen gelöscht worden. Assistant-Controller können neue Dateien hinzufügen oder die Fähigkeiten des Assistant ändern, um einen neuen Chat mit ihm zu starten.',
  [T.addFileDisclaimer]:
    'Stellen Sie sicher, dass hinzugefügte Dateien im Wissen für Benutzer zugänglich sind, mit denen sie geteilt werden',
  [T.errorConfirmationDialog]:
    'Bitte beheben Sie die folgenden Fehler, bevor Sie fortfahren',
  [T.assistantDeletedDisclaimer]:
    'Sie können den Chat mit einem gelöschten Assistenten nicht fortsetzen.',
  [T.outdatedVersionText]: `Sie können mit einer veralteten Version dieses Assistenten nicht weiter chatten. Starten `,
  [T.revokedVersionText]:
    'Der Zugriff auf die Wissensdateien des Assistenten wurde widerrufen. Sie können nicht weiter chatten. Klicken Sie ',
  [T.revokedAssistantPermission]:
    'Der Zugriff auf den Assistenten wurde widerrufen. Sie können nicht weiter chatten. ',
  [T.customizeAssistant]:
    'Passen Sie die Antworten des KI-Modells an Ihre spezifischen Anwendungsfälle an.',
  [T.newChat]: 'neuer Chat',
  [T.here]: 'hier',
  [T.revokedAssistant]: ' um die Dateien anzuzeigen.',
  [T.updatedAssistant]: ` mit dem aktualisierten Assistenten.`,
  [T.assistantUniqueViolationError]:
    'Assistent mit demselben Namen existiert bereits',
  [T.noAiModelDisclaimer]:
    'Das KI-Modell des Assistenten wurde vom Administrator deaktiviert. Assistenten-Kontrolleure können ihm entweder ein neues Modell zuweisen oder den Administrator-Zugriff auf das deaktivierte Modell anfordern, um einen neuen Chat zu starten.',
  [T.noAiModelTitle]: 'Konfiguriertes AI-Modell deaktiviert',
  [T.stayOnThisPage]: `Auf dieser Seite bleiben`,
  [T.aiModelErrorMessage]: `Bitte wählen Sie ein AI-Modell aus`,
  [T.aiModelDisabledTooltip]: 'Modell unterstützt keine Bilder als Anhänge.',
  [T.createUpdateConfirmationDialogTitle]: `Nicht gespeicherte Änderungen`,
  [T.leaveWithoutSaving]: `Ohne Speichern verlassen`,
  [T.createUpdateConfirmationDisclaimer]: `Sie sind dabei, diese Seite mit nicht gespeicherten Änderungen zu verlassen.`,
  [T.discardChangesTitle]: `Änderungen verwerfen?`,
  [T.discardChangesDisclaimer]: `Sie verlassen diese Seite mit nicht gespeicherten Änderungen. Alle Fortschritte gehen verloren.`,
  [T.addImage]: `Bild hinzufügen`,
  [T.changeImage]: `Bild ändern`,
  [T.uploadOrChooseAnImage]: `Bild hochladen oder auswählen`,
  [T.close]: 'Schließen Sie',
  [T.assistantDeleted]: 'Assistentin Gelöscht',
  [T.conversationStarterErrorMessage]:
    'Assistent Starter darf nicht länger als 300 Zeichen sein',
  [T.viewMore]: 'Mehr sehen',
  [T.viewLess]: 'Weniger sehen',
  [T.assistantSelfAssignmentError]:
    'Selbstzuweisung/Unzuweisung einer Ressource ist nicht erlaubt!',
  [T.chatUnavailable]: 'Chat nicht verfügbar',
  [T.shareUsingLink]: 'Mit Link teilen',
  [T.linkCopied]: 'Link kopiert',
  [T.shareAssistantInviteDescription]:
    'Laden Sie Ihre Teamkollegen ein und teilen Sie die Verantwortung für diesen Agenten.',
  [T.roleDescription]: 'Rolle für EmpowerGPT-Benutzer mit dem Link',
  [T.errorGeneratingLink]: 'Fehler beim Generieren des Links',
  [T.customLicense]: 'Benutzerdefinierte Lizenz',
  [T.creditsPerMonth]: 'Credits pro Monat',
  [T.autoExpiry]: 'Automatisches Ablaufdatum',
  [T.filesUploadLimit]: 'Datei-Upload-/Importlimit auf einmal',
  [T.userLimit]: 'Benutzerlimit',
  [T.maxSearchPlus]: 'Search+-Limit (pro Monat)',
  [T.workflowRuns]: 'Workflow-Ausführungen (pro Monat)',
  [T.workflowCredits]: 'Workflow-Credits (%)',
  [T.workflowRunsRequired]: 'Workflow-Ausführungen sind erforderlich',
  [T.percentageRange]: 'Geben Sie einen Wert zwischen 0 und 100 ein',
  [T.maxDocAnalystAnalysis]: 'Doc-Analyst-Analysen (pro Monat)',
  [T.maxDocAnalystQuestionPerAnalysis]: 'Doc-Analyst-Fragen pro Analyse',
  [T.maxOcrFiles]: 'OCR-Dateien (pro Monat)',
  [T.maxSmartMeetDurationSecs]:
    'Dauer der Smart-Meet-Sitzungen (Sekunden, pro Monat)',
  [T.maxDataAnalystQuery]: 'Data-Analyst-Abfragen (pro Monat)',
  [T.unlimitedAccess]: 'Unbegrenzt',
  [T.createTenants]: 'Mandanten erstellen',
  [T.maxExpiryDateError]:
    'Das Ablaufdatum sollte höchstens 1 Monat ab heute betragen.',
  [T.tenantPlan]: 'Mandantenplan',
  [T.expiryDays]: 'Ablauftage erforderlich',
  [T.fileUploadLimit]: 'Datei-Upload-Limit ist erforderlich',
  [T.userLimitRequired]: 'Benutzerlimit ist erforderlich',
  [T.expiryDate]: 'Läuft ab am',
  [T.expiryDateRequired]: 'Ablaufdatum ist erforderlich',
  [T.trialExpiryMaxOneMonth]:
    'Das Ablaufdatum der Testversion darf höchstens einen Monat in der Zukunft liegen',
  [T.license]: 'Lizenz',

  [T[PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT]]: 'Projektmanager-Assistent',
  [T[PERSONA_TYPE.DEVELOPER_COMPANION]]: 'Entwickler-Begleiter',
  [T[PERSONA_TYPE.STUDENT_STUDY_BUDDY]]: 'Studienbegleiter',
  [T[PERSONA_TYPE.SALES_CRM_STRATEGIST]]: 'Vertriebs & CRM-Stratege',
  [T[PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST]]: 'Wissensmanagement-Analyst',
  [T[PERSONA_TYPE.EXECUTIVE_ASSISTANT]]: 'Vorstandsassistent',
  [T[PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER]]: 'Support-Agent-Trainer',

  [T[`${PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT}-desc`]]:
    'Ich bin der Projektmanager. Ich möchte Fristen einhalten, Lieferungen verfolgen und eine reibungslose Zusammenarbeit zwischen Teams gewährleisten. Ich helfe dir, komplexe Projekte mühelos zu verwalten, indem ich Aufgaben organisiere, Meetings zusammenfasse und alle auf dem gleichen Stand halte.',

  [T[`${PERSONA_TYPE.DEVELOPER_COMPANION}-desc`]]:
    'Ich bin der Entwickler-Begleiter. Ich möchte sauberen Code schreiben, Fehler schneller beheben und nie blockiert sein. Ich unterstütze dich beim Erklären von Code, Generieren von wiederverwendbaren Snippets und beim effizienten Umgang mit deinem Tech-Stack und der Dokumentation.',

  [T[`${PERSONA_TYPE.STUDENT_STUDY_BUDDY}-desc`]]:
    'Ich bin dein Studienbegleiter. Ich möchte schwierige Themen verstehen, mich gut auf Prüfungen vorbereiten und beim Lernen organisiert bleiben. Ich helfe dir, komplexe Konzepte aufzubrechen, Notizen zusammenzufassen und personalisierte Lernmaterialien zu erstellen.',

  [T[`${PERSONA_TYPE.SALES_CRM_STRATEGIST}-desc`]]:
    'Ich bin der Vertriebsstratege. Ich möchte starke Kundenbeziehungen aufbauen und schneller Abschlüsse erzielen. Ich helfe dir, CRM-Daten zusammenzufassen, überzeugende Nachrichten zu entwerfen und Einblicke zu liefern, die deine Verkaufsleistung verbessern.',

  [T[`${PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST}-desc`]]:
    'Ich bin der Wissensanalyst. Ich möchte internes Wissen sauber, zugänglich und nützlich für das ganze Team halten. Ich helfe dir, schneller Antworten zu finden, Dokumentationen klar zu halten und deine Wissensdatenbank optimal zu strukturieren.',

  [T[`${PERSONA_TYPE.EXECUTIVE_ASSISTANT}-desc`]]:
    'Ich bin der Vorstandsassistent. Ich möchte sicherstellen, dass nichts übersehen wird – von wichtigen Meetings bis hin zu strategischen Entscheidungen. Ich helfe dir, indem ich Mitteilungen verfasse, Berichte zusammenfasse und deinen Kalender verwalte, damit du dich auf das Wesentliche konzentrieren kannst.',

  [T[`${PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER}-desc`]]:
    'Ich bin der Support-Trainer. Ich möchte schnellen, genauen und konsistenten Kundensupport bieten. Ich helfe dir, indem ich Support-Tickets analysiere, klare Antworten formuliere und Schulungsmaterialien für dein Support-Team vorbereite.',

  // Confluence
  [T.contentImportFromConfluence]: 'Atlassian Confluence',
  [T.confluenceModalTitle]: 'Inhalte aus Confluence importieren',
  [T.confluenceModalSubtitle]:
    'Navigieren Sie in Ihrem Confluence und wählen Sie die gewünschten Inhalte zum Importieren aus.',
  [T.confluenceMySpaces]: 'Meine Räume',
  [T.confluenceSharedSpaces]: 'Gemeinsam genutzte Räume',
  [T.openInConfluence]: 'In Confluence öffnen',
  [T.confluenceResourceProviderWelcomeTitle]:
    'Schritte zur Konfiguration des Imports aus Confluence',
  [T.confluenceWelcomeInstruction1]:
    'Details zum Admin-Konto der Atlassian-Organisation.',
  [T.confluenceWelcomeInstruction2]:
    'Erstellen und konfigurieren Sie eine OAuth 2.0-App im Atlassian Developer.',
  [T.confluenceWelcomeInstruction3]:
    'Geben Sie die Details für die erstellte Anwendung ein.',
  [T.confluenceWelcomeInstruction4]:
    'Fügen Sie der API-Scope der Anwendung die erforderlichen Berechtigungen hinzu.',
  [T.confluenceConfigurationSuccessTitle]: 'Import aus Confluence konfiguriert',
  [T.confluenceConfigurationSuccessDescription1]:
    'Inhalte können jetzt als Sammlungen aus Confluence in EmpowerGPT importiert werden.',
  [T.confluenceConfigurationSuccessDescription2]:
    'Die Sichtbarkeit der importierten Inhalte richtet sich nach den Berechtigungen in Confluence.',
  [T.confluenceAdminConfigurationStep1Start]:
    'Öffnen Sie in einem neuen Tab die ',
  [T.atlassianManagementText]:
    'API-Token-Verwaltungsseite des Atlassian-Kontos.',
  [T.confluenceAdminConfigurationStep1End]:
    ' Stellen Sie sicher, dass Sie sich mit dem Admin-Konto der Atlassian-Organisation anmelden.',
  [T.confluenceAdminConfigurationStep2]:
    'Klicken Sie auf die Schaltfläche „API-Token erstellen“ und geben Sie einen geeigneten Namen wie „EmpowerGPT - [Firmenname]“ ein.',
  [T.confluenceAdminConfigurationStep3]:
    'Nach dem Erstellen können Sie das API-Token kopieren. Fügen Sie das API-Token zusammen mit der E-Mail-Adresse des angemeldeten Admins ein.',
  [T.apiTokenRequired]: 'API-Token ist erforderlich',
  [T.apiToken]: 'API-TOKEN',
  [T.confluenceAdminConfigurationStep4]:
    'Fügen Sie unten die Basis-URL für die Atlassian-Anwendungen Ihrer Organisation ein. (Zum Beispiel: Wenn Ihre Organisation Contoso heißt, lautet die Basis-URL https://contoso.atlassian.net/wiki)',
  [T.invalidConfluenceUrl]: 'Ungültige Confluence-Basis-URL angegeben.',
  [T.confluenceStep1Title]:
    'Details zum Admin-Konto der Atlassian-Organisation',
  [T.atlassianBaseUrl]: 'Atlassian-Basis-URL',
  [T.confluenceStep2Title]:
    'Erstellen und konfigurieren Sie eine OAuth 2.0-App im Atlassian Developer',
  [T.confluenceStep2Instruction1Start]:
    'Melden Sie sich in einem neuen Tab bei ',
  [T.confluenceStep2Instruction1End]: 'Atlassian Developer an.',
  [T.confluenceStep2Instruction2]:
    'Sobald Sie angemeldet sind, klicken Sie im Menü oben rechts auf „Benutzermenü“ und wählen Sie „Entwicklerkonsole“ aus.',
  [T.confluenceStep2Instruction3]:
    'Klicken Sie im Abschnitt „Meine Apps“ auf die Schaltfläche „Erstellen“ und wählen Sie „OAuth 2.0-Integration“ aus dem Dropdown-Menü aus.',
  [T.confluenceStep2Instruction4]:
    'Geben Sie einen geeigneten Namen für die Anwendung ein, z. B. „EmpowerGPT - [Firmenname]“. Aktivieren Sie das Kontrollkästchen, um den Entwicklerbedingungen von Atlassian zuzustimmen, und klicken Sie auf „Erstellen“.',
  [T.confluenceStep2Instruction5]:
    'Nach erfolgreicher Erstellung landen Sie auf der „Übersicht“-Seite der Anwendung. Navigieren Sie zur Seite „Autorisierung“ und klicken Sie auf die Schaltfläche „Hinzufügen“ neben „OAuth 2.0 (3LO)“, um die Benutzerautorisierung zu aktivieren.',
  [T.confluenceStep2Instruction6]:
    'Fügen Sie die folgende URL in das Feld „Callback-URL“ ein und klicken Sie auf „Änderungen speichern“.',
  [T.callBackUrl]: 'Callback-URL',
  [T.confluenceStep2Instruction7]:
    'Navigieren Sie jetzt zur Seite „Verteilung“ und klicken Sie auf „Bearbeiten“ vor dem Abschnitt „Verteilungskontrollen“. Ändern Sie den Verteilungsstatus auf „Freigabe“.',
  [T.confluenceStep2Instruction8]:
    'Fügen Sie Ihren Firmennamen als Anbietername hinzu und fügen Sie den folgenden Link in das Feld Datenschutzrichtlinie ein.',
  [T.privacyPolicy]: 'Datenschutzrichtlinie',
  [T.privacyPolicyRequired]: 'Datenschutzrichtlinie ist erforderlich',
  [T.confluenceStep2Instruction9]:
    'Wählen Sie „Nein“ im Dropdown-Menü „Speichert Ihre App personenbezogene Daten?“ und klicken Sie auf die Schaltfläche „Änderungen speichern“ am Ende.',
  [T.appCreationStepsPerformed]:
    'Alle oben genannten Schritte wurden im Atlassian Developer ausgeführt.',
  [T.confluenceStep3Title]:
    'Geben Sie die Details der erstellten Anwendung ein',
  [T.confluenceStep3Instruction1]: 'Navigieren Sie zur Seite „Einstellungen“.',
  [T.confluenceStep3Instruction2]:
    'Kopieren Sie die Client-ID und die Geheim-ID und geben Sie jede in das entsprechende Feld unten ein.',
  [T.clientId]: 'Client-ID',
  [T.clientSecret]: 'Geheimnis',
  [T.confluenceStep4Title]:
    'Fügen Sie der erstellten Anwendung die erforderlichen Berechtigungen hinzu',
  [T.confluenceStep4Instruction1]:
    'Navigieren Sie zur Seite „Berechtigungen“ und klicken Sie auf die Schaltfläche „Hinzufügen“ neben der Zeile „Confluence-API“. Die Schaltfläche „Hinzufügen“ sollte auf „Konfigurieren“ aktualisiert werden.',
  [T.confluenceStep4Instruction2]:
    'Klicken Sie auf die Schaltfläche „Konfigurieren“ und anschließend auf „Bereiche bearbeiten“ unter der Registerkarte „Klassische Bereiche“.',
  [T.confluenceStep4Instruction3]:
    'Wählen Sie die folgenden Berechtigungen aus, indem Sie das Kontrollkästchen in der Spalte „Auswählen“ aktivieren.',
  [T.confluenceStep4Instruction3a]: 'Confluence-Raumzusammenfassung lesen',
  [T.confluenceStep4Instruction3b]:
    'Zusammenfassung der Confluence-Inhalte lesen',
  [T.confluenceStep4Instruction3c]: 'Detaillierte Confluence-Inhalte lesen',
  [T.confluenceStep4Instruction4]:
    'Die obigen Schritte wurden in der erstellten Anwendung im Atlassian Developer ausgeführt.',
  [T.resourceProviderConfluenceEnabledSuccessfully]:
    'Confluence erfolgreich aktiviert.',
  [T.resourceProviderConfluenceDisabledSuccessfully]:
    'Confluence erfolgreich deaktiviert.',
  [T.errorUpdatingConfluence]: 'Fehler beim Aktualisieren von Confluence.',
  [T.resourceProviderConfluenceCreationFailed]:
    'Fehler beim Aktivieren von Confluence.',
  [T.viewDetails]: 'Details anzeigen',
  [T.hideDetails]: 'Details ausblenden',
  [T.authWindowClosed]: 'Das Authentifizierungsfenster wurde geschlossen.',
  [T.tokenExchangeFailed]: 'Token-Austausch fehlgeschlagen',
  [T.failedRefreshToken]: 'Aktualisierung des Zugriffstokens fehlgeschlagen',
  [T.errorDecodingToken]: 'Fehler beim Dekodieren des Tokens: ',
  [T.noWhitespaceAllowed]: 'Bitte entfernen Sie Leerzeichen',
  [T.browseToSelect]: 'Zum Auswählen durchsuchen',
  [T.browseToSelectDocs]: 'Zum Auswählen von Dokumenten durchsuchen',
  [T.viewDocuments]: 'Dokumente anzeigen',
  [T.selectAllFiles]: 'Komplette Arbeitsbereiche',
  [T.allEnterpriseKnowledgeInfo]:
    'Dieser Assistent hat Zugriff auf alle Inhalte in Ihren Arbeitsbereichen',
  [T.selectFromWorkspace]: 'Aus dem Arbeitsbereich auswählen',
  [T.selectFromWorkspaces]: 'Aus Arbeitsbereichen auswählen',
  [T.uploadUpToFiles]: 'Hochladen (bis zu {{ files }} Dateien)',
  [T.uploadFilesProgress]: 'Hochladen ({{ uploaded }}/{{ limit }} Dateien)',
  [T.uploadLimitReached]: 'Upload-Limit erreicht',
  [T.uploadNew]: 'Neu hochladen',
  [T.controller]: 'Controller',

  // Settings
  [T.systemSettings]: 'Systemeinstellungen',
  [T.security]: 'Sicherheit',
  [T.aboutYou]: 'Über Sie',
  [T.aboutYouSubtitle]:
    'Diese Informationen werden verwendet, um Ihr Erlebnis zu personalisieren',
  [T.companyName]: 'Name der Firma',
  [T.department]: 'Abteilung',
  [T.jobRole]: 'Berufsbezeichnung',
  [T.country]: 'Land',
  [T.deleteAccount]: 'Konto löschen',
  [T.deleteAccountInfo]:
    'Löschen Sie dauerhaft Ihr gesamtes Konto, die in „Mein Arbeitsbereich“ hochgeladenen Dokumente und Ihre Chats. Dieser Vorgang ist unumkehrbar.',
  [T.customInstructions]: 'Benutzerdefinierte Anweisungen',
  [T.enableForNewChats]: 'Für neue Chats aktivieren',
  [T.aboutYouLabel]:
    'Erzählen Sie EmpowerGPT von sich, um personalisiertere Antworten zu erhalten.',
  [T.aboutYouPlaceholder]:
    '- Was machen Sie hauptsächlich bei der Arbeit?\n- Was sind Ihre Hauptverantwortlichkeiten?',
  [T.giveInstructionsLabel]: 'Wie soll EmpowerGPT antworten?',
  [T.giveInstructionsPlaceholder]:
    '- Welchen Ton soll EmpowerGPT verwenden: formell oder informell?\n- Bevorzugte Länge der Antworten von EmpowerGPT: kurz oder ausführlich?',
  [T.changePasswordLabel]:
    'Ihr Passwort ist der Schlüssel zu Ihrem Konto. Stellen Sie sicher, dass es stark und sicher ist.',
  [T.settingsSavedSuccessfully]: 'Einstellungen erfolgreich gespeichert',
  [T.profileUpdatedSuccessfully]: 'Profil erfolgreich aktualisiert',

  // attach document and image
  [T.maxChatFileSize]:
    'Die Datei "{{ name }}" ist zu groß. Die maximale Größe für {{type}} beträgt "{{ size }}mb".',
  [T.maxUploadedFileSize]:
    'Einige Dateien überschreiten das Größenlimit für ihr Format.',

  [T.maxUploadFile]:
    'Die maximale Anzahl an angehängten Dateien beträgt "{{ files }}".',
  [T.unSupportedFile]:
    'Die Datei "{{ name }}" wurde aufgrund eines nicht unterstützten Formats nicht hochgeladen.',
  [T.webSearchOnMsg]:
    'Deaktivieren Sie die Websuche, um die Dateianhangsfunktion zu aktivieren',
  [T.chatFileName]: ' {{ status }} {{ name }}',
  [T.uploading]: 'Hochladen',
  [T.preparing]: 'Vorbereitung',
  [T.processing]: 'Verarbeitung',
  [T.processed]: 'Verarbeitet',
  [T.Unprocessed]: 'Nicht verarbeitet',
  [T.unsupportedFile]: 'Nicht unterstützte {{ name }}.',
  [T.uploadFailed]: 'UPLOAD_FEHLGESCHLAGEN',
  [T.retryMsg]: 'Fehler beim Hochladen von {{ name }}. Bitte erneut versuchen.',
  [T.documentRemoved]: 'Dokument erfolgreich entfernt',
  [T.unsupportedModelForImage]:
    'Das ausgewählte Modell unterstützt keine Bilder, wechseln Sie zu einem Modell, das die Bildanalyse unterstützt.',
  [T.modelUnavailableForChat]: `Das ausgewählte Modell wurde vom Administrator der Organisation deaktiviert. Bitte wechsle zu einem anderen verfügbaren Modell, um den Chat fortzusetzen.`,
  [T.uploadFailedText]: 'Upload fehlgeschlagen. Wiederholen Sie',
  [T.uploadingOrProcessingText]: '{{status}} Anhänge',
  [T.failedOrUnsupportedText]:
    'Fehler {{status}} Anhänge. Entfernen Sie Anhänge mit einem Fehler, um die Nachricht zu senden.',
  [T.switchToListView]: 'Zur Listenansicht wechseln',
  [T.switchToGridView]: 'Zur Rasteransicht wechseln',
  [T.perUserLimits]: 'Benutzerbezogene Limits',
  [T.noLimit]: 'Kein Limit',
  [T.modelUsageInChat]: 'Modellnutzung im Chat',
  [T.maximumQueriesLimit]: 'Maximale Anfragenbegrenzung in 3 Std.',
  [T.maximumAnalysisLimit]: 'Maximale Analysen in 3 Std.',
  [T.resetToDefault]: 'Auf Standard zurücksetzen',
  [T.fieldValidationMessage]:
    'Bitte geben Sie eine gültige Zahl größer als 0 ein.',
  [T.userLimitsUpdateSuccessMsg]:
    'Benutzerlimits wurden erfolgreich aktualisiert.',

  [T.filesInProcessTitle]: 'Assistenten-Wissensdateien werden verarbeitet.',
  [T.filesInProcessDesc]:
    'Der Chat ist vorübergehend nicht verfügbar, bis alle Assistenten-Wissensdokumente erfolgreich verarbeitet wurden. Folgende Dateien werden verarbeitet:',

  //PAYG
  [T.paygTitle]: 'Pay As You Go',
  [T.paygDescription]:
    'Vorausbezahlte Pay As You Go-Credits halten Ihr Team am Laufen, sobald es sein Nutzungslimit erreicht. Deaktivieren Sie dies, um jegliche Mehrnutzung sofort zu stoppen.',
  [T.paygCapReachedTitle]: 'Limit erreicht — KI-Funktionen sind blockiert.',
  [T.paygCapReachedDescription]:
    'Ihr Team hat den Zugang zu KI-Funktionen verloren. Es fallen keine zusätzlichen Kosten an. Aktualisieren Sie das Limit, um den Zugang wiederherzustellen.',
  [T.paygApproachingCapTitle]: 'Guthabenlimit fast erreicht — Aufladen.',
  [T.paygCapReachedPlanAvailableTitle]:
    'Limit erreicht — Pay As You Go-Credits aufgebraucht.',
  [T.paygCapReachedPlanAvailableDescription]:
    'Erhöhen Sie das Limit, um Pay As You Go für Ihr Team verfügbar zu halten.',
  [T.paygApproachingCapPlanLowTitle]:
    'Limit fast erreicht — auch die In-Plan-Credits gehen zur Neige.',
  [T.paygApproachingCapPlanLowDescription]:
    'Ihnen fehlen noch {{currency}}{{amount}} bis zum Limit und auch die In-Plan-Credits gehen zur Neige. Erhöhen Sie das Limit, um eine Sperrung zu vermeiden.',
  [T.paygApproachingCapDescription]:
    'Sie sind {{currency}}{{amount}} von Ihrem Limit entfernt. Bei aktuellem Verbrauch wird Ihr Team das Budget aufbrauchen. Erwägen Sie, es jetzt zu erhöhen.',
  [T.paygBalance]: 'Pay As You Go-Guthaben',
  [T.paygCreditsLimitExceedTooltip]:
    'Es ist ein zusätzlicher Pay As You Go-Kreditverbrauch von {{excess}} aufgetreten, der automatisch gegen alle im selben Monat getätigten Käufe verrechnet wird.',
  [T.paygInPlanCreditLimitReachedTooltip]:
    'Es ist ein zusätzlicher In-Plan-Kreditverbrauch von {{excess}} aufgetreten. Überverbrauchte In-Plan-Credits werden vom Pay As You Go-Guthaben abgezogen.',
  [T.creditsSpent]: 'Verbrauchte Credits',
  [T.purchasedOn]: 'Gekauft am',
  [T.expiresOn]: 'Läuft ab am',
  [T.paygNoCapSetTitle]: 'Kein Limit festgelegt',
  [T.paygNoCapSetDescription]:
    'Aktivieren Sie Pay As You Go, um ein Kreditlimit festzulegen und Mehrverbrauch automatisch abzudecken',
  [T.paygEnablePayAsYouGo]: 'Pay As You Go aktivieren',
  [T.paygEnableTitle]: 'Pay As You Go aktivieren',
  [T.paygEnableDescription]:
    'Wenn Ihr In-Plan-Guthaben aufgebraucht ist, laufen die KI-Funktionen weiter, indem sie auf Ihr vorausbezahltes Pay As You Go-Guthaben zugreifen.',
  [T.paygTopUp]: 'Aufladen',
  [T.paygTopUpAmount]: 'Aufladebetrag',
  [T.paygTopUpAmountHint]: 'Dieser Betrag versteht sich ohne Steuern.',
  [T.paygTopUpCredits]: 'Credits: {{credits}}',
  [T.paygTopUpCreditsTooltip]:
    'Nicht genutzte Guthaben bleiben verfügbar und können im nächsten Monat verwendet werden.',
  [T.paygMaxTopUpAmount]: 'Der maximale Aufladebetrag beträgt €{{max}}.',
  [T.paygPremiumFeaturesCap]: 'Nutzungslimit für Premium-Funktionen',
  [T.paygWorkflowLabel]: 'Workflow',
  [T.paygEditPremiumTitle]: 'Premium-Nutzungslimit bearbeiten',
  [T.paygEditPremiumDescription]:
    'Legen Sie fest, wie viel des Pay As You Go-Guthabens für Premium-Funktionen verwendet werden darf.',
  [T.paygEditPremiumSuccess]:
    'Nutzungslimit für Premium-Funktionen erfolgreich aktualisiert.',
  [T.paygEditPremiumFailed]:
    'Nutzungslimit für Premium-Funktionen konnte nicht aktualisiert werden.',
  [T.paygMonthlyCap]: 'Monatliches Limit',
  [T.paygCheckoutFailed]:
    'Der Bezahlvorgang konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
  [T.paygBillingInfo]:
    'Dieser Betrag wird im Voraus berechnet, um Ihr Pay As You Go-Guthaben zu aktivieren. Sie können es jederzeit unter Einstellungen → Pay As You Go deaktivieren oder ändern.',
  [T.paygUpdateCap]: 'Aktualisieren',
  [T.paygEnableButton]: 'Pay As You Go aktivieren',
  [T.paygTopUpButton]: 'Aufladen',
  [T.highToLow]: 'Hoch nach niedrig',
  [T.lowToHigh]: 'Niedrig nach hoch',
  [T.paygConsumedPercent]: 'Pay As You Go-Verbrauch in %',
  [T.paygClearFilters]: 'Filter löschen',
  [T.current]: 'Aktuell',
  [T.history]: 'Verlauf',
  [T.credits]: 'Credits',
  [T.paygCreditsLabel]: 'PAYG-Credits',
  [T.paygPlanCreditsLabel]: 'In-Plan-Credits',
  // PAYG individual limits
  [T.paygIndividualLimitColumn]: 'Individuelles Limit',
  [T.paygIndividualLimitSharedPool]: 'Gemeinsamer Pool',
  [T.paygIndividualLimitCustom]: 'Benutzerdefiniertes Limit',
  [T.paygIndividualLimitCustomValue]: 'Benutzerdefiniert: {{amount}}',
  [T.paygIndividualLimitUnlimited]: 'Unbegrenzt',
  [T.paygIndividualLimitSharedPoolDesc]:
    'Erhalten Sie einen gleichen Anteil am Team-Pool.',
  [T.paygIndividualLimitCustomDesc]:
    'Legen Sie einen bestimmten monatlichen Betrag fest.',
  [T.paygIndividualLimitUnlimitedDesc]:
    'Keine Ausgabenobergrenze, Abrechnung nach tatsächlicher Nutzung.',
  [T.paygEditIndividualLimit]: 'Individuelles Limit bearbeiten',
  [T.paygIndividualLimitSuccess]: 'Das individuelle Limit wurde aktualisiert.',
  [T.paygIndividualLimitFailed]:
    'Das individuelle Limit konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
  [T.chargedTaxIncl]: 'Addebitato (IVA inclusa)',
  [T.chargedDate]: 'Abrechnungsdatum',
  [T.paygEnableSuccess]: 'Pay As You Go wurde erfolgreich aktiviert.',
  [T.paygDisableSuccess]: 'Pay As You Go wurde deaktiviert.',
  [T.paygEnableFailed]:
    'Pay As You Go konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.',
  [T.paygDisableFailed]:
    'Pay As You Go konnte nicht deaktiviert werden. Bitte versuchen Sie es erneut.',
  [T.paygAlreadyExists]:
    'Pay As You Go mit demselben monatlichen Limit ist bereits aktiviert.',
  [T.paygInvalidLimit]: 'Das monatliche Limit kann nicht reduziert werden.',
  [T.paygNotEnabled]:
    'Pay As You Go ist nicht aktiv. Bitte aktivieren Sie die Funktion, um fortzufahren.',
  [T.paygDisableConfirmDescription]:
    'Durch Deaktivierung von Pay As You Go wird die Nutzung von Überschreitungsguthaben gestoppt. Sie können es jederzeit wieder aktivieren.',
  [T.paygEnableConfirmDescription]:
    'Durch Aktivierung von Pay As You Go wird die Nutzung von Überschreitungsguthaben fortgesetzt. Möchten Sie fortfahren?',
  [T.paygStatusCancelled]: 'Gekündigt',
  [T.paygStatusPastDue]: 'Zahlung überfällig',
  [T.paygStatusBlocked]: 'Gesperrt',
  [T.paygStatusExpired]: 'Abgelaufen',
  [T.paygStatusRenewed]: 'Erneuert',
  [T.paygStatusUnavailable]: 'Nicht verfügbar',
  [T.paygFetchUsageFailed]:
    'Nutzungsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
  [T.paygFetchHistoryFailed]:
    'Verlaufsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
  // License disclaimer — standard licence (PAYG not offered)
  [T.licenseDisclaimerStandard90Owner]:
    'Über 90% der KI-Credits Ihrer Organisation wurden verbraucht.',
  [T.licenseDisclaimerStandard90User]:
    'Über 90% der KI-Credits Ihrer Organisation wurden verbraucht. Bitte kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerStandard100Owner]:
    'Monatliches Limit für KI-Credits Ihrer Organisation erreicht. Für sofortige Unterstützung kontaktieren Sie den Kundensupport.',
  [T.licenseDisclaimerStandard100User]:
    'Monatliches Limit für KI-Credits Ihrer Organisation erreicht. Bitte kontaktieren Sie Ihren Administrator.',
  // License disclaimer — PAYG offered but switched off
  [T.licenseDisclaimerPaygAvailable90Owner]:
    'Über 90% des In-Plan-Kreditlimits Ihrer Organisation wurden verbraucht. Aktivieren Sie Pay As You Go, um eine Sperrung zu vermeiden.',
  [T.licenseDisclaimerPaygAvailable90User]:
    'Über 90% des In-Plan-Kreditlimits Ihrer Organisation wurden verbraucht. Bitte kontaktieren Sie Ihren Administrator, um Pay As You Go zu aktivieren.',
  [T.licenseDisclaimerPaygAvailable100Owner]:
    'In-Plan-Kreditlimit Ihrer Organisation erreicht — KI-Funktionen sind gesperrt. Aktivieren Sie Pay As You Go, um fortzufahren.',
  [T.licenseDisclaimerPaygAvailable100User]:
    'In-Plan-Kreditlimit Ihrer Organisation erreicht. Bitte kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerEnablePayg]: 'Pay As You Go aktivieren',
  // License disclaimer — PAYG active (is_payg_active)
  [T.licenseDisclaimerPayg90Owner]:
    'Über 90% der Pay As You Go-Credits Ihrer Organisation verbraucht.',
  [T.licenseDisclaimerPayg90User]:
    'Über 90% der Pay As You Go-Credits Ihrer Organisation verbraucht. Kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerBoth90Owner]:
    'Über 90% der Pay As You Go- und In-Plan-Credits Ihrer Organisation verbraucht.',
  [T.licenseDisclaimerBoth90User]:
    'Über 90% der Pay As You Go- und In-Plan-Credits Ihrer Organisation verbraucht. Kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerPayg100Owner]:
    'Alle Pay As You Go-Credits Ihrer Organisation wurden verbraucht.',
  [T.licenseDisclaimerPayg100User]:
    'Alle Pay As You Go-Credits Ihrer Organisation wurden verbraucht. Kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerPaygCovering]:
    'Pay As You Go deckt den Verbrauch Ihrer Organisation, da die In-Plan-Credits zur Neige gehen.',
  [T.licenseDisclaimerBoth100Owner]:
    'Plan- und Pay As You Go-Credits Ihrer Organisation aufgebraucht — KI-Funktionen sind gesperrt.',
  [T.licenseDisclaimerBoth100User]:
    'Plan- und Pay As You Go-Credits Ihrer Organisation aufgebraucht — KI-Funktionen sind gesperrt. Kontaktieren Sie Ihren Administrator.',
  [T.licenseDisclaimerRaiseCap]: 'Aufladen',
  [T.licenseDisclaimerRestoreAccess]: 'Zugang wiederherstellen',

  //help & support
  [T.helpSupport]: 'Support',
  [T.chooseOptions]:
    'Wählen Sie eine der untenstehenden Optionen für Hilfe und Feedback.',
  [T.contactSupport]: 'Support kontaktieren',
  [T.contactCustomerSupport]: 'Kundensupport kontaktieren',
  [T.ReportIssue]: 'Ein Problem melden',
  [T.suggestedImprovements]: 'Verbesserungen vorschlagen',
  [T.attachFile]: 'Datei anhängen',
  [T.uploadFile]: 'Datei hochladen',
  [T.supportTicketError]:
    'Fehler beim Senden der Nachricht an den Support. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support direkt unter {{supportEmail}}.',
  [T.fileSizeError]: 'Die maximale Anzahl an angehängten Dateien ist 5',
  [T.subject]: 'Betreff',
  [T.sizeExceedError]: 'Überschreitet die maximale Dateigröße von 7 MB.',
  [T.reportIssueSubject]:
    'Fassen Sie das Problem zusammen, mit dem Sie konfrontiert sind.',
  [T.reportIssueDescription]:
    'Beschreiben Sie das Problem im Detail und, wenn möglich, die Schritte zur Reproduktion.',
  [T.suggestedImprovemnt]:
    ' Beschreiben Sie Ihre vorgeschlagene Verbesserung oder neue Funktionsanfragen.',
  [T.issueText]:
    'Ihre Vorschläge wurden mit dem Team geteilt. Wir könnten uns bei Ihnen melden, wenn weitere Informationen erforderlich sind.',
  [T.supportText]:
    'Das Team wird sich in Kürze bei dir melden. Du wirst Antworten auf ',
  [T.successMsg]: 'Nachricht erfolgreich gesendet',
  [T.issueReported]: 'Problem gemeldet',
  [T.fileUploadingInProgress]: 'Die Datei wird hochgeladen...',
  [T.accountTypeUpdateMsg]:
    'Kontotyp aktualisiert; Anwendung wird in 3 Sekunden neu geladen.',
  [T.realmDeletedMsg]:
    'Ihr Mandant wurde gelöscht. Weiterleitung zur Anmeldeseite.',
  [T.invalidToken]:
    'Ungültiges/Abgelaufen Token. Weiterleitung zur Anmeldeseite.',
  [T.userDeletedMsg]: 'Ihr Konto wurde aus der Organisation entfernt.',
  [T.proSearchTooltip]:
    'Leiten Sie Ihre Anfrage über eine fortschrittliche KI-Planung für intelligentere Antworten.',
  [T.deepseekModelDisclaimer]:
    'DeepSeek liefert die besten Ergebnisse bei Verwendung von englischen Eingaben.',
  [T.createClient]: 'Service-Client erstellen',
  [T.createClientDescription]:
    'Klicken Sie auf die Schaltfläche, um eine ClientId, ein ClientSecret und einen Realm für den Service-Client zu erstellen',
  [T.configurationDescription]:
    'Diese Informationen werden verwendet, um Ihre Erfahrung zu personalisieren',
  [T.clientIdPlaceholder]: 'Bitte geben Sie die Client‑ID ein',
  [T.tokenRefreshRate]: 'Token‑Aktualisierungsrate',
  [T.tokenRefreshRatePlaceholder]:
    'Bitte geben Sie die Token‑Aktualisierungsrate in Stunden ein',
  [T.configurationDisclaimer]:
    '** Die Token‑Aktualisierungsrate ist standardmäßig auf 1 Stunde eingestellt und ein Aktualisierungstoken wird bereitgestellt! **',
  [T.clientIdAndRefreshRate]: 'Client‑ID & Token‑Aktualisierungsrate',
  [T.urlAndSecretId]: 'URLs & Secret‑ID abrufen',
  [T.externalApiWelcomeTitle]:
    'Schritte zur Konfiguration der API‑Integrationen',
  [T.externalApiWelcomeInstruction1]: 'Client‑ID & Token‑Aktualisierungsrate',
  [T.externalApiWelcomeInstruction2]: 'URLs & Secret‑ID abrufen',
  [T.externalApiConfigured]: 'Externe API erfolgreich konfiguriert',
  [T.externalApiConfigurationDescription]:
    'Verwenden Sie die generierten Anmeldeinformationen, um mit den EmpowerGPT‑APIs zu kommunizieren',
  [T.tokenRefreshRateRequired]: 'Token‑Aktualisierungsrate ist erforderlich',
  [T.secretId]: 'Kundengeheimnis',
  [T.authorizeUrl]: 'Autorisierungs‑URL',
  [T.authenticateUrl]: 'Authentifizierungs‑URL',
  [T.authenticationType]: 'Authentifizierungstyp',
  [T.headerName]: 'Header‑Name',
  [T.algorithm]: 'Algorithmus',
  [T.authenticateUrlPlaceholder]:
    'Bitte geben Sie die Authentifizierungs‑URL ein',
  [T.secretToken]: 'Geheimer Token',
  [T.includeSecretId]: 'Secret‑ID‑Token einschließen.',
  [T.headerNameRequired]: 'Header‑Name ist erforderlich',
  [T.algorithmRequired]: 'Algorithmus ist erforderlich',
  [T.authTypePlaceholder]: 'Bitte geben Sie den Authentifizierungstyp ein',
  [T.algorithmPlaceholder]: 'Bitte geben Sie den Algorithmus ein',
  [T.chatCompletion]: 'Chat‑Abschluss',
  [T.chatStreaming]: 'Chat‑Streaming',
  [T.secretTokenUpdateSuccess]: 'Token segreto aggiornato con successo',
  [T.secretTokenUpdateError]:
    'Errore durante l’aggiornamento del token segreto',
  [T.logoutUrl]: 'Abmelde-URL',
  [T.regenerateSecret]: 'Geheimnis regenerieren',
  [T.step]: 'Schritt',
  [T.bookmark]: 'Lesezeichen',
  [T.bookmarkDescription]: 'Empower GPT-Dokumentation',

  // Organization Logo
  [T.logoDeletedSuccess]: 'Logo erfolgreich gelöscht',
  [T.logoDeletedError]: `Fehler beim Löschen des Logos`,
  [T.logoUpdatedSuccess]: 'Logo erfolgreich aktualisiert',
  [T.logoUpdatedError]: `Fehler beim Aktualisieren des Logos`,
  [T.orgLogoSize]: 'Die Logogröße darf 5 MB nicht überschreiten',
  [T.logo]: 'Das Logo',
  [T.orgLogo]: 'Logo der Organisation',
  [T.logoTabDesc]:
    'Passen Sie Ihr Konto an, indem Sie das Logo Ihrer Organisation um das Produkt herum hinzufügen. Ihr Logo wird wie das Intech-Logo in den folgenden Beispielen erscheinen.',
  [T.switchText]: 'Verwenden Sie ein Logo für alle Orte',
  [T.squareLogoSignin]: 'Quadratisches Logo für die Anmeldung/ Registrierung',
  [T.rectangleLogoSideNav]: 'Rechteckiges Logo für Seitennavigation',
  [T.squareLogoSideNav]: 'Quadratisches Logo für Seitennavigation',
  [T.maxSize]: 'Die maximale Größe sollte 5 MB betragen',

  // Canvas
  [T.errorUpdatingCanvas]: 'Fehler beim Aktualisieren der Leinwand',
  [T.writeSomethingPlaceholder]: 'Schreibe etwas …',
  [T.editOrExplainPlaceholder]: 'Bearbeiten oder Erklären...',
  [T.canvasFooterMsg1]: 'Du siehst eine vorherige Version',
  [T.canvasFooterMsg2]:
    'Stelle diese Version wieder her, um Änderungen vorzunehmen',
  [T.canvasRestoreVersion]: 'Diese Version wiederherstellen',
  [T.canvasBackToLatestVersion]: 'Zur neuesten Version zurückkehren',
  [T.canvas]: 'Canvas',
  [T.createNewCanvasChat]: 'Neuen Canvas-Chat erstellen',
  [T.canvasDisclaimer]:
    'Wir freuen uns, unsere Canvas-Funktion in der Beta-Version vorzustellen. Bitte beachten Sie, dass sie noch einige Eigenheiten haben kann, während wir sie weiter verfeinern.',
  [T.noCanvasModels]:
    'Keine KI-Modelle für Canvas-Chats verfügbar. Bitte wenden Sie sich an Ihren Administrator.',
  [T.duration]: 'Dauer',
  [T.speaker]: 'Sprecher',

  // Actions
  [T[ACTIONS_CATEGORIES.OUTLOOK_EMAIL]]: 'Outlook-E-Mail',
  [T[ACTIONS_CATEGORIES.OUTLOOK_CALENDAR]]: 'Outlook-Kalender',
  [T[ACTIONS_CATEGORIES.GMAIL]]: 'Gmail',
  [T[ACTIONS_CATEGORIES.GOOGLE_CALENDAR]]: 'Google-Kalender',
  [T[ACTIONS_CATEGORIES.SLACK]]: 'Slack',
  [T[ACTIONS_CATEGORIES.GOOGLE_DRIVE]]: 'Google Drive',
  [T[ACTIONS_CATEGORIES.GOOGLE_SHEETS]]: 'Google Tabellen',
  [T[ACTIONS_CATEGORIES.HUBSPOT]]: 'HubSpot',
  [T[ACTIONS_CATEGORIES.JIRA]]: 'Jira',
  [T[ACTIONS_CATEGORIES.CONFLUENCE]]: 'Confluence',
  [T[ACTIONS_CATEGORIES.MICROSOFT_TEAMS]]: 'Microsoft Teams',
  [T[ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT]]: 'Microsoft SharePoint',
  [T[ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE]]: 'Microsoft OneDrive',
  [T[ACTIONS_CATEGORIES.SQL_DATABASE]]: 'SQL-Datenbank',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-desc`]]:
    'Abfragen und erkunden Sie Ihre SQL-Datenbank in natürlicher Sprache. Unterstützt PostgreSQL, MySQL, MariaDB und SQL Server.',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}`]]:
    'SQL ausführen',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}-desc`]]:
    'Führen Sie SELECT-Abfragen auf Ihrer verbundenen Datenbank aus.',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}`]]:
    'Objekte suchen',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}-desc`]]:
    'Entdecken Sie Schemas, Tabellen, Spalten und andere Datenbankobjekte.',

  [T[ACTIONS_CATEGORIES.SAP_S4HANA]]: 'SAP S/4HANA',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-desc`]]:
    'Lesezugriff auf SAP-Instandhaltungsaufträge, Meldungen, Materialbestände und Materialbelege.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}`]]:
    'Instandhaltungsaufträge auflisten',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}-desc`
  ]]:
    'Instandhaltungsaufträge mit Art, Priorität, Werk und Termindetails auflisten.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}`]]:
    'Instandhaltungsauftrag abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}-desc`
  ]]: 'Alle Details eines einzelnen Instandhaltungsauftrags abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}`
  ]]: 'Auftragsvorgänge abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}-desc`
  ]]:
    'Vorgänge eines Instandhaltungsauftrags mit Arbeitsplätzen und Werken abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}`
  ]]: 'Instandhaltungsmeldungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}-desc`
  ]]:
    'Instandhaltungsmeldungen mit Priorität, Equipment und Störungsdaten auflisten.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}`
  ]]: 'Instandhaltungsmeldung abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}-desc`
  ]]: 'Alle Details einer einzelnen Instandhaltungsmeldung abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}`
  ]]: 'Meldungspositionen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}-desc`
  ]]: 'Positionen einer Meldung mit Objektteil- und Schadenscodes abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}`
  ]]: 'Meldungsmaßnahmen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}-desc`
  ]]: 'Maßnahmen einer Meldung mit Status und verantwortlicher Person abrufen.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}`]]:
    'Materialbestand auflisten',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}-desc`
  ]]: 'Materialien mit ihren Basismengeneinheiten auflisten.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}`]]:
    'Materialbestand abrufen',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}-desc`]]:
    'Bestandsdetails eines Materials inklusive Kontenmodell-Aufschlüsselung abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}`
  ]]: 'Bestandsmengen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}-desc`
  ]]: 'Bestandsmengen nach Werk, Lagerort, Charge und Bestandsart abrufen.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}`]]:
    'Materialbelege auflisten',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}-desc`
  ]]: 'Materialbelegköpfe mit Buchungsdaten und Warenbewegungscodes auflisten.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}`]]:
    'Materialbeleg abrufen',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}-desc`
  ]]: 'Einen Materialbeleg mit allen Positionen abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}`
  ]]: 'Materialbelegpositionen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}-desc`
  ]]:
    'Materialbelegpositionen mit Mengen, Bewegungsarten und Lagerorten auflisten.',

  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-desc`]]:
    'Unterhalten Sie sich mit Ihren Outlook-E-Mails, erstellen Sie Entwürfe und senden Sie Nachrichten.',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-desc`]]:
    'Zeigen Sie Ihre Outlook-Kalenderereignisse an und verwalten Sie sie.',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-desc`]]:
    'Unterhalten Sie sich mit Ihren E-Mails, erstellen Sie Entwürfe und senden Sie Nachrichten.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-desc`]]:
    'Zeigen Sie Ihre Kalenderereignisse an und verwalten Sie sie.',
  [T[`${ACTIONS_CATEGORIES.SLACK}-desc`]]:
    'Eine Plattform. Alle Ihre Go-to-Market-Teams. Perfekt abgestimmt.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-desc`]]:
    'Greifen Sie auf Ihre Dateien zu, organisieren Sie Dokumente und arbeiten Sie gemeinsam in Google Drive.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-desc`]]:
    'Verwalten und analysieren Sie Daten in Google-Tabellen.',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-desc`]]:
    'Verwalten Sie Kontakte, Deals und Kampagnen direkt im Chat.',
  [T[`${ACTIONS_CATEGORIES.JIRA}-desc`]]:
    'Suchen, erstellen und aktualisieren Sie Jira-Vorgänge direkt im Chat.',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-desc`]]:
    'Suchen, lesen und verwalten Sie Confluence-Seiten und -Kommentare direkt im Chat.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-desc`]]:
    'Kontextbezogener Zugriff auf Dokumente, Listen und Seiten über Ihre SharePoint-Sites hinweg.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-desc`]]:
    'Lesen, durchsuchen und erstellen Sie Dokumente in natürlicher Sprache, ohne zwischen Tools zu wechseln.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-desc`]]:
    'Lesen, verwalten und erstellen Sie Dateien in Ihrem OneDrive in natürlicher Sprache',

  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}`]]:
    'Entwurf erstellen',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}`]]:
    'E-Mail senden',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}`
  ]]: 'Suche nach Inhalt',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}`
  ]]: 'Suche nach Kontakt',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}-desc`]]:
    'E-Mail entwerfen und als Entwurf speichern, ohne zu senden',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}-desc`]]:
    'E-Mail verfassen und direkt über Ihr Outlook-Konto senden',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}-desc`
  ]]: 'E-Mails im Posteingang nach Texten im Betreff oder Inhalt suchen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}-desc`
  ]]: 'E-Mails nach Absendername oder E-Mail-Adresse suchen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}`
  ]]: 'Ereignis erstellen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}`
  ]]: 'Ereignisse löschen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}`
  ]]: 'Ereignisse nach Datum abrufen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}`
  ]]: 'Heutige Ereignisse abrufen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}`
  ]]: 'Kalender auflisten',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}`
  ]]: 'Kalenderereignisse anzeigen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}`
  ]]: 'Ereignis aktualisieren',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}-desc`
  ]]: 'Neues Ereignis oder Meeting im Outlook-Kalender planen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}-desc`
  ]]: 'Ein bestimmtes Ereignis aus Ihrem Outlook-Kalender entfernen.',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}-desc`
  ]]: 'Ereignisse für ein bestimmtes Datum aus Ihrem Outlook-Kalender abrufen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}-desc`
  ]]: 'Für heute geplante Ereignisse aus Ihrem Outlook-Kalender abrufen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}-desc`
  ]]: 'Alle mit Ihrem Outlook-Konto verknüpften Kalender anzeigen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}-desc`
  ]]: 'Alle Ereignisse eines ausgewählten Kalenders anzeigen',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}-desc`
  ]]: 'Details eines bestehenden Ereignisses in Ihrem Outlook-Kalender ändern',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_EVENT}-desc`
  ]]:
    'Details eines bestimmten Ereignisses per ID aus Ihrem Outlook-Kalender abrufen',

  // Google Gmail
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEND_EMAIL}`]]:
    'E-Mail senden',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_EMAILS}`]]:
    'E-Mails suchen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.REPLY_EMAIL}`]]:
    'Auf E-Mail antworten',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT}`]]:
    'Entwurf erstellen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT_REPLY}`]]:
    'Antwortentwurf erstellen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.GET_EMAIL_ATTACHMENTS}`]]:
    'E-Mail-Anhänge abrufen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_PEOPLE}`]]:
    'Personen suchen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEND_EMAIL}-desc`]]:
    'E-Mail verfassen und direkt über Ihr Gmail-Konto senden',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_EMAILS}-desc`]]:
    'E-Mails in Ihrem Gmail-Posteingang mit Stichwörtern und Filtern suchen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.REPLY_EMAIL}-desc`]]:
    'Auf einen bestehenden E-Mail-Thread in Ihrem Gmail-Konto antworten',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT}-desc`]]:
    'E-Mail-Entwurf in Ihrem Gmail-Konto erstellen und speichern, ohne zu senden',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.CREATE_DRAFT_REPLY}-desc`]]:
    'Antwortentwurf für einen bestehenden E-Mail-Thread erstellen, ohne zu senden',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.GET_EMAIL_ATTACHMENTS}-desc`]]:
    'E-Mails mit ihren Anhängen aus Ihrem Gmail-Konto abrufen',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-${GOOGLE_GMAIL.SEARCH_PEOPLE}-desc`]]:
    'Personen in Ihren Gmail-Kontakten und im Domain-Verzeichnis suchen',

  // Google Calendar
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.LIST_CALENDARS}`
  ]]: 'Kalender auflisten',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.VIEW_EVENTS}`]]:
    'Ereignisse anzeigen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.CREATE_EVENT}`]]:
    'Ereignis erstellen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.UPDATE_EVENT}`]]:
    'Ereignis aktualisieren',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.DELETE_EVENT}`]]:
    'Ereignis löschen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.SEARCH_PEOPLE}`]]:
    'Personen suchen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.LIST_CALENDARS}-desc`
  ]]: 'Alle verfügbaren Kalender in Ihrem Google Calendar-Konto anzeigen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.VIEW_EVENTS}-desc`
  ]]:
    'Ereignisse aus einem bestimmten Kalender in Ihrem Google Calendar anzeigen und abrufen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.CREATE_EVENT}-desc`
  ]]: 'Neues Ereignis oder Meeting in Ihrem Google Calendar planen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.UPDATE_EVENT}-desc`
  ]]: 'Details eines bestehenden Ereignisses in Ihrem Google Calendar ändern',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.DELETE_EVENT}-desc`
  ]]: 'Ein bestimmtes Ereignis aus Ihrem Google Calendar entfernen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-${GOOGLE_CALENDAR.SEARCH_PEOPLE}-desc`
  ]]: 'Personen in Ihren Google-Kontakten und im Domain-Verzeichnis suchen',

  // Google Drive
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_SHARED_DRIVES}`]]:
    'Geteilte Laufwerke abrufen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_FOLDERS}`]]:
    'Ordner abrufen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_FILES}`]]:
    'Dateien suchen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.DOWNLOAD_FILE}`]]:
    'Datei herunterladen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_PEOPLE}`]]:
    'Personen suchen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_SHARED_DRIVES}-desc`
  ]]: 'Alle geteilten Laufwerke in Ihrem Google Drive-Konto auflisten',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.GET_FOLDERS}-desc`]]:
    'Ordner aus Ihrem Google Drive abrufen und anzeigen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_FILES}-desc`]]:
    'Dateien und Dokumente in Ihrem Google Drive mit Stichwörtern suchen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.DOWNLOAD_FILE}-desc`]]:
    'Eine bestimmte Datei aus Ihrem Google Drive herunterladen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-${GOOGLE_DRIVE.SEARCH_PEOPLE}-desc`]]:
    'Personen in Ihren Google-Kontakten und im Domain-Verzeichnis suchen',

  // Slack
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEARCH_MESSAGES}`]]:
    'Nachrichten suchen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_PEOPLE}`]]: 'Personen abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_BY_EMAIL}`]]:
    'Benutzer per E-Mail abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_INFO}`]]:
    'Benutzerinfo abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.LIST_USER_CONVERSATIONS}`]]:
    'Benutzerkonversationen auflisten',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_MY_CHANNELS}`]]:
    'Meine Kanäle abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_INFO}`]]:
    'Kanalinfo abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_MESSAGES}`]]:
    'Kanalnachrichten abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_THREAD_REPLIES}`]]:
    'Thread-Antworten abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.REPLY_TO_MESSAGE}`]]:
    'Auf Nachricht antworten',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEND_MESSAGE}`]]: 'Nachricht senden',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEARCH_MESSAGES}-desc`]]:
    'Nachrichten in Ihrem Slack-Workspace mit Stichwörtern suchen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_PEOPLE}-desc`]]:
    'Liste aller Benutzer in Ihrem Slack-Workspace abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_BY_EMAIL}-desc`]]:
    'Bestimmten Slack-Benutzer anhand seiner E-Mail-Adresse finden',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_USER_INFO}-desc`]]:
    'Informationen über den aktuell authentifizierten Benutzer abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.LIST_USER_CONVERSATIONS}-desc`]]:
    'Alle Konversationen für einen bestimmten Benutzer in Slack auflisten',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_MY_CHANNELS}-desc`]]:
    'Alle Kanäle abrufen, in denen Sie Mitglied sind',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_INFO}-desc`]]:
    'Detaillierte Informationen über einen bestimmten Slack-Kanal abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_CHANNEL_MESSAGES}-desc`]]:
    'Nachrichten aus einem bestimmten Slack-Kanal abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.GET_THREAD_REPLIES}-desc`]]:
    'Alle Antworten in einem bestimmten Nachrichten-Thread abrufen',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.REPLY_TO_MESSAGE}-desc`]]:
    'Auf einen bestimmten Nachrichten-Thread in Slack antworten',
  [T[`${ACTIONS_CATEGORIES.SLACK}-${SLACK.SEND_MESSAGE}-desc`]]:
    'Neue Nachricht an einen Slack-Kanal senden',

  // HubSpot
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.FIND_COMPANIES}`]]:
    'Unternehmen finden',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_COMPANY}`]]:
    'Unternehmen erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_COMPANY}`]]:
    'Unternehmen aktualisieren',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES}`]]:
    'Unternehmen suchen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES_ADVANCED}`]]:
    'Erweiterte Unternehmenssuche',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_OWNERS}`]]: 'Inhaber abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_USER_INFO}`]]:
    'Benutzerinfo abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACTS}`]]:
    'Kontakte abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_CONTACT}`]]:
    'Kontakt erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_CONTACT}`]]:
    'Kontakt aktualisieren',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_DEAL}`]]: 'Deal erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_DEALS}`]]: 'Deals suchen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_DEAL}`]]:
    'Deal aktualisieren',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_COMPANY_RECENT_ACTIVITIES}`]]:
    'Aktuelle Unternehmensaktivitäten abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACT_RECENT_ACTIVITIES}`]]:
    'Aktuelle Kontaktaktivitäten abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_TASK}`]]:
    'Aufgabe erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_NOTE}`]]:
    'Notiz erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.FIND_COMPANIES}-desc`]]:
    'Unternehmen in Ihrem HubSpot CRM nach verschiedenen Kriterien suchen und finden',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_COMPANY}-desc`]]:
    'Neuen Unternehmensdatensatz in Ihrem HubSpot CRM erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_COMPANY}-desc`]]:
    'Informationen für ein bestehendes Unternehmen in HubSpot aktualisieren',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES}-desc`]]:
    'Unternehmen mit Filtern und spezifischen Kriterien suchen',
  [T[
    `${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_COMPANIES_ADVANCED}-desc`
  ]]:
    'Erweiterte Suche nach Unternehmen mit komplexen Filterkombinationen durchführen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_OWNERS}-desc`]]:
    'Liste aller Inhaber in Ihrem HubSpot-Konto abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_USER_INFO}-desc`]]:
    'Informationen über den aktuell authentifizierten HubSpot-Benutzer abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACTS}-desc`]]:
    'Kontakte aus Ihrem HubSpot CRM mit optionaler Filterung abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_CONTACT}-desc`]]:
    'Neuen Kontaktdatensatz in Ihrem HubSpot CRM erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_CONTACT}-desc`]]:
    'Informationen für einen bestehenden Kontakt in HubSpot aktualisieren',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_DEAL}-desc`]]:
    'Neuen Deal in Ihrer HubSpot-Verkaufspipeline erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.SEARCH_DEALS}-desc`]]:
    'Deals in HubSpot mit erweiterten Filtern und Kriterien suchen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.UPDATE_DEAL}-desc`]]:
    'Details eines bestehenden Deals in Ihrer HubSpot-Pipeline aktualisieren',
  [T[
    `${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_COMPANY_RECENT_ACTIVITIES}-desc`
  ]]: 'Aktuelle Aktivitäten für ein bestimmtes Unternehmen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.GET_CONTACT_RECENT_ACTIVITIES}-desc`
  ]]: 'Aktuelle Aktivitäten für einen bestimmten Kontakt abrufen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_TASK}-desc`]]:
    'Neue Aufgabe für einen Kontakt oder ein Unternehmen in HubSpot erstellen',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-${HUBSPOT.CREATE_NOTE}-desc`]]:
    'Neue Notiz für einen Kontakt oder ein Unternehmen in HubSpot erstellen',

  // Jira
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}`]]:
    'Zugängliche Ressourcen abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}`]]:
    'Aktuellen Benutzer abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}`]]: 'Vorgang abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}`]]:
    'Externe Vorgangsverknüpfungen abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}`]]:
    'Vorgangstyp-Felder abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}`]]:
    'Projekt-Vorgangstypen abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}`]]:
    'Vorgangsverknüpfungstypen abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}`]]:
    'Übergänge abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}`]]: 'Projekte abrufen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}`]]:
    'Konto-ID nachschlagen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}`]]: 'Kommentar hinzufügen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}`]]:
    'Arbeitsprotokoll hinzufügen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}`]]: 'Vorgang erstellen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}`]]:
    'Vorgang aktualisieren',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}`]]:
    'Vorgang überführen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}`]]: 'Vorgänge suchen',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}-desc`]]:
    'Listet die Atlassian-Sites auf, auf die Ihr Konto zugreifen kann',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}-desc`]]:
    'Ruft Informationen zum aktuell authentifizierten Atlassian-Benutzer ab',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}-desc`]]:
    'Ruft einen bestimmten Jira-Vorgang anhand seines Schlüssels oder seiner ID ab',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}-desc`]]:
    'Ruft externe Verknüpfungen (z. B. Confluence-Seiten, externe URLs) eines Jira-Vorgangs ab',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}-desc`]]:
    'Ruft die Pflicht- und optionalen Felder für einen Vorgangstyp in einem Projekt ab',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}-desc`]]:
    'Ruft die verfügbaren Vorgangstypen für ein Jira-Projekt ab',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}-desc`]]:
    'Listet die verfügbaren Vorgangsverknüpfungstypen auf, z. B. blockiert oder bezieht sich auf',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}-desc`]]:
    'Listet die gültigen Workflow-Übergänge für einen Jira-Vorgang auf',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}-desc`]]:
    'Listet die für den aktuellen Benutzer sichtbaren Jira-Projekte auf',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}-desc`]]:
    'Ermittelt die Atlassian-Konto-ID eines Benutzers anhand von Name oder E-Mail',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}-desc`]]:
    'Fügt einem Jira-Vorgang einen Kommentar hinzu',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}-desc`]]:
    'Erfasst geleistete Arbeit für einen Jira-Vorgang',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}-desc`]]:
    'Erstellt einen neuen Jira-Vorgang in einem Projekt',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}-desc`]]:
    'Aktualisiert Felder eines bestehenden Jira-Vorgangs',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}-desc`]]:
    'Überführt einen Jira-Vorgang durch seinen Workflow',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}-desc`]]:
    'Sucht Jira-Vorgänge mithilfe von JQL',

  // Confluence
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}`
  ]]: 'Zugängliche Ressourcen abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}`]]:
    'Aktuellen Benutzer abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}`]]:
    'Seite abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}`]]:
    'Unterseiten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}`
  ]]: 'Fußkommentare abrufen',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}`
  ]]: 'Inline-Kommentare abrufen',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}`
  ]]: 'Antworten auf Fußkommentar abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}`]]:
    'Bereiche abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}`]]:
    'Seiten in Bereich abrufen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}`]]:
    'Seite erstellen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}`]]:
    'Seite aktualisieren',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}`]]:
    'Fußkommentar erstellen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}`]]:
    'Inline-Kommentar erstellen',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}`]]:
    'Confluence durchsuchen',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}-desc`
  ]]: 'Listet die Atlassian-Sites auf, auf die Ihr Konto zugreifen kann',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}-desc`]]:
    'Ruft Informationen zum aktuell authentifizierten Atlassian-Benutzer ab',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}-desc`]]:
    'Ruft eine Confluence-Seite anhand ihrer ID ab',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}-desc`
  ]]: 'Ruft die Unterseiten einer Confluence-Seite ab',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}-desc`
  ]]: 'Ruft Fußkommentare einer Confluence-Seite ab',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}-desc`
  ]]: 'Ruft Inline-Kommentare einer Confluence-Seite ab',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}-desc`
  ]]: 'Ruft Antworten auf einen Confluence-Fußkommentar ab',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}-desc`]]:
    'Listet Confluence-Bereiche auf',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}-desc`]]:
    'Listet Seiten in einem Confluence-Bereich auf',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}-desc`]]:
    'Erstellt eine neue Confluence-Seite',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}-desc`]]:
    'Aktualisiert den Inhalt und optional den Titel einer bestehenden Confluence-Seite',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}-desc`
  ]]: 'Fügt einer Confluence-Seite einen Fußkommentar hinzu',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}-desc`
  ]]:
    'Fügt einen Inline-Kommentar zu ausgewähltem Text auf einer Confluence-Seite hinzu',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}-desc`]]:
    'Durchsucht Confluence-Seiten und -Inhalte mithilfe von CQL',

  // Microsoft Teams
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}`
  ]]: 'Nachrichten durchsuchen',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}`]]:
    'Kanäle auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}`
  ]]: 'Kanalnachrichten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}`
  ]]: 'Chat-Nachrichten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}`
  ]]: 'Kanalnachricht senden',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}`
  ]]: 'Chat-Nachricht senden',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}-desc`
  ]]: 'Durchsuchen Sie alle Ihre Teams-Chats mit Stichwörtern nach Nachrichten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}-desc`
  ]]: 'Alle Kanäle aus allen Teams auflisten, in denen Sie Mitglied sind',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}-desc`
  ]]:
    'Nachrichten aus einem bestimmten Teams-Kanal mit optionaler Datumsfilterung abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}-desc`
  ]]:
    'Nachrichten aus einem bestimmten Teams-Chat mit optionaler Datumsfilterung abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}-desc`
  ]]:
    'Eine Nachricht an einen bestimmten Teams-Kanal mit Text- oder HTML-Formatierung senden',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}-desc`
  ]]:
    'Eine Nachricht an einen bestimmten Teams-Chat mit Text- oder HTML-Formatierung senden',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}`]]:
    'Chats auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}`
  ]]: 'Chat-Mitglieder abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}-desc`
  ]]:
    'Alle Einzel-Chats, Gruppen-Chats und Besprechungs-Chats auflisten, in denen Sie Mitglied sind',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}-desc`
  ]]:
    'Alle Mitglieder eines bestimmten Chats einschließlich ihrer Anzeigenamen, E-Mail-Adressen und Rollen abrufen',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}`]]:
    'Besprechungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}`
  ]]: 'Besprechungstranskript abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}-desc`
  ]]:
    'Ihre Teams-Onlinebesprechungen mit Betreff, Uhrzeit und Teilnahmelinks auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}-desc`
  ]]: 'Das Transkript einer bestimmten Teams-Besprechung abrufen',

  // Google Docs
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}`]]:
    'Dokumente durchsuchen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}`]]:
    'Dokument erstellen',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}`
  ]]: 'Dokumentinhalt abrufen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}`]]:
    'Text einfügen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}`]]:
    'Text ersetzen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}`]]:
    'Text formatieren',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}`]]:
    'Alle suchen und ersetzen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}-desc`]]:
    'Durchsuchen Sie Ihre Google Docs mit Stichwörtern und Filtern nach Dokumenten',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}-desc`]]:
    'Erstellen Sie ein neues Google Docs-Dokument mit einem angegebenen Titel',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}-desc`
  ]]: 'Rufen Sie den Inhalt und die Metadaten eines bestimmten Google Docs ab',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}-desc`]]:
    'Fügen Sie Text an bestimmten Stellen in einem Google Doc ein',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}-desc`]]:
    'Ersetzen Sie bestimmte Textpassagen in einem Google Doc',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}-desc`]]:
    'Wenden Sie Formatierungsstile auf bestimmten Text in einem Google Doc an',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}-desc`
  ]]:
    'Suchen und ersetzen Sie alle Vorkommen von Text in einem Google Doc mit optionaler Groß-/Kleinschreibung',

  // Google Sheets
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}`]]:
    'Dateien durchsuchen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}`]]:
    'Zeilen erstellen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}`]]:
    'Zeilen aktualisieren',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}`]]:
    'Zeilen auflisten',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}`]]:
    'Metadaten abrufen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}`]]:
    'Tabellenblatt hinzufügen',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}-desc`]]:
    'Durchsuchen Sie Ihre Google Sheets mit Stichwörtern und Filtern nach Tabellenkalkulationsdateien',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}-desc`]]:
    'Fügen Sie leere Zeilen an einer bestimmten Position in ein bestimmtes Tabellenblatt ein',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}-desc`]]:
    'Aktualisieren Sie vorhandene Zeilen in einem Tabellenblatt mit neuen Werten',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}-desc`]]:
    'Listen Sie Zeilen aus einem Tabellenblatt ab einer bestimmten Zeilennummer auf',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}-desc`]]:
    'Rufen Sie Metadateninformationen über eine Tabellenkalkulation ab, einschließlich Tabellenblattnamen und Eigenschaften',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}-desc`]]:
    'Fügen Sie einer vorhandenen Tabellenkalkulation ein neues Tabellenblatt mit angegebenen Abmessungen hinzu',

  // Microsoft SharePoint
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}`
  ]]: 'Profil abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}`
  ]]: 'Laufwerke auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}`
  ]]: 'Websites durchsuchen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}`
  ]]: 'Website abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}`
  ]]: 'Unterwebsites auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}`
  ]]: 'Laufwerksinhalte auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}`
  ]]: 'Zuletzt verwendete Dateien auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}`
  ]]: 'Website-Benutzer auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}`
  ]]: 'Website-Listen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}`
  ]]: 'Liste abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}`
  ]]: 'Spalten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}`
  ]]: 'Spalte abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}`
  ]]: 'Listenelemente auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}`
  ]]: 'Listenelement abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}`
  ]]: 'Website-Seiten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}`
  ]]: 'Gruppen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}`
  ]]: 'Gruppenmitglieder abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}`
  ]]: 'Gruppenmitglied hinzufügen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}`
  ]]: 'Gruppenmitglied entfernen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}`
  ]]: 'Dateien durchsuchen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}`
  ]]: 'Datei hochladen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}`
  ]]: 'Ordner abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}-desc`
  ]]: 'Rufen Sie die Profilinformationen für den aktuellen Benutzer ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}-desc`
  ]]:
    'Listen Sie Laufwerke in einer Website oder vom aktuellen Benutzer zugängliche Laufwerke auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}-desc`
  ]]: 'Durchsuchen Sie SharePoint-Websites mit Stichwörtern',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}-desc`
  ]]:
    'Rufen Sie detaillierte Informationen über eine bestimmte SharePoint-Website ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}-desc`
  ]]: 'Listen Sie alle Unterwebsites innerhalb einer SharePoint-Website auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}-desc`
  ]]:
    'Listen Sie Dateien und Ordner in einem Laufwerk im Stammverzeichnis oder in einem Ordner auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}-desc`
  ]]: 'Listen Sie vom aktuellen Benutzer kürzlich aufgerufene Dateien auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}-desc`
  ]]:
    'Listen Sie alle Benutzer auf, die Zugriff auf eine SharePoint-Website haben',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}-desc`
  ]]: 'Listen Sie alle SharePoint-Listen innerhalb einer Website auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}-desc`
  ]]: 'Rufen Sie Metadaten und Details für eine bestimmte SharePoint-Liste ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}-desc`
  ]]: 'Listen Sie alle Spaltendefinitionen in einer SharePoint-Liste auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}-desc`
  ]]: 'Rufen Sie die Definition und Metadaten einer bestimmten Spalte ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}-desc`
  ]]:
    'Listen Sie Elemente aus einer SharePoint-Liste mit optionaler Filterung auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}-desc`
  ]]:
    'Rufen Sie detaillierte Daten für ein bestimmtes Element in einer SharePoint-Liste ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}-desc`
  ]]: 'Listen Sie alle Webseiten innerhalb einer SharePoint-Website auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}-desc`
  ]]:
    'Rufen Sie alle Gruppen für den aktuellen Benutzer oder einen bestimmten Benutzer ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}-desc`
  ]]: 'Rufen Sie alle Mitglieder einer bestimmten Gruppe ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}-desc`
  ]]: 'Fügen Sie einen Benutzer als Mitglied zu einer Gruppe hinzu',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}-desc`
  ]]: 'Entfernen Sie einen Benutzer aus einer Gruppe',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}-desc`
  ]]: 'Suchen Sie nach Dateien nach Namen innerhalb eines Laufwerks',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}-desc`
  ]]: 'Laden Sie eine Datei in einen SharePoint-Ordner hoch',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}-desc`
  ]]: 'Lösen Sie einen Ordnerpfad auf, um Laufwerk- und Ordner-IDs zu erhalten',

  // Microsoft OneDrive
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}`
  ]]: 'Verfügbare Laufwerke auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}`
  ]]: 'Ordner nach Pfad abrufen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}`
  ]]: 'Ordner nach Namen durchsuchen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}`
  ]]: 'Dateien nach Namen durchsuchen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}`
  ]]: 'Ordner erstellen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}`
  ]]: 'Ordnerinhalte auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}`
  ]]: 'Datei herunterladen',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}-desc`
  ]]:
    'Listen Sie alle zugänglichen OneDrive-Speicherorte für den aktuellen Benutzer auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}-desc`
  ]]: 'Rufen Sie einen Ordner über seinen Pfad relativ zum Laufwerksstamm ab',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}-desc`
  ]]: 'Suchen Sie nach Ordnern nach Namen über das Laufwerk hinweg',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}-desc`
  ]]: 'Suchen Sie nach Dateien nach Namen über das Laufwerk hinweg',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}-desc`
  ]]:
    'Erstellen Sie einen Ordner nach Pfad und erstellen Sie fehlende übergeordnete Ordner nach Bedarf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}-desc`
  ]]: 'Listen Sie alle Dateien und Ordner in einem bestimmten Ordnerpfad auf',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}-desc`
  ]]: 'Laden Sie eine Datei von OneDrive nach Datei-ID herunter',

  [T[ACTIONS_CATEGORIES.DATEV_ACCOUNTING]]: 'DATEV Buchhaltung',
  [T[`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-desc`]]:
    'Zugriff auf DATEV-Buchhaltung — Mandate, Wirtschaftsjahre, Sachkonten und Buchungsbelege.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}`
  ]]: 'Mandate auflisten',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}-desc`
  ]]: 'Alle zugänglichen DATEV-Buchhaltungsmandate auflisten.',
  [T[`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}`]]:
    'Mandat abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}-desc`
  ]]: 'Ein einzelnes DATEV-Buchhaltungsmandat anhand der UUID abrufen.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}`
  ]]: 'Wirtschaftsjahre abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}-desc`
  ]]: 'Alle Wirtschaftsjahr-IDs für ein Mandat zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}`
  ]]: 'Wirtschaftsjahr abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}-desc`
  ]]: 'Details eines einzelnen Wirtschaftsjahres zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}`
  ]]: 'Sachkonten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}-desc`
  ]]: 'Sachkonten für ein Wirtschaftsjahr zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}`
  ]]: 'Summen und Salden abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}-desc`
  ]]: 'Monatliche Summen und Salden für ein Wirtschaftsjahr zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}`
  ]]: 'Buchungsfolgen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}-desc`
  ]]: 'Buchungsfolgen für ein Wirtschaftsjahr zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}`
  ]]: 'Zahlungsbedingungen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}-desc`
  ]]: 'Zahlungsbedingungen für ein Wirtschaftsjahr zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}`
  ]]: 'Belegarten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}-desc`
  ]]: 'Alle für ein DATEV-Mandat konfigurierten Belegarten zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}`
  ]]: 'DUO-Version abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}-desc`
  ]]:
    'Erlaubte Dateierweiterungen und Heftungslogik für die DUO-Version eines Mandats zurückgeben.',

  [T[ACTIONS_CATEGORIES.DATEV_HR]]: 'DATEV HR',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-desc`]]:
    'Zugriff auf DATEV HR — Lohn, Mitarbeiterdaten, Sozialversicherung, Abwesenheiten und Lohnzettel.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}`]]:
    'HR-Mandate auflisten',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}-desc`]]:
    'Alle mit dem aktuellen Token zugänglichen HR-Mandate auflisten.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}`]]:
    'HR-Mandat abrufen',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}-desc`]]:
    'Ein einzelnes HR-Mandat anhand der ID abrufen.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}`]]:
    'Mitarbeiter-Stammdaten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}-desc`
  ]]: 'Stammdaten eines einzelnen Mitarbeiters zurückgeben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}`]]:
    'Gehaltsdetails abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}-desc`
  ]]: 'Gehaltsdetails eines einzelnen Mitarbeiters zurückgeben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}`]]:
    'Steuerzahlungen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}-desc`
  ]]: 'Lohnsteuer- und Kirchensteuerzahlungen eines Mitarbeiters zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}`
  ]]: 'Sozialversicherung abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}-desc`
  ]]: 'Sozialversicherungsdaten eines einzelnen Mitarbeiters zurückgeben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}`]]:
    'Abwesenheiten abrufen',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}-desc`]]:
    'Abwesenheitsdaten eines Mitarbeiters zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}`
  ]]: 'Mitarbeiter-ID suchen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}-desc`
  ]]:
    'DATEV-Mitarbeiter-ID anhand der betrieblichen Personalnummer nachschlagen.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}`
  ]]: 'Alle Mitarbeiter-Stammdaten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}-desc`
  ]]: 'Stammdaten aller Mitarbeiter eines Mandats zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}`
  ]]: 'Alle Gehaltsdetails abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}-desc`
  ]]: 'Gehaltsdetails aller Mitarbeiter eines Mandats zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}`
  ]]: 'Alle Steuerzahlungen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}-desc`
  ]]: 'Steuerzahlungen aller Mitarbeiter eines Mandats zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}`
  ]]: 'Alle Sozialversicherungen abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}-desc`
  ]]: 'Sozialversicherungszahlungen aller Mitarbeiter zurückgeben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}`]]:
    'Alle Abwesenheiten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}-desc`
  ]]: 'Abwesenheiten aller Mitarbeiter eines Mandats zurückgeben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}`]]:
    'Lohnmandant abrufen',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}-desc`]]:
    'HR-Lohnmandanten-Informationen einschließlich Dokumententyp-Zugriffsrechten abrufen.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}`]]:
    'Lohnberichte abrufen',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}-desc`]]:
    'Lohndokumente für ein Mandat und einen Zeitraum zurückgeben.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}`
  ]]: 'Dokumentenverfügbarkeit prüfen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}-desc`
  ]]:
    'Prüfen, ob Lohndokumente für ein Mandat und einen Zeitraum verfügbar sind.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}`
  ]]: 'Lohnzettel-Nummern abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}-desc`
  ]]:
    'Mitarbeiternummern zurückgeben, die für einen bestimmten Zeitraum Lohnzettel haben.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}`]]:
    'Lohnbericht-Metadaten abrufen',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}-desc`
  ]]:
    'Metadaten zu verfügbaren Lohnberichten für alle Mitarbeiter zurückgeben.',

  [T[ACTIONS_CATEGORIES.MICROSOFT_D365]]: 'Dynamics 365',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-desc`]]:
    'Dynamics 365 abfragen — Kunden, Lieferanten, Artikel, Verkauf, Einkauf und Hauptbuch-Berichte.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}`]]:
    'Kunden auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}-desc`
  ]]:
    'Kundenstammdaten: Kontaktdaten, Adressen, Zahlungsbedingungen, Kreditlimits, Salden.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}`]]:
    'Lieferanten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}-desc`
  ]]:
    'Lieferantenstammdaten: Firmendetails, Adressen, Zahlungsbedingungen, Steuerregistrierung, Salden.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}`]]:
    'Artikel auflisten',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}-desc`]]:
    'Artikelstammdaten: Beschreibungen, Preise, Stückkosten, Steuergruppen, Lagerbestände.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}`]]:
    'Mitarbeiter auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}-desc`
  ]]:
    'Mitarbeiterstammdaten: persönliche Daten, Beschäftigungsstatus, Berufsbezeichnungen, Bankdaten.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}`
  ]]: 'Firmeninformationen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}-desc`
  ]]:
    'Firmenprofil: Name, Adresse, Kontaktdaten, Steuerregistrierungsnummern, Bankdaten.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}`
  ]]: 'Bankkonten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}-desc`
  ]]: 'Bankkontodaten: Kontonummern, Banknamen, Salden, IBAN/SWIFT-Codes.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}`]]:
    'Währungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}-desc`
  ]]: 'Währungsstammdaten: Codes, Symbole, ISO-Codes, Rundungseinstellungen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}`
  ]]: 'Verkaufsrechnungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}-desc`
  ]]:
    'Offene Verkaufsrechnungen: Kundendetails, Beträge, Steuerinformationen, Fälligkeitsdaten, Status.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}`
  ]]: 'Gebuchte Verkaufsrechnungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}-desc`
  ]]: 'Gebuchte (abgeschlossene) Verkaufsrechnungen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}`
  ]]: 'Verkaufsgutschriften auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}-desc`
  ]]:
    'Verkaufsgutschriften: Kundendetails, Beträge, Steuerinformationen, zugehörige Rechnungsreferenzen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}`
  ]]: 'Verkaufsaufträge auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}-desc`
  ]]:
    'Verkaufsaufträge: Kundendetails, Adressen, Auftragsstatus, Liefertermine, Summen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}`
  ]]: 'Kundenzahlungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}-desc`
  ]]:
    'Kundenzahlungstransaktionen: Beträge, Daten, Methoden, zugehörige Rechnungen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}`
  ]]: 'Einkaufsrechnungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}-desc`
  ]]:
    'Offene Einkaufsrechnungen: Lieferantendetails, Beträge, Fälligkeitsdaten, Zahlungsbedingungen, Status.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}`
  ]]: 'Gebuchte Einkaufsrechnungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}-desc`
  ]]: 'Gebuchte (abgeschlossene) Einkaufsrechnungen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}`
  ]]: 'Einkaufsgutschriften auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}-desc`
  ]]:
    'Einkaufsgutschriften: Lieferantendetails, Beträge, Währung, Zahlungsbedingungen, Status.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}`
  ]]: 'Einkaufsaufträge auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}-desc`
  ]]:
    'Einkaufsaufträge: Lieferantendetails, Auftragsstatus, Liefer-/Zahlungsinformationen, Summen.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}`
  ]]: 'Lieferantenzahlungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}-desc`
  ]]:
    'Lieferantenzahlungstransaktionen: Beträge, Daten, Methoden, Rechnungszuordnung.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}`
  ]]: 'Sachkonten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}-desc`
  ]]:
    'Kontenplan: Nummern, Namen, Kategorien, Salden, Buchungseinstellungen (nur lesend).',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}`
  ]]: 'Hauptbuchbuchungen auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}-desc`
  ]]:
    'Gebuchte Hauptbuchbuchungen: Buchungsnummer, Buchungsdatum, Belegart, Konto, Soll-/Haben-Beträge.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}`
  ]]: 'Saldenlisten auflisten',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}-desc`
  ]]:
    'Saldenlisten für alle Sachkonten: Kontonummern, Namen, Typen, Soll-/Haben-Salden.',

  [T.addAction]: 'Aktionen für Assistenten hinzufügen',
  [T.noParametersAction]: 'Aktion hat keine Parameter',
  [T.removeAll]: 'Alle entfernen',
  [T.addAll]: 'Alle hinzufügen',
  [T.connect]: 'Verbinden',
  [T.disconnect]: 'Trennen',
  [T.connected]: 'Verbunden',
  [T.notConnected]: 'Nicht verbunden',
  [T.connectors]: 'Schnittstellen',
  [T.manageConnectors]: 'Schnittstellen verwalten',
  [T.addConnector]: 'Schnittstelle hinzufügen',
  [T.addConnectors]: 'Schnittstellen hinzufügen',
  [T.connectorsModalDescription]:
    'Steigern Sie Ihre Produktivität mit Schnittstellen.',
  [T.searchConnector]: 'Schnittstelle suchen',
  [T.noConnectorsConnectedYetTitle]:
    'Es sind noch keine Schnittstellen verbunden.',
  [T.noConnectorsConnectedYetDescription]:
    'Gehen Sie zum Tab „Alle Schnittstellen“ und verbinden Sie eine Schnittstelle.\nIhre verbundenen Schnittstellen werden hier angezeigt.',
  [T.noRemainingConnectorsToConnectTitle]:
    'Es gibt derzeit keine weiteren Schnittstellen zum Verbinden.',
  [T.noRemainingConnectorsToConnectDescription]:
    'Alle Schnittstellen sind verbunden, es sind keine weiteren verfügbar.',
  [T.noConnectorMatchTitle]: 'Keine Schnittstelle mit diesem Namen gefunden.',
  [T.noConnectorMatchDescription]:
    'Suchen Sie die Schnittstelle über ihren genauen Namen oder durchsuchen Sie die vollständige Liste der Schnittstellen.',
  [T.showAll]: 'Alle anzeigen',
  [T.showLess]: 'Weniger anzeigen',
  [T.workflowsNavLabel]: 'Workflows',
  [T.connectorsDescription]:
    'Verbinden Sie Ihre Tools und nutzen Sie sie direkt in Assistants, um Arbeitsergebnisse in Echtzeit zu sehen.',
  [T.noConnectorsFound]: 'Es wurden noch keine Verbindungen hinzugefügt.',
  [T.askForConfirmation]: 'Um Bestätigung bitten',
  [T.askForConfirmationTooltip]:
    'Sie werden gebeten, diese Aktion im Chat zu bestätigen.',
  [T.toolPermissions]: 'Tool-Berechtigungen',
  [T.enableAll]: 'Alle aktivieren',
  [T.connectedActions]: 'Verbundene Aktionen',
  [T.actionsLibrary]: 'Aktionsbibliothek',
  [T.addActionsDescription]:
    'Fügen Sie Aktionen hinzu, die Ihr Assistent ausführen kann.',
  [T.noActionsConnectedYet]: 'Noch keine Aktionen verbunden',
  [T.addConnections]: 'Verbindungen hinzufügen',
  [T.enabledCount]: '{{count}}/{{total}} aktiviert',
  [T.addActions]: 'Aktionen hinzufügen',
  [T.connectorConfigDescription]:
    'Die ausgewählte Konfiguration wird auf alle Aktionsaufgaben in dieser Integration angewendet.',
  [T.connectorOwnConnectionQuestion]:
    'Sollen Benutzer dieses Assistenten ihre eigene {{connector}}-Verbindung für diese Aktion verwenden?',
  [T.connectorDefaultOption]:
    'Ja, Benutzer müssen ihr {{connector}}-Konto verbinden.',
  [T.connectorAdvancedOption]:
    'Nein, alle Benutzer sollen dieselbe, vorausgewählte Verbindung verwenden. (Erweitert)',
  [T.connectorAttentionDescription]:
    'Wählen Sie Ihre Verbindung sorgfältig. Jeder, der diesen Assistenten verwendet, kann über diese Aktion darauf zugreifen – stellen Sie daher sicher, dass sie allen Zugriffsrichtlinien entspricht.',
  [T.connectedSuccessfully]: 'Erfolgreich verbunden',
  [T.actionsLimitDescription]:
    'Sie können bis zu 10 Aktionen pro Assistenten hinzufügen.',
  [T.addConnectorDescription]:
    'Die ausgewählte Konfiguration wird auf alle Aktions-Aufgaben in dieser Integration angewendet.',
  [T.addActionDisclaimer]:
    'Sollten Benutzer dieses Assistenten ihre eigene {{action_category}} Verbindung für diese Aktion verwenden?',
  [T.defaultConnectionDisclaimer]:
    'Ja, Benutzer müssen ihr {{action_category}} verbinden.',
  [T.preSelectedDisclaimer]:
    'Nein, alle Benutzer sollten dieselbe, vorausgewählte Verbindung verwenden.',
  [T.attention]: 'Achtung',
  [T.rulesDisclaimer]:
    'Seien Sie vorsichtig bei der Auswahl einer Verbindung. Alle Benutzer dieses Assistenten können die Verbindung bei der Nutzung dieser Aktion verwenden. Stellen Sie sicher, dass dies keine Zugriffsregeln verletzt.',
  [T.addConnection]: 'Verbindung hinzufügen',
  [T.addNewAction]: 'Neue Aktion hinzufügen',
  [T.addNewActions]: 'Neue Aktionen hinzufügen',
  [T.action]: 'Aktionen',
  [T.preBuildActionText]:
    'Wählen Sie eine vorgefertigte Aktion oder erstellen Sie eine neue benutzerdefinierte Aktion, um sich mit externen Tools zu verbinden.',
  [T.noActionsAvailable]: 'Keine Aktionen verfügbar.',
  [T.authenticationDisclaimer]:
    'Der Benutzer muss sich zuerst authentifizieren, um diese Aktion auszuführen.',
  [T.authenticate]: 'Authentifizieren',
  [T.deny]: 'Ablehnen',
  [T.advanceConnectionAuthenticationMsg]:
    'Bitte bitten Sie den Besitzer dieses Assistenten, die Autorisierung erneut durchzuführen.',
  [T.addAdvanceConnectionTooltip]:
    'Bitte fügen Sie die Verbindung hinzu, um diese Aktion zu verwenden',

  [T.canvasResponseTooLong]:
    'Fehler beim Streamen der Leinwand. Antwort zu lang.',

  // Self Sign up
  [T.companyInfoDesc]: 'Wir würden gerne mehr über Sie erfahren...',
  [T.enterCompanyName]: 'Wie lautet der Name Ihres Unternehmens?',
  [T.firstName]: 'Vorname',
  [T.lastName]: 'Nachname',
  [T.confirmPassword]: 'Passwort bestätigen',
  [T.password]: 'Passwort',
  [T.emailVerification]: 'E-Mail-Verifizierung',
  [T.emailSentText]:
    'Wir haben eine E-Mail an {{email}} gesendet, um Ihre E-Mail-Adresse zu verifizieren.',
  [T.pleaseVerifyEmail]:
    'Bitte klicken Sie auf die Schaltfläche „E-Mail verifizieren“, um fortzufahren.',
  [T.contactUsText]: 'Für Hilfe kontaktieren Sie uns unter info@empowergpt.io',
  [T.notSeeingEmail]: 'E-Mail nicht erhalten?',
  [T.checkSpam]: 'Bitte überprüfen Sie Ihren Spam-Ordner oder ',
  [T.resendEmail]: ' E-Mail erneut senden',
  [T.companyNameRequired]: 'Firmenname ist erforderlich',
  [T.addCompanyName]: 'Firmennamen eingeben',
  [T.companySize]: 'Wie groß ist Ihr Unternehmen?',
  [T.companySizeRequired]: 'Unternehmensgröße ist erforderlich',
  [T.companySizeKey]: 'Unternehmensgröße',
  [T.roleText]: 'Welche Rolle haben Sie?',
  [T.roleRequired]: 'Rolle ist erforderlich',
  [T.basedCountry]: 'In welchem Land hat Ihr Unternehmen seinen Sitz?',
  [T.countrySelectionRequired]: 'Land ist erforderlich',
  [T.startFreeTrial]: 'Mein kostenloses Probeabo starten',
  [T.billing]: 'Abrechnung',
  [T.paymentMethod]: 'Zahlungsmethoden',
  [T.billingText]:
    'Verwalten Sie die Abrechnungsinformationen Ihrer Organisation.',
  [T.upgradePlan]: 'Plan upgraden',
  [T.paymentDesc]:
    'Die Standardmethode wird automatisch für alle Ihre Abonnements verwendet',
  [T.addPaymentMethod]: 'Zahlungsmethode hinzufügen',
  [T.noPaymentAdded]: 'Noch keine Zahlungsmethode hinzugefügt.',
  [T.trialLi1]: 'Zugang zu den Kernfunktionen von Chat und Assistenten',
  [T.trialLi2]: 'Starten Sie mit 5 € Guthaben für Chats und Dateinutzung',
  [T.trialLi3]: 'Fügen Sie bis zu 5 Teammitglieder hinzu',
  [T.trialLi4]: 'Sicherer Arbeitsbereich mit Basis-Verlauf',
  [T.trialLi5]: 'Eingeschränkter Zugang zu Mini-Experten',
  [T.trialLi6]: 'Perfekt zum Testen und Entdecken von EmpowerGPT',
  [T.essentialFeaturesHeading]: 'Monatliche Nutzungsgrenzen & Funktionen',
  [T.essentialLi1]: 'Chat mit KI auf Enterprise-Niveau mit Fair-Use-Richtlinie',
  [T.essentialLi2]: 'Dateiverarbeitung: 7 Millionen Wörter / 150+ Dateien',
  [T.essentialLi3]: 'Search Plus: 50 Suchanfragen',
  [T.essentialLi4]: '1 vorgefertigte App nutzen',
  [T.essentialLi5]: 'Doc Analyst: 3 Analysen (je bis zu 10 Fragen)',
  [T.essentialLi6]: 'OCR: 50 Dateien',
  [T.essentialTagline]: 'Ihr Einstieg in Enterprise-KI',
  [T.perMonthPerUser]: '/Monat pro Nutzer',
  [T.pricingUpgrade]: 'Upgrade',
  [T.yearly]: 'Jährlich',
  [T.save20]: '20 % sparen',
  [T.monthly]: 'Monatlich',
  [T.trial]: 'Testphase',
  [T.professional]: 'Professional',
  [T.essential]: 'Essentials',
  [T.freeTrial]: '7 Tage kostenlos testen',
  [T.trialCardText]:
    'Für alle, die die erstaunlichen Funktionen der EmpowerGPT-Produkte erleben möchten.',
  [T.currentPlan]: 'Aktueller Plan',
  [T.perMonth]: 'pro Monat',
  [T.essentialCardText]:
    'Start mit 1 Nutzer – 7-tägige kostenlose Testversion, keine Kreditkarte nötig, EU-gehostetes SaaS, digitaler Service-Support.',
  [T.upgrade]: 'Upgrade',
  [T.upgradeToPro]: 'Auf Pro upgraden',
  [T.upgradeToProfessional]: 'Upgrade auf Professional',
  [T.billedAnnually]: 'Jährlich abgerechnet',
  [T.letsTalk]: 'Lassen Sie uns reden',
  [T.contactSales]: 'Vertrieb kontaktieren',
  [T.billedMonthly]: 'Monatlich abgerechnet',
  [T.selfSignUpFailed]: 'Selbstregistrierung fehlgeschlagen',
  [T.passwordValidateFailure]:
    'Muss Großbuchstaben, Zahl & Sonderzeichen enthalten',
  [T.passwordMatchFailed]: 'Passwörter stimmen nicht überein',
  [T.firstNameRequired]: 'Vorname ist erforderlich',
  [T.firstNameInvalid]: 'speciale tekens of extra spaties zijn niet toegestaan',
  [T.lastNameRequired]: 'Nachname ist erforderlich',
  [T.lastNameInvalid]: 'speciale tekens of extra spaties zijn niet toegestaan',
  [T.passwordRequired]: 'Passwort ist erforderlich',
  [T.confirmPasswordRequired]: 'Passwortbestätigung ist erforderlich',
  [T.emailSuccessfullySend]:
    'Konto erfolgreich erstellt! Bitte bestätigen Sie Ihr Konto über die E-Mail, die wir Ihnen gesendet haben',
  [T.emailVerificationSuccessfullySend]:
    'E-Mail-Verifizierungslink erfolgreich gesendet! Bitte überprüfen Sie Ihren E-Mail-Posteingang für den Verifizierungslink.',
  [T.noAccount]: 'Noch kein Konto?',
  [T.seatManagement]: 'Sitzplatzverwaltung',
  [T.seatManagementDesc]:
    'Erweitern Sie Ihr Erlebnis, indem Sie zusätzliche Plätze zu Ihrem Tarif hinzufügen',
  [T.updateSeats]: 'Plätze aktualisieren',
  [T.updatePlan]: 'Plan aktualisieren',
  [T.availableSeat]: 'Verfügbare Plätze',
  [T.totalPrice]: 'Gesamtpreis',
  [T.updateSubscription]: 'Abonnement aktualisieren',
  [T.seats]: 'Plätze',
  [T.seatSelectorDescription]:
    'Fügen Sie mehr Plätze hinzu, um die Produktivität und Zusammenarbeit zu steigern.',
  [T.calculateTotal]: 'Gesamt berechnen',
  [T.purchasedPlan]: 'Gekaufter Plan',
  [T.orderSummary]: 'Bestellübersicht',
  [T.selectedPlan]: '{{plan}}-Plan',
  [T.proceedToPayment]: 'Mit der Zahlung fortfahren',
  [T.checkOutDesc]: 'Ihr Abonnement wird am {{date}} für {{price}} verlängert',
  [T.businessOwner]: 'Geschäftsinhaber',
  [T.seniorExecutive]: 'Führungskraft',
  [T.manager]: 'Manager',
  [T.associate]: 'Mitarbeiter',
  [T.other]: 'Andere',
  [T.executive]: 'Leitender Angestellter',
  [T.signup]: 'Jetzt registrieren',
  [T.signUpSuccess]: 'Weiterleitung zur Login-Seite',
  [T.trialEnds]: 'Ihre kostenlose Testphase endet in {{days}} Tagen am: ',
  [T.trialEndsToday]: 'Ihre kostenlose Testphase endet heute: ',
  [T.trialEndedTitle]: 'Ihre kostenlose Testphase ist beendet: ',
  [T.trialEndingOn]: 'Ihre kostenlose Testphase endet am:',
  [T.endsOn]: 'Endet am: ',
  [T.viewPlan]: 'Plan ansehen',
  [T.trialExpiredTitle]: 'Ihre kostenlose Testversion ist abgelaufen.',
  [T.subscriptionExpiredTitle]: 'Ihr Abonnement ist abgelaufen.',
  [T.subscriptionExpiredDesc]:
    'Um Empower GPT weiterhin zu nutzen, upgraden Sie bitte Ihren Plan.',
  [T.upgradeNow]: 'Jetzt upgraden',
  [T.excludingTax]: '(Ohne Steuern und MwSt.)',
  [T.month]: 'Monat',
  [T.vat]: 'MwSt.',
  [T.toBeCalculated]: 'Wird berechnet',
  [T.addCard]: 'Zahlungsmethode hinzufügen',
  [T.companyInfoFailure]:
    'Unternehmensinformationen konnten nicht gespeichert werden',
  [T.checkoutSuccessfully]: 'Plan erfolgreich aktualisiert',
  [T.subscriptionSuccessfullyUpdated]: 'Abonnement erfolgreich aktualisiert',
  [T.occupiedSeats]: 'Belegte Plätze',
  [T.newSeats]: 'Neue Plätze',
  [T.totalSeats]: 'Gesamtanzahl der Plätze',
  [T.currentAmount]: 'Abrechnungsanpassung: €{{amount}}',
  [T.newChargeAmount]:
    'Gesamtbetrag für den nächsten Abrechnungszeitraum: €{{amount}}',
  [T.discardChange]: 'Änderungen verwerfen',
  [T.userInvitePartialSuccess]:
    'Einige Benutzer wurden nicht eingeladen. {{emails}} von {{total}} fehlgeschlagen.',
  [T.errorCalculatingPreview]: 'Fehler beim Berechnen der Rechnung',
  [T.backTo]: 'Zurück zu ',
  [T.seatsNotAvailable]:
    'Bitte kaufen Sie weitere Plätze, um mehr Benutzer hinzuzufügen',
  [T.domainBlocked]:
    'Bitte geben Sie eine gültige, permanente E-Mail-Adresse an. Temporary or disposable email domains are not allowed.',
  [T.userAlreadyExist]: 'Benutzer existiert bereits',
  [T.updatePaymentMethod]: 'Zahlungsmethode aktualisieren',
  [T.errorGettingStripeDashboardUrl]:
    'Fehler beim Abrufen der Stripe-Dashboard-URL',
  [T.errorDiscoveringTenant]: 'Fehler beim Ermitteln des Mieters',
  [T.bestAIModelSelected]: 'Bestes KI-Modell ausgewählt',
  [T.essentials]: 'Essentials',
  [T.upgradeRestricted]: '⚠️ Upgrade eingeschränkt',
  [T.upgradeRestrictedInfo]:
    'Wenden Sie sich an Ihren Organisationsinhaber, um Ihren Plan zu upgraden.',
  [T.confirmCheckout]: 'Checkout bestätigen',
  [T.confirmCheckoutDesc]: 'Möchten Sie fortfahren?',
  [T.confirmPayment]: 'Zahlung bestätigen',
  [T.amountDeduction]: 'Betrag {{amount}} wird von Ihrem Konto abgebucht.',
  [T.confirmUpgrade]: 'Upgrade bestätigen',
  [T.updateSubscriptionDesc]:
    'Sind Sie sicher, dass Sie Ihr Abonnement upgraden möchten?',
  [T.minusSeatWarningDesc]:
    'Wenn Sie die Anzahl der Plätze reduzieren, wird die Änderung sofort wirksam. Sie können den entfernten Plätzen keine Benutzer mehr zuweisen, und die Abrechnungsanpassung wird ab dem nächsten Zyklus berücksichtigt.',
  [T.minusSeatWarningTitle]: 'Die Änderung wird sofort wirksam!',
  [T.minusSeatsDesc]:
    'Ihr Abonnement wird am Ende des aktuellen Abrechnungszeitraums aktualisiert.',
  [T.unableToPreviewInvoice]: 'Vorschau der Rechnung nicht möglich',
  [T.errorUpdatingSubscription]: 'Fehler beim Aktualisieren des Abonnements',
  [T.subscriptionSyncError]: 'Fehler bei der Synchronisierung des Abonnements',
  [T.noSubscription]: 'Abonnement konnte nicht gefunden werden',
  [T.invalidSubscription]: 'Ungültiges Abonnement',
  [T.wrongAddress]:
    'Der Steuersitz des Kunden ist ungültig oder wird nicht erkannt.',
  [T.subscriptionCancelledText]:
    'Keine bevorstehende Rechnung gefunden, das Abonnement könnte zur Kündigung vorgesehen sein.',
  [T.insufficientBalance]:
    'Die Karte hat unzureichendes Guthaben, um die Zahlung zu verarbeiten.',
  [T.endTrialError]:
    'Wir können die Zahlung nicht fortsetzen, bitte versuchen Sie es später noch einmal',
  [T.modelStatusDeprecated]:
    'Das Modell wurde erfolgreich als veraltet markiert.',
  [T.modelStatusDeprecatedError]:
    'Das ausgewählte Modell ist veraltet. Wählen Sie ein anderes.',
  [T.modelConfiguration]: 'Modellkonfiguration',
  [T.defaultChatModel]: 'Standard-Chatmodell',
  [T.defaultChatModelMoto]:
    'Wähle das Standardmodell für alle neuen Chats. Benutzer können es ändern, indem sie\nihr Standardmodell in den Kontoeinstellungen auswählen.',
  [T.modelConfigurationMoto]:
    'Wähle aus, welche Modelle in deinem Arbeitsbereich erlaubt sind',
  [T.searchModelsPlaceholder]: 'Modelle suchen.',
  [T.regionHostedEu]: 'In der EU gehostet',
  [T.regionHostedUs]: 'In den USA gehostet',
  [T.regionHostedGlobal]: 'Global gehostet',
  [T.regionHostedOther]: 'In {{region}} gehostet',
  [T.allModels]: 'Alle Modelle',
  [T.addNewModel]: 'Neues Modell hinzufügen',
  [T.editModel]: 'Modell bearbeiten',
  [T.modelName]: 'Modellname',
  [T.updateModel]: 'Modell aktualisieren',
  [T.modelName]: 'Modellname',
  [T.addDate]: 'Hinzugefügt am',
  [T.providedBy]: 'Bereitgestellt von',
  [T.knowledgeCutoffDate]: 'Wissenstand',
  [T.modelProvidedBy]: 'Modell bereitgestellt von',
  [T.modelDeploymentProvider]: 'Modellbereitstellungsanbieter',
  [T.modelUpdate]: 'Modell {{modelName}} {{status}}  aktualisiert',
  [T.enabled]: 'aktiviert',
  [T.disabled]: 'deaktiviert',
  [T.modelUpdateFailed]: 'Fehler beim Aktualisieren des Modells',
  [T.modelCreate]: 'Modell erfolgreich erstellt',
  [T.modelCode]: 'Modellcode',
  [T.modelPriority]: 'Modellpriorität',
  [T.ragCost]: 'RAG-Kosten',
  [T.ctFactor]: 'CT-Faktor',
  [T.ptFactor]: 'PT-Faktor',
  [T.modelRegion]: 'Region',
  [T.modelAvailabilityInFeature]: 'Verfügbarkeit des Modells in Funktionen',
  [T.deprecate]: 'Veraltet',
  [T.confirmDeprecateModelMessage]:
    'Sind Sie sicher, dass Sie dieses Modell veralten lassen möchten?',
  [T.scoringAnalysisDisclaimer]:
    'Scoring-Analyse in der Beta-Version veröffentlicht. Es können Abweichungen auftreten.',
  [T.cardActionRequiredError]:
    'Zusätzliche Benutzeraktion ist erforderlich, um die Zahlung abzuschließen.',
  [T.cardExpiredError]: 'Die Zahlung wurde vom Anbieter abgelehnt.',
  [T.analysisQuestionLimitReached]: 'Analyse-Fragenlimit erreicht',
  [T.paymentFailedError]:
    'Der Zahlungsversuch ist fehlgeschlagen, bitte versuchen Sie es erneut.',
  [T.stripeTenantNotFoundError]: 'Der Mandant existiert nicht.',
  [T.tenantDomainAlreadyExistsError]: 'Die Domain existiert bereits.',
  [T.searchTenantNotFoundError]: 'Der gesuchte Mieter wurde nicht gefunden.',
  [T.activeSubscriptionAlreadyExistsError]:
    'Sie haben bereits ein aktives Abonnement.',
  [T.upgradeYearlyPlan]: 'Upgrade auf Jahresplan',
  [T.upgradeToYearly]: 'Auf Jahresabo upgraden',
  [T.upgradeToYearlyDesc]: 'Auf Jahresabo upgraden und bis zu 10 % sparen.',
  [T.shiftToYearlyPlan]: 'Auf Jahresabo wechseln',
  [T.upgradeToYearlyPlanButton]: 'Auf Jahresabo upgraden',
  [T.totalAmountToPayLine]: 'Gesamtbetrag zu zahlen: {{amount}}',
  [T.confirmYearlyUpgrade]: 'Jahres-Upgrade bestätigen',
  [T.confirmYearlyUpgradeAmount]:
    'Der Betrag {{amount}} wird von Ihrem Konto abgebucht.',
  [T.confirmYearlyUpgradeQuestion]: 'Möchten Sie fortfahren?',
  [T.cancelled]: 'Storniert',
  [T.updatedSubscriptionRequired]:
    'Ein aktives Abonnement ist erforderlich, um Sitze zu aktualisieren.',
  [T.subscriptionUpgradedSuccessfully]: 'Abonnement erfolgreich aktualisiert.',
  [T.subscriptionUpgradeFailed]:
    'Aktualisierung des Abonnements fehlgeschlagen.',
  [T.trialAlreadyExpired]: 'Testversion ist bereits abgelaufen',
  [T.subscriptionUpdateNotAllowed]:
    'Das Abonnement ist gekündigt, Zahlungen sind nicht erlaubt.',
  [T.minimumSeatsViolation]: 'Mindestanzahl an Plätzen verletzt',
  [T.maximumSeatsViolation]:
    'Die maximale Anzahl an Sitzplätzen in Ihrem Plan beträgt 250. Bitte wenden Sie sich an den Vertrieb, um fortzufahren.',
  [T.subscriptionRenewalNotAllowed]:
    'Die Verlängerung des Abonnements ist nicht zulässig, das Abonnement könnte auf Kündigung gesetzt sein',
  [T.subscriptionUpdateError]: 'Fehler beim Aktualisieren des Abonnements',
  [T.proceedToUpgrade]: 'Mit Upgrade fortfahren',
  [T.upgradeConfirmDesc]:
    'Sind Sie sicher, dass Sie Ihr Abonnement auf einen Jahresplan umstellen möchten?',
  [T.expired]: 'Abgelaufen',
  [T.uploadFailed]: 'UPLOAD_FEHLGESCHLAGEN',
  [T.retryMsg]: 'Fehler beim Hochladen von {{ name }}. Bitte erneut versuchen.',
  [T.documentRemoved]: 'Dokument erfolgreich entfernt',
  [T.domainNotRecognized]: 'Domain wird nicht erkannt!',
  [T.domainInvalidFormat]:
    'Geben Sie einen gültigen Domainnamen ein (Sonderzeichen und Großbuchstaben sind nicht zulässig).',
  [T.domainNotRegistered]: 'Die Domain {{domain}} ist nicht registriert.',
  [T.validDomainRequired]:
    'Bitte verwenden Sie einen gültigen Domain-Link zur Anmeldung.',
  [T.checkEmailForDomain]:
    'Sie finden die registrierte Domain in Ihrer E-Mail. Für weitere Unterstützung kontaktieren Sie uns unter info@empowergpt.ai',
  [T.dontRememberDomain]: 'Domain vergessen?',
  [T.loginFromThisLink]: 'Bitte melden Sie sich über diesen Link an:',
  [T.linkPlaceholder]: 'Link',
  [T.alreadyHaveAccount]: 'Sie haben bereits ein Konto?',
  [T.userAlreadyExists]: 'Dieser Benutzer existiert bereits.',
  [T.login]: 'Anmelden',
  [T.signupInfo]:
    'Unternehmens-KI für Text, Sprache, Bilder und Wissen – sicher und einsatzbereit',
  [T.workEmail]: 'Geschäftliche E-Mail-Adresse',
  [T.emailRequired]: 'E-Mail-Adresse erforderlich',
  [T.recaptchaRequired]: 'Bitte bestätigen Sie, dass Sie ein Mensch sind.',
  [T.signupConfirmation1]:
    'Eine Einladung wurde an Ihre E-Mail-Adresse gesendet.',
  [T.signupConfirmation2]:
    'Klicken Sie in der erhaltenen E-Mail auf die Schaltfläche „Weiter“, um Ihr Konto einzurichten. Der Einladungslink läuft nach 14 Tagen ab',
  [T.login]: 'Anmelden',
  [T.creatingTenant]: 'Mandanten werden erstellt',
  [T.settingUpWorkspaces]: 'Arbeitsbereiche werden eingerichtet',
  [T.configuringPreferences]: 'Einstellungen werden konfiguriert',
  [T.finalizingAccountSettings]: 'Kontoeinstellungen werden abgeschlossen',
  [T.welcome]: 'Willkommen',
  [T.welcomeAndSignIn]: 'Willkommen und Anmelden',
  [T.signIn]: 'Anmelden',
  [T.compareModelTitle]: 'Modelle vergleichen',
  [T.compareModelDescription]: 'Seite an Seite',
  [T.chatHelperText]:
    '<highlight>Hi,\u00A0</highlight> <span>Wie kann ich Ihnen heute helfen?</span>',
  [T.verifyingUser]: 'Benutzer wird verifiziert...',
  [T.credentialVerifying]:
    'Bitte warten Sie, während wir Ihre Anmeldedaten überprüfen.',
  [T.setUpPassword]: 'Richten Sie Ihr Kontopasswort ein',
  [T.passwordGuide]:
    'Ein sicheres Passwort hilft, unbefugten Zugriff auf Ihr E-Mail-Konto zu verhindern.',
  [T.reEnterPassword]: 'Passwort erneut eingeben',
  [T.verificationFailed]: 'Verifizierung fehlgeschlagen',
  [T.verificationFailedDescription]:
    'Die Überprüfung ist aufgrund des Ablaufs der E-Mail fehlgeschlagen!',
  [T.returnToLogin]: 'Zurück zur Anmeldung',
  [T.passwordLength]: 'Mindestens 8 Zeichen erforderlich',
  [T.specialCaseWarning]: 'Fügen Sie mindestens ein Sonderzeichen hinzu',
  [T.passwordNotMatched]: 'Passwörter stimmen nicht überein',
  [T.passwordRequirementSpecial]: 'Mindestens ein Sonderzeichen',
  [T.passwordRequirementUppercase]: 'Mindestens ein Großbuchstabe',
  [T.passwordRequirementLowercase]: 'Mindestens ein Kleinbuchstabe',
  [T.passwordRequirementNumber]: 'Mindestens eine Zahl',
  [T.passwordRequirementMinLength]: 'Mindestens 8 Zeichen',
  [T.passwordRequirementMatch]: 'Passwort muss übereinstimmen',
  [T.organizationSubDomain]: 'Organisations-Subdomain',
  [T.organizationSubDomainPlaceholder]: 'ihre-organisation',
  [T.checkAvailability]: 'Verfügbarkeit prüfen',
  [T.domainAvailable]: 'Domain ist verfügbar',
  [T.domainUnavailable]: 'Domain ist nicht verfügbar',

  [T.verifyEmail]: 'E-Mail verifizieren',
  [T.sentEmailMessage]: 'Wir haben eine E-Mail gesendet an ',
  [T.verificationEmailMessage]:
    'Klicken Sie einfach auf den Link in der E-Mail, um Ihre Registrierung abzuschließen. Falls Sie sie nicht sehen, überprüfen Sie bitte Ihren <span>Spam-Ordner</span>.',
  [T.resendVerificationEmail]: 'Bestätigungs-E-Mail erneut senden',
  [T.changeEmail]: 'E-Mail ändern',

  [T.fillDetailMsg]: 'Bitte füllen Sie die Angaben aus, um zu beginnen.',
  [T.continueWithGoogle]: 'Mit Google fortfahren',
  [T.continueWithMicrosoft]: 'Mit Microsoft fortfahren',

  [T.dedicatedLoginUrl]:
    'Nach der Registrierung erstellen wir Ihre persönliche Login-URL',
  [T.marketingConsent]:
    'Ich stimme zu, E-Mail-Updates zum Onboarding-Leitfaden, zu Produkten, Dienstleistungen und Neuigkeiten von INTECH Automation & Intelligence GmbH zu erhalten.',

  [T.or]: 'Oder',
  [T.example]: 'Beispiel: ',
  [T.enterEmail]: 'E-Mail eingeben',

  [T.trialHeading]: 'Starten Sie Ihre 7-tägige EmpowerGPT Testversion!',
  [T.trialDescription]:
    'Genießen Sie vollen Zugriff ohne Risiko. Sie können jederzeit kündigen – ohne Verpflichtungen.',
  [T.trustedEnterprise]:
    'Vertrauenswürdig für Unternehmenswissen, Compliance und Datenschutz interner Daten.',

  [T.noCreditCard]: 'Keine Kreditkarte erforderlich',
  [T.secureKnowledge]: 'Sichere Wissenssuche (RAG)',
  [T.teamReady]: 'Teamfähige Umgebung mit privatem KI-Arbeitsbereich',
  [T.teamReadyEnvironment]: 'Teamfähige Umgebung',
  [T.anyDocumentUpload]: 'Beliebig viele Dokumente hochladen und durchsuchen',
  [T.easyUpgrade]: 'Einfache Upgrade-Möglichkeit beim Wechsel zu Enterprise',

  [T.compliance]: 'Compliance',
  [T.freeTrial7DayHeading]: 'Ihre 7-tägige kostenlose Testversion beinhaltet:',
  [T.readyLoginUrl]: 'Ihre Login-URL ist bereit',
  [T.yourLoginUrl]: 'Ihre Anmelde-URL lautet:',
  [T.bookMarkUrl]:
    'Setzen Sie ein Lesezeichen für diese Anmelde-URL – Sie werden sie jedes Mal zum Anmelden verwenden.',
  [T.copyUrl]: 'URL kopieren',
  [T.startOnboarding]: 'Beginnen Sie mit dem Onboarding',
  [T.needHelp]: 'Benötigen Sie Hilfe? Kontaktieren Sie uns unter',
  [T.welcome]: 'Willkommen',
  [T.manageConnectorAccess]:
    'Verwalten Sie, wer Zugriff auf diesen Connector hat und was er tun kann.',
  [T.sqlDatabaseConnectionString]: 'Datenbankverbindungszeichenfolge (DSN)',
  [T.sqlDatabaseConnectionStringInvalid]:
    'Ungültiges DSN-Format. Unterstützt: postgres://, mysql://, mariadb://, sqlserver://',
  [T.sqlDatabaseSupportedFormats]: 'Unterstützte Formate:',
  [T.sapClientIdLabel]: 'SAP Client-ID',
  [T.sapClientIdPlaceholder]: 'SAP-Client-ID angeben',
  [T.sapClientIdRequired]: 'OAuth-Client-ID ist erforderlich',
  [T.sapClientIdInvalid]:
    'Ungültiges Format der Client-ID. Nur Buchstaben verwenden, Unterstriche sind zwischen Wörtern erlaubt (z. B. my_client_id).',
  [T.sapTenantIdLabel]: 'SAP-Mandanten-Subdomain',
  [T.sapTenantIdPlaceholder]: 'my300123',
  [T.sapTenantIdHelperText]:
    'Wird zum Erstellen der Auth-, Token- und Benutzerinfo-URLs verwendet.',
  [T.sapTenantIdRequired]: 'SAP-Mandanten-Subdomain ist erforderlich',
  [T.sapTenantIdInvalid]:
    'Ungültiges Format der Mandanten-Subdomain. Nur Kleinbuchstaben, Zahlen und Bindestriche verwenden, beginnend und endend mit einem Buchstaben oder einer Zahl (z. B. my300123).',
  [T.requiredText]: 'Erforderlich',
  [T.paymentPlanCreationFailed]: 'Fehler bei der Erstellung des Zahlungsplans',
  [T.paymentPlanAlreadyExist]:
    'Ein Zahlungsplan für diesen Mandanten existiert bereits',
  [T.paymentPlanUpdateFailed]:
    'Fehler bei der Aktualisierung des Zahlungsplans',

  // Data Library
  [T.failed]: 'Fehlgeschlagen',
  [T.clickAndNameYourFolder]: 'Klicken und benennen Sie Ihren Ordner',
  [T.createNewFolder]: 'Neuen Ordner erstellen',
  [T.viewOnlyAccessTitle]: 'Sie haben nur Lesezugriff auf die Daten.',
  [T.viewOnlyAccessDescription]:
    'Dies ist schreibgeschützt. Sie können den Inhalt nur anzeigen.',
  [T.theFolderIsEmpty]: 'Der Ordner ist leer',
  [T.uploadAndImportNewFiles]: 'Neue Ordner/Dateien hochladen und importieren',
  [T.folderEmptyDescription]:
    'Dieser Ordner ist leer. Es gibt nichts anzuzeigen.',
  [T.uploadSupportedFormatsDescription]:
    'Laden Sie Ihre Dokumente oder Ordner in den folgenden unterstützten Formaten und Grenzen hoch!',
  [T.nameCollection]: 'Sammlung benennen',
  [T.webLinks]: 'Weblinks',
  [T.addedCountOf5]: '{{count}}/5 Hinzugefügt',
  [T.addWebLink]: 'Weblink hinzufügen',
  [T.uploadingEllipsis]: 'Wird hochgeladen...',
  [T.documentsUploadedSuccessfully]:
    '{{count}} Dokumente erfolgreich hochgeladen.',
  [T.documentUploadFailed]: '{{count}} Dokument-Upload ist fehlgeschlagen.',
  [T.uploadingFilesCount]: '{{count}} Dateien werden hochgeladen...',
  [T.scanningFilesCount]:
    '{{processed}} von {{total}} Dateien werden gelesen...',
  [T.preparingFolderFiles]: 'Ihre Dateien werden vorbereitet...',
  [T.uploadedFileSingular]: '{{count}} Datei hochgeladen',
  [T.uploadedFilePlural]: '{{count}} Dateien hochgeladen',
  [T.filesUploadedOfSingular]:
    '{{successCount}} von {{fileCount}} Datei hochgeladen',
  [T.filesUploadedOfPlural]:
    '{{successCount}} von {{fileCount}} Dateien hochgeladen',
  [T.uploadingFileSingular]: '{{count}} Datei wird hochgeladen',
  [T.uploadingFilePlural]: '{{count}} Dateien werden hochgeladen',
  [T.retryFailedDocument]: 'Fehlgeschlagenes Dokument erneut versuchen',
  [T.abortUpload]: 'Das Hochladen abbrechen?',
  [T.abortUploadDescription]:
    'Wenn Sie diese Seite verlassen, werden Ihre laufenden Uploads abgebrochen. Möchten Sie wirklich fortfahren?',
  [T.yesAbortAll]: 'Ja, alle abbrechen',
  [T.noKeepUploading]: 'Nein, weiter hochladen',
  [T.supportedDocFormats]:
    'PDF, PPT, PPTX, DOC, DOCX, ODS, ODP, ODT, RTF (300 MB)',
  [T.supportedMediaFormats]: 'MP3, MP4, MPGA, MPEG, WAV, M4A, WEBM (400 MB)',
  [T.supportedSpreadsheetFormats]: 'XLS, XLSX, CSV, TXT (50 MB)',
  [T.itemSelected]: '{{count}} Element ausgewählt',
  [T.itemsSelected]: '{{count}} Elemente ausgewählt',
  [T.selectAll]: 'Alle auswählen',
  [T.userOrUserGroups]: 'Benutzer oder Benutzergruppen',
  [T.searchByNameOrEmail]: 'Nach Name oder E-Mail-Adresse suchen...',
  [T.searchByExistingNameOrEmail]:
    'Vorhandenen Benutzer nach Name oder E-Mail suchen...',
  [T.loadingMore]: 'Mehr laden...',
  [T.noMoreItemsToLoad]: 'Keine weiteren Elemente zum Laden',
  [T.unsupportedFilesLabel]: 'Nicht unterstützte Dateien',
  [T.modifiedSyncBy]: 'Geändert/Synchronisiert von',
  [T.modifiedOrSyncBy]: 'Geändert von oder Synchronisiert von',
  [T.modifiedSyncOn]: 'Geändert/Synchronisiert am',
  [T.modifiedOrSyncOnTime]: 'Änderungsdatum oder Synchronisierungsdatum',
  [T.statusOfResource]: 'Status der Ressource',

  // Data Library Dialogs
  [T.areYouSure]: 'Sind Sie sicher?',
  [T.actionCannotBeUndone]:
    'Diese Aktion kann nicht rückgängig gemacht werden. Alle aktuellen Fortschritte gehen verloren.',
  [T.aiOverview]: 'KI-Übersicht',
  [T.summaryNotAvailable]:
    'Zusammenfassung ist für diese Ressource nicht verfügbar.',
  [T.undetected]: 'Nicht erkannt',
  [T.resourceNameLabel]: '{{resource}}-Name',
  [T.nameYourResource]: 'Benennen Sie Ihr(e) {{resource}}',
  [T.remove]: 'Entfernen',
  [T.searchSharedUsers]: 'Geteilte Benutzer suchen...',
  [T.whoHasAccess]: 'Wer hat Zugriff',
  [T.noMatchesFound]: 'Keine Übereinstimmungen gefunden',
  [T.noUsersHaveAccess]: 'Keine Benutzer haben Zugriff',
  [T.permissionSettings]: 'Berechtigungseinstellungen',
  [T.selectDestinationFolder]: 'Zielordner auswählen',
  [T.accessOnly]: 'Nur Zugriff',
  [T.pastLocation]:
    'Vorheriger Speicherort: {{folder}}-Ordner im {{workspace}}-Arbeitsbereich',
  [T.movePermissionTitle]: 'Berechtigung zum Verschieben',
  [T.movePermissionDescription]:
    'Sie können Ihre Dateien nur in Arbeitsbereiche/Ordner verschieben, in denen Sie die Berechtigung zum Verschieben haben!',
  [T.noResourceFoundHere]: 'Keine Ressource hier gefunden',
  [T.importFromExternalApps]: 'Aus externen Apps importieren',
  [T.integrationNotFound]: 'Integrationstyp "{{type}}" nicht gefunden.',
  [T.navigateSharePoint]:
    'Navigieren Sie zum Zielordner oder zur Bibliothek, um mit dem Import zu beginnen.',
  [T.navigateOneDrive]:
    'Navigieren Sie in Ihrem OneDrive und wählen Sie den Zielordner oder die Datei zum Importieren aus.',
  [T.navigateConfluence]:
    'Navigieren Sie durch Ihre Confluence-Bereiche und Seiten.',
  [T.failedToLoadSharePoint]: 'SharePoint-Daten konnten nicht geladen werden.',
  [T.failedToLoadOneDrive]: 'OneDrive-Daten konnten nicht geladen werden.',
  [T.failedToLoadConfluence]: 'Confluence-Daten konnten nicht geladen werden.',
  [T.navigateGoogleDrive]:
    'Navigieren Sie in Google Drive und wählen Sie den Zielordner oder die Datei aus, die Sie importieren möchten.',
  [T.failedToLoadGoogleDrive]:
    'Das Laden der Google Drive-Daten ist fehlgeschlagen.',
  [T.googleDriveMyDrive]: 'Mein Drive',
  [T.googleDriveSharedDrives]: 'Freigegebene Laufwerke',
  [T.openInGoogleDrive]: 'In Google Drive öffnen',
  [T.noItemsFound]: 'Keine Elemente gefunden.',
  [T.noSpacesOrPagesFound]: 'Keine Bereiche oder Seiten gefunden.',
  [T.mySpaces]: 'Meine Bereiche',
  [T.sharedSpaces]: 'Geteilte Bereiche',
  [T.myDrive]: 'Mein Laufwerk',
  [T.sharedWithMeLabel]: 'Mit mir geteilt',
  [T.open]: 'Öffnen',
  [T.viewer]: 'Betrachter',
  [T.shareResourceTitle]: 'Teilen - {{name}}',

  // Data Library Header, Hooks & Utils
  [T.viewOnlyAccess]: 'Nur ansehen',
  [T.noPermissionToCreateResources]:
    'Sie haben keine Berechtigung, Ressourcen zu erstellen.',
  [T.clearFilter]: 'Filter löschen',
  [T.inProgressStatus]: 'In Bearbeitung',
  [T.retryingStatus]: 'Wiederholung',
  [T.unsupportedStatus]: 'Nicht unterstützt',
  [T.openInLabel]: 'Öffnen in',
  [T.synced]: 'Synchronisiert',
  [T.workspacesSecuredDescription]:
    'Verwenden Sie gesicherte und zugriffskontrollierte Arbeitsbereiche für die private Zusammenarbeit.',
  [T.myWorkspaceDescription]:
    'Inhalte in „Mein Arbeitsbereich" sind nur für Sie zugänglich.',
  [T.publicWorkspaceDescription]:
    'Inhalte unter „Öffentlich" werden mit allen Benutzern geteilt.',
  [T.entityActionSuccess]: '{{entity}} {{action}} erfolgreich.',
  [T.failedToActionEntity]: '{{entity}} konnte nicht {{action}} werden.',
  [T.cannotImportIntoPublicWorkspace]:
    'Import in einen öffentlichen Arbeitsbereich nicht möglich',
  [T.cannotImportIntoPrivateWorkspace]:
    'Import in einen privaten Arbeitsbereich nicht möglich',
  [T.noExternalIntegrations]:
    'Sie können keine Daten aus Drittanbieterquellen importieren, solange Sie diese nicht in den Einstellungen konfiguriert haben.',
  [T.keepExistingRolesOnSubItems]:
    'Bestehende Rollen für Unterelemente beibehalten',
  [T.applyToAllSubFoldersAndFiles]: 'Auf alle Unterordner und Dateien anwenden',
  [T.applyToFilesOnly]: 'Nur auf Dateien anwenden',
  [T.resourceNameIsRequired]: 'Der Name der Ressource ist erforderlich',
  [T.cannotAssignRegularUserAsController]:
    'Regulärer Benutzer kann nicht als Controller des Arbeitsbereichs zugewiesen werden',
  [T.unauthorizedUsersNotAllowedAsController]:
    'Nicht autorisierte Benutzer sind nicht als Controller des Arbeitsbereichs zulässig',
  [T.selectAtLeastOneUserOrGroup]:
    'Bitte wählen Sie mindestens einen Benutzer oder eine Gruppe aus',
  [T.pleaseSelectRole]: 'Bitte wählen Sie eine Rolle aus',
  [T.pleaseSelectAssignmentStrategy]:
    'Bitte wählen Sie eine Zuweisungsstrategie aus',
  [T.collectionNameIsRequired]: 'Sammlungsname ist erforderlich',
  [T.collectionNameTooShort]: 'Sammlungsname ist zu kurz',
  [T.invalidUrl]: 'Ungültige URL',
  [T.atLeastOneLinkRequired]: 'Mindestens ein gültiger Link ist erforderlich',
  [T.sharedTab]: 'Geteilt',
  [T.updated]: 'aktualisiert',
  [T.created]: 'erstellt',
  [T.modified]: 'Geändert',
  [T.disableGoogleSSOToEnableThisOption]:
    'Deaktivieren Sie Google SSO, um diese Option zu aktivieren',
  [T.disableMicrosoftSSOToEnableThisOption]:
    'Deaktivieren Sie Microsoft SSO, um diese Option zu aktivieren',
  [T.maxLimitExceeded]: 'Sie haben das maximale Limit überschritten.',
  [T.disableGoogleSSOToEnableThisOption]:
    'Deaktivieren Sie Google SSO, um diese Option zu aktivieren',
  [T.disableMicrosoftSSOToEnableThisOption]:
    'Deaktivieren Sie Microsoft SSO, um diese Option zu aktivieren',
  [T.resourceDeletionFailed]: 'Ressourcenlöschung fehlgeschlagen.',
  [T.resourceDeleteSuccess]: 'Ressource erfolgreich gelöscht.',
  [T.cannotRemoveYourself]:
    'Du kannst dich nicht selbst aus der Liste der geteilten Inhalte entfernen',
  [T.adTokenExpired]:
    'Die Verbindung zum Chat-Stream wurde unterbrochen. Die Seite wird in {{seconds}} Sekunden neu geladen…',
  [T.dataHostedByThirdPartiesComesWithSharingRestrictions]:
    'Für Daten, die von Dritten gehostet werden, gelten Beschränkungen hinsichtlich der Weitergabe!',
  [T.contentVisibilityDependsEntirelyOnItsSourcePermissionsExceptWhenItIsInPublicOrMyWorkspace]:
    'Die Sichtbarkeit von Inhalten hängt vollständig von den Berechtigungen der Quelle ab, es sei denn, sie befinden sich im Ordner „Öffentlich“ oder „Mein Arbeitsbereich“.',
  [T.retry]: 'Erneut versuchen',
  [T.retryAll]: 'Alle erneut versuchen',
  [T.cancelAll]: 'Alle abbrechen',
  [T.syncingDescription]:
    'Bitte haben Sie einen Moment Geduld! Wir synchronisieren gerade Ihre Daten von Ihrem Drittanbieter.',
  [T.syncingTitle]: 'Ihre Daten werden gerade synchronisiert.',
  [T.syncFailedTitle]: 'Die Datensynchronisierung ist fehlgeschlagen.',
  [T.syncFailedDescription]:
    'Die Datensynchronisierung ist fehlgeschlagen! Versuchen Sie es erneut über die Schaltfläche „Importieren“.',
  [T.editAvailableModels]: 'Verfügbare Modelle bearbeiten',
  [T.thinkingEffort]: 'Denkaufwand',
  [T.chooseThinkingEfforts]: 'Denkaufwand wählen',
  [T.thinkingEffortDescription]:
    'Höherer Aufwand bedeutet ausführlichere Antworten, dauert aber länger und verbraucht Ihre Limits schneller.',
  [T.off]: 'Aus',
  [T.minimal]: 'Minimal',
  [T.low]: 'Niedrig',
  [T.high]: 'Hoch',
  [T.xhigh]: 'Extra',
  [T.max]: 'Maximal',
  [T.hostedGloballyByProvider]: 'Global von {{provider}} gehostet',
  [T.hostedInRegionByProvider]: 'In der {{region}} von {{provider}} gehostet',
  [T.model_Llama_3_1_405B_description]:
    'Größtes Open-Weights-LLM. Ideal für mehrsprachige Aufgaben, RAG-Pipelines und großskalige Enterprise-On-Prem-Deployments.',
  [T.model_Llama_3_2_90B_description]:
    'Effizientes multimodales Open-Weights-Modell mit Bildverständnis. Ideal für Vision-Aufgaben und Self-Hosted-Inference.',
  [T.model_deepseek_v3_description]:
    'Fortschrittlichstes Reasoning-Modell mit 1M Kontext und 2× ARC-AGI-2-Verbesserung gegenüber Gemini 3 Pro. Ideal für komplexe Forschung, agentisches Coding und multimodale Aufgaben.',
  [T.model_gpt_5_description]:
    'Unified Flagship-Modell von OpenAI. Ideal für komplexes Reasoning, Coding und agentische Wissensarbeit über mehr als 40 professionelle Domänen hinweg.',
  [T.model_minio1_description]:
    'Leichtgewichtiges Reasoning-Modell. Ideal für schnelle, kosteneffiziente analytische Aufgaben ohne Bedarf an voller o-Series-Rechenleistung.',
  [T.model_Mistral_large_description]:
    'Starkes mehrsprachiges Modell mit EU-Datenresidenz. Ideal für europäische Enterprise-Anwendungsfälle, Coding und compliance-sensible Deployments.',
  [T.model_gemini_3_1_pro_description]:
    'Fortschrittlichstes Reasoning-Modell von Google mit 1M Kontext und 2× ARC-AGI-2-Verbesserung gegenüber Gemini 3 Pro. Ideal für komplexe Forschung, agentisches Coding und multimodale Aufgaben.',
  [T.model_gemini_3_pro_preview_description]:
    'Bessere Konzeption, verbesserte Token-Effizienz und ein fundierteres, sachlich konsistentes Erlebnis.',
  [T.model_gpt_5_2_description]:
    'Starkes Allzweckmodell mit Instant-, Thinking- und Pro-Modi. Ideal für alltägliche Wissensarbeit und mehrstufige agentische Workflows.',
  [T.model_gpt_5_3_chat_description]:
    'Coding-fokussierter GPT-5-Nachfolger für autonome Softwareentwicklung. Ideal für professionelle Entwickler und langlaufende Coding-Agenten.',
  [T.model_claude_opus_4_6_description]:
    'Leistungsstärkstes Modell von Anthropic. Ideal für tiefes Reasoning, Forschungssynthese und komplexe Dokumentenanalyse.',
  [T.model_claude_sonnet_4_6_description]:
    'Schnelles und sehr leistungsfähiges Allround-Modell. Ideal für Coding, Dokumentenanalyse und strukturierte Business-Aufgaben mit hohem Durchsatz.',
  [T.model_gemini_2_0_flash_description]:
    'Extrem schnelles und kosteneffizientes multimodales Modell. Ideal für großvolumige Q&A und latenzkritische Anwendungen.',
  [T.model_gemini_2_5_flash_description]:
    'Verbesserte Flash-Version mit höherer Geschwindigkeit und Genauigkeit. Ideal für schnelle multimodale Aufgaben und längere Kontexte.',
  [T.model_gpt_4o_description]:
    'Schnelles multimodales Modell mit nativer Sprach- und Bildverarbeitung. Ideal für Echtzeit-Interaktionen und den Alltagseinsatz.',
  [T.model_gpt_5_1_description]:
    'Verfeinertes GPT-5-Modell mit automatischer Umschaltung zwischen Instant- und Thinking-Modus. Ideal für personalisierte, kontrollierbare Alltagsaufgaben.',
  [T.model_o1_description]:
    'Deep-Reasoning-Modell mit expliziter Chain-of-Thought. Ideal für Mathematik, Logik und fortgeschrittene STEM-Probleme.',
  [T.model_gpt_4_1_description]:
    'Langkontext-Spezialist mit 1M Token Fenster. Ideal für große Codebasen, juristische Dokumente und Multi-Dokument-RAG-Pipelines.',
  [T.model_gpt_5_4_description]:
    'Frontier-Modell, das Reasoning, Coding und agentische Workflows kombiniert. Ideal für komplexe Produktionsaufgaben mit geringer Halluzination.',
  [T.model_gpt_4_32k_description]:
    'GPT-4 mit erweitertem 32K-Kontextfenster. Ideal für lange Dokumentaufgaben, die GPT-4-Qualität ohne Zugriff auf neuere Modelle erfordern.',
  [T.model_Llama_3_70B_Instruct_description]:
    '70B Instruction-Modell der vorherigen Generation. Ideal für allgemeine Aufgaben in Self-Hosting-Umgebungen mit begrenztem Budget.',
  [T.model_Mistral_large_02_description]:
    'Aktualisiertes Mistral Large mit verbesserter Instruction-Following- und Coding-Leistung. Ideal für europäische Enterprise-Workloads mit stärkerer Code-Generierung.',
  [T.model_cohere_description]:
    'Speziell für Enterprise-RAG und Tool-Use entwickelt. Ideal für Retrieval-Augmented Generation, Grounded Q&A und strukturierte Daten-Workflows.',
  [T.model_Llama_3_1_8b_Instruct_description]:
    'Leichtgewichtiges Open-Weights-Modell. Ideal für On-Device- oder Low-Latency-Inferenz bei begrenzten Rechenressourcen.',
  [T.model_Llama_3_1_70B_Instruct_description]:
    'Mittelgroßes Open-Weights-Modell. Ideal für Instruction-Following, Zusammenfassungen und Self-Hosting mit ausgewogenem Kosten-Leistungs-Verhältnis.',
  [T.model_gpt_3_5_turbo_description]:
    'Schnelles und kostengünstiges Allzweckmodell. Ideal für hochvolumige, latenzsensitive Aufgaben, bei denen die Ausgabequalität zweitrangig ist.',
  [T.model_gpt_3_5_turbo_16k_description]:
    'GPT-3.5 Turbo mit erweitertem Kontextfenster. Ideal für einfache lange Dokumentaufgaben bei minimalen Kosten.',
  [T.model_gpt_4_description]:
    'Originale GPT-4-Version. Ideal für allgemeines Reasoning und Sprachaufgaben; weitgehend durch neuere Modelle ersetzt.',
  [T.model_gpt_4_turbo_description]:
    'Schnellere und günstigere GPT-4-Variante mit 128K Kontext. Ideal für kostensensitive Aufgaben mit GPT-4-Qualität.',
  [T.model_grok_3_description]:
    'Flaggschiff-Modell von xAI mit Zugriff auf Echtzeitdaten von X (Twitter). Ideal für STEM-Reasoning, Live-Trendanalysen und Social-Intelligence-Aufgaben.',
  [T.model_minio4_description]:
    'Leichtgewichtiges Reasoning-Modell. Ideal für schnelle, kosteneffiziente analytische Aufgaben ohne Bedarf an voller o-Series-Rechenleistung.',
  [T.model_gpt_5_6_luna_description]:
    'Eine schnelle, kostengünstige Stufe, die für Aufgaben mit hohem Datenaufkommen ausgelegt ist. Ideal für latenzkritische, budgetbewusste Aufgaben wie Klassifizierung und einfache Abfragen.',
  [T.model_gpt_5_6_terra_description]:
    'Ein ausgewogenes Alltagsmodell mit der Leistung eines Flaggschiff-Modells der letzten Generation zu etwa der Hälfte des Preises. Ideal für den Einsatz in begrenzten Anwendungsbereichen, für eine erste Überprüfung und für allgemeine Produktionsaufgaben.',
  [T.model_gpt_5_6_sol_description]:
    'Das Flaggschiff unter den Schlussfolgerungsmodellen mit dem bislang robustesten Sicherheits-Stack von OpenAI. Ideal für risikoreiche, mehrstufige Probleme, bei denen Sie die höchstmögliche Leistungsfähigkeit benötigen.',
  [T.model_claude_opus_5_description]:
    'Ein leistungsstarkes Flaggschiff-Modell, das fast an die Intelligenz der Spitzenklasse heranreicht – und das zum halben Preis. Ideal für anspruchsvolle Programmieraufgaben, Wissensarbeit und agentische Aufgaben mit langfristiger Perspektive.',
  [T.model_claude_opus_4_7_description]:
    'Spitzenmodell mit stärkerer Softwareentwicklung, höherauflösendem Sehen und Selbstprüfung bei lang laufenden Aufgaben. Am besten für komplexe Coding-Arbeiten und langfristige autonome Workflows.',
  [T.model_claude_opus_4_8_description]:
    'Schärferes Urteilsvermögen und mehr Ehrlichkeit, mit dynamischen Workflows für groß angelegte Codebase-Migrationen. Am besten für agentisches Coding, Reasoning und Wissensarbeit im großen Maßstab.',
  [T.model_gemini_3_5_flash_description]:
    'Googles intelligentestes Flash-Modell, mit Spitzenleistung bei agentischer Ausführung, Coding und langfristigen Aufgaben im großen Maßstab. Am besten für iteratives Coding, mehrstufige Tool-Nutzung und schnelle agentische Abläufe.',

  //Notifications
  [T.notifications]: 'Benachrichtigungen',
  [T.closeNotifications]: 'Benachrichtigungen schließen',
  [T.markAllAsRead]: 'Alle als gelesen markieren',
  [T.unread]: 'Ungelesen',
  [T.allCaughtUp]: 'Du bist auf dem neuesten Stand',
  [T.allCaughtUpDescription]:
    'Das sind alle deine Benachrichtigungen der letzten {{NOTIFICATION_RETENTION_DAYS}} Tage',
  [T.markAsRead]: 'Als gelesen markieren',
  [T.markAsUnread]: 'Als ungelesen markieren',
  [T.mute]: 'Benachrichtigungen stummschalten',
  [T.dismiss]: 'Schließen',
  [T.viewChanges]: 'Anzeigen Ändern',
  [T.retentionDays]: 'Aufbewahrungsdauer: {{NOTIFICATION_RETENTION_DAYS}} Tage',
  [T.okay]: 'OK',
  [T.category]: 'Kategorie',
  [T.inApp]: 'In der App',
  [T.mandatory]: 'Pflichtfeld',
  [T.mandatoryDescription]:
    'Ihr Team kann diese Benachrichtigungskategorie nicht aktivieren/deaktivieren',
  [T.optional]: 'Optional',
  [T.optionalDescription]:
    'Ihr Team kann diese Benachrichtigungskategorie aktivieren/deaktivieren',
  [T.notificationsDescription]:
    'Wählen Sie aus, welche Benachrichtigungen Sie von Empower GPT erhalten möchten',
  [T.organizationNotifications]: 'Organisationsbenachrichtigungen',
  [T.organizationNotificationsDescription]:
    'Benachrichtigungseinstellungen für Ihre Organisation verwalten',
  [T.notificationFetchError]:
    'Benachrichtigungen konnten nicht abgerufen werden',
  [T.notificationMarkAllReadError]:
    'Alle Benachrichtigungen konnten nicht als gelesen markiert werden',
  [T.notificationReadStatusUpdateError]:
    'Lesestatus der Benachrichtigung konnte nicht aktualisiert werden',
  [T.notificationDismissError]:
    'Benachrichtigung konnte nicht verworfen werden',
  [T.notificationDismissAllError]:
    'Alle Benachrichtigungen konnten nicht verworfen werden',
  [T.notificationPreferencesFetchError]:
    'Benachrichtigungseinstellungen konnten nicht abgerufen werden',
  [T.notificationPreferencesUpdateError]:
    'Benachrichtigungseinstellungen konnten nicht aktualisiert werden',
  [T.notificationMandatoryCategoryError]:
    'Diese Benachrichtigungskategorie ist obligatorisch und kann nicht geändert werden',
  // Notification categories
  [T.notifCatDocumentProcessing]: 'Dokumentenverarbeitung',
  [T.notifCatContentSharing]: 'Inhalte teilen',
  [T.notifCatAssistantUpdates]: 'Assistenten-Updates',
  [T.notifCatWorkspaceChanges]: 'Arbeitsbereich-Änderungen',
  [T.notifCatConnectorSyncStatus]: 'Connector-Synchronisierungsstatus',
  [T.notifCatSystemAnnouncements]: 'Systemankündigungen',
  [T.notifCatWorkflowEvents]: 'Workflow-Ereignisse',
  [T.notifCatTenantLifecycle]: 'Mandanten-Lebenszyklus',
  [T.notifCatSubscriptionAndBilling]: 'Abonnement und Abrechnung',
  [T.notifCatUserAndRoles]: 'Benutzer und Rollen',
  [T.notifCatDocAnalyst]: 'Dokumentenanalyst',
  // Notification category descriptions
  [T.notifCatDescDocumentProcessing]:
    'Verarbeitungsabschluss, Fehler, Batch-Updates, Fehlerberichte und Leistungsmetriken.',
  [T.notifCatDescContentSharing]:
    'Dokumente, Ordner oder Sammlungen hinzugefügt, geändert, gelöscht oder geteilt.',
  [T.notifCatDescAssistantUpdates]:
    'Geteilte Assistenten, Aktualisierungen von Favoriten, Einladungen zur Zusammenarbeit und Versionsänderungen.',
  [T.notifCatDescWorkspaceChanges]:
    'Mitgliedschaftsaktualisierungen, Rollenänderungen, neue Einladungen und Berechtigungsanpassungen.',
  [T.notifCatDescConnectorSyncStatus]:
    'SharePoint-, OneDrive-, Google Drive-Synchronisierungen, Zugriffsänderungen und Speicherwarnungen.',
  [T.notifCatDescSystemAnnouncements]:
    'Neue KI-Modelle, Wartungsfenster, Feature-Rollouts und System-Upgrades.',
  [T.notifCatDescWorkflowEvents]:
    'Workflow-Ausführungen, Fehler, Genehmigungen, Ablehnungen und Statusaktualisierungen.',
  [T.notifCatDescTenantLifecycle]:
    'Erstellung und Löschung von Organisationen und Arbeitsbereichen, Berechtigungsänderungen und Zugriffsanfragen.',
  [T.notifCatDescSubscriptionAndBilling]:
    'Abonnementaktualisierungen, Abrechnungswarnungen, Planänderungen, Verlängerungen und Nutzungslimitbenachrichtigungen.',
  [T.notifCatDescUserAndRoles]:
    'Benachrichtigungen zu Benutzerkontoänderungen und Rollenaktualisierungen.',
  [T.notifCatDescDocAnalyst]:
    'Analyseabschluss, Fehler, Batch-Updates, Fehlerberichte und Leistungsmetriken.',
  // Notification subcategories
  [T.notifSubCatDocumentProcessed]: 'Dokument verarbeitet',
  [T.notifSubCatDocumentFailed]: 'Dokument fehlgeschlagen',
  [T.notifSubCatBatchUploadComplete]: 'Batch-Upload abgeschlossen',
  [T.notifSubCatDocumentShared]: 'Dokument geteilt',
  [T.notifSubCatAccessChanged]: 'Zugriff geändert',
  [T.notifSubCatConnectorSyncComplete]:
    'Connector-Synchronisierung abgeschlossen',
  [T.notifSubCatConnectorSyncFailed]:
    'Connector-Synchronisierung fehlgeschlagen',
  [T.notifSubCatTenantSettingChanged]: 'Mandanteneinstellung geändert',
  [T.notifSubCatSubscriptionUpdated]: 'Abonnement aktualisiert',
  [T.notifSubCatSubscriptionExpiryReminder]: 'Erinnerung an Abonnementablauf',
  [T.notifSubCatAccountTypeChanged]: 'Kontotyp geändert',
  [T.notifSubCatUsageLimitWarning]: 'Nutzungslimit-Warnung',
  [T.notifSubCatSystemMaintenance]: 'Systemwartung',
  [T.notifSubCatModelAdded]: 'Modell hinzugefügt',
  [T.notifSubCatModelDeprecated]: 'Modell veraltet',
  [T.notifSubCatWeeklyDigest]: 'Wöchentliche Zusammenfassung',
  [T.notifSubCatNewTenantCreated]: 'Neuer Mandant erstellt',
  [T.notifSubCatTenantDeactivationWarn]: 'Warnung zur Mandantendeaktivierung',
  [T.notifSubCatAssistantShared]: 'Assistent geteilt',
  [T.notifSubCatAssistantUpdated]: 'Assistent aktualisiert',
  [T.notifSubCatAssistantRemoved]: 'Assistent entfernt',
  [T.notifSubCatAnalysisCompleted]: 'Analyse abgeschlossen',
  [T.notifSubCatAnalysisPartial]: 'Analyse teilweise abgeschlossen',
  [T.notifSubCatAnalysisFailed]: 'Analyse fehlgeschlagen',
  [T.notifSubCatDatasetModified]: 'Datensatz geändert',
  [T.notifSubCatWorkspaceDeleted]: 'Arbeitsbereich gelöscht',
  [T.notifSubCatWorkspaceCreated]: 'Arbeitsbereich erstellt',
  [T.notifSubCatWorkspaceAssigned]: 'Arbeitsbereich zugewiesen',
  [T.notifSubCatRoleChanged]: 'Rolle geändert',
  [T.notifSubCatUserAdded]: 'Benutzer hinzugefügt',
  [T.notifSubCatUserRemoved]: 'Benutzer entfernt',
  [T.notifSubCatWorkflowCompleted]: 'Workflow abgeschlossen',
  [T.notifSubCatWorkflowFailed]: 'Workflow fehlgeschlagen',
  [T.notifSubCatApprovalRequired]: 'Genehmigung erforderlich',
  [T.notifSubCatApprovalReminder]: 'Genehmigungserinnerung',
  // Notification summary and subcategory description templates
  [T.notifSummaryDocumentProcessed]:
    '{{filename}} wurde erfolgreich verarbeitet.',
  [T.notifSubCatDescDocumentProcessed]:
    'Dokument {{filename}} wurde erfolgreich verarbeitet.',

  [T.notifSummaryDocumentFailed]:
    '{{filename}} konnte nicht verarbeitet werden. {{reason}}.',
  [T.notifSubCatDescDocumentFailed]:
    'Dokument {{filename}} konnte nicht verarbeitet werden. {{reason}}.',

  [T.notifSummaryBatchUploadComplete]:
    'Batch abgeschlossen: {{X}} von {{Y}} Dokumenten verarbeitet, {{Z}} fehlgeschlagen.',
  [T.notifSubCatDescBatchUploadComplete]:
    'Batch-Upload abgeschlossen: {{X}} von {{Y}} Dokumenten erfolgreich verarbeitet, {{Z}} fehlgeschlagen.',

  [T.notifSummaryDocumentShared]:
    '{{sharer_name}} hat {{document_name}} mit Ihnen geteilt.',
  [T.notifSubCatDescDocumentShared]:
    '{{sharer_name}} hat {{document_name}} mit Ihnen geteilt.',

  [T.notifSummaryAccessChanged]:
    'Ihr Zugriff auf {{document_name}} wurde zu {{role}} widerrufen.',
  [T.notifSubCatDescAccessChanged]:
    'Benutzerzugriff auf Dokument {{document_name}} wurde auf {{role}} widerrufen.',

  [T.notifSummaryConnectorSyncComplete]:
    '{{connector_name}} Synchronisierung abgeschlossen: {{X}} neu, {{Y}} aktualisiert, {{Z}} entfernt.',
  [T.notifSubCatDescConnectorSyncComplete]:
    'Synchronisierung für {{connector_name}} abgeschlossen: {{X}} neue Dokumente, {{Y}} aktualisiert, {{Z}} entfernt.',

  [T.notifSummaryConnectorSyncFailed]:
    '{{connector_name}} Synchronisierung fehlgeschlagen: {{error_summary}}.',
  [T.notifSubCatDescConnectorSyncFailed]:
    '{{connector_name}} Synchronisierung fehlgeschlagen: {{error_summary}}.',

  [T.notifSummaryTenantSettingChanged]:
    'Einstellungen für {{org_name}} wurden aktualisiert.',
  [T.notifSubCatDescTenantSettingChanged]:
    'Abonnementplan für {{org_name}} wurde auf {{plan_name}} aktualisiert. Neue Limits: {{summary}}.',

  [T.notifSummarySubscriptionUpdated]:
    'Abonnement für {{org_name}} auf {{plan_name}} aktualisiert.',
  [T.notifSubCatDescSubscriptionUpdated]:
    'Abonnementplan für {{org_name}} wurde auf {{plan_name}} aktualisiert. Neue Limits: {{summary}}.',

  [T.notifSummaryAccountTypeChanged]:
    'Ihre Rolle wurde von {{prev_role}} zu {{new_role}} geändert.',
  [T.notifSubCatDescAccountTypeChanged]:
    'Benutzerkontoart / Rolle wurde von {{prev_role}} zu {{new_role}} geändert.',

  [T.notifSummarySubscriptionExpiryReminder]:
    'Ihr Abonnement läuft am {{date}} ab. Erneuern Sie es, um Unterbrechungen zu vermeiden.',
  [T.notifSubCatDescSubscriptionExpiryReminder]:
    'Ihr EmpowerGPT-Abonnement für {{org_name}} läuft am {{date}} ab. Bitte erneuern Sie es.',

  [T.notifSummaryUsageLimitWarning]:
    'Sie nähern sich dem Nutzungslimit für {{exceed_limit}} oder haben es überschritten.',
  [T.notifSubCatDescUsageLimitWarning]:
    'Nutzungslimits für {{exceed_limit}} werden überschritten.',

  [T.notifSummarySystemMaintenance]:
    'Geplante Wartung. Der Dienst kann vorübergehend nicht verfügbar sein.',
  [T.notifSubCatDescSystemMaintenance]:
    'Geplante Wartung oder Plattform-Update.',

  [T.notifSummaryModelAdded]: 'KI-Modell {{model_name}} ist jetzt verfügbar.',
  [T.notifSubCatDescModelAdded]: 'KI-Modell {{model_name}} wurde hinzugefügt.',

  [T.notifSummaryModelDeprecated]:
    'KI-Modell {{model_name}} wurde eingestellt.',
  [T.notifSubCatDescModelDeprecated]:
    'KI-Modell {{model_name}} wurde eingestellt.',

  [T.notifSummaryWeeklyDigest]:
    'Ihre wöchentliche Nutzungszusammenfassung ist bereit.',
  [T.notifSubCatDescWeeklyDigest]:
    'Hier ist die wöchentliche Zusammenfassung {{weekly_usage}}.',

  [T.notifSummaryNewTenantCreated]: 'Organisation {{org_name}} wurde erstellt.',
  [T.notifSubCatDescNewTenantCreated]:
    'Neue Organisation {{org_name}} wurde erstellt.',

  [T.notifSummaryTenantDeactivationWarn]:
    'Ihr Organisationsabonnement wird in 1 Woche deaktiviert.',
  [T.notifSubCatDescTenantDeactivationWarn]:
    'Das Mandantenabonnement wird in 1 Woche deaktiviert.',

  [T.notifSummaryAssistantShared]:
    '{{creator_name}} hat den Assistenten {{assistant_name}} mit Ihnen geteilt.',
  [T.notifSubCatDescAssistantShared]:
    '{{creator_name}} hat den Assistenten {{assistant_name}} mit Ihnen geteilt.',

  [T.notifSummaryAssistantUpdated]:
    'Assistent {{name}} wurde von {{editor_name}} aktualisiert.',
  [T.notifSubCatDescAssistantUpdated]:
    'Assistent {{name}} wurde von {{editor_name}} aktualisiert.',

  [T.notifSummaryAssistantRemoved]: 'Assistent {{name}} wurde entfernt.',
  [T.notifSubCatDescAssistantRemoved]: 'Assistent {{name}} wurde entfernt.',

  [T.notifSummaryAnalysisCompleted]:
    '{{analysis_title}} abgeschlossen — {{X}} von {{Y}} Fragen beantwortet.',
  [T.notifSubCatDescAnalysisCompleted]:
    'Analyse {{analysis_title}} abgeschlossen — {{X}} von {{Y}} Fragen beantwortet.',

  [T.notifSummaryAnalysisPartial]:
    '{{analysis_title}} teilweise abgeschlossen — {{Z}} Fragen unbeantwortet.',
  [T.notifSubCatDescAnalysisPartial]:
    'Analyse {{analysis_title}} teilweise abgeschlossen — {{Z}} Fragen unbeantwortet.',

  [T.notifSummaryAnalysisFailed]:
    '{{analysis_title}} fehlgeschlagen: {{reason}}.',
  [T.notifSubCatDescAnalysisFailed]:
    'Analyse {{analysis_title}} fehlgeschlagen: {{reason}}.',

  [T.notifSummaryDatasetModified]:
    'Datensatz {{name}} wurde geändert — Analyse {{title}} könnte betroffen sein.',
  [T.notifSubCatDescDatasetModified]:
    'Datensatz {{name}} wurde geändert — Analyse {{title}} könnte betroffen sein.',

  [T.notifSummaryWorkspaceDeleted]:
    'Arbeitsbereich {{name}} und alle Inhalte wurden dauerhaft gelöscht.',
  [T.notifSubCatDescWorkspaceDeleted]:
    'Arbeitsbereich {{name}} und alle Inhalte wurden dauerhaft gelöscht.',

  [T.notifSummaryWorkspaceCreated]:
    '{{creator_name}} hat Arbeitsbereich {{workspace_name}} erstellt.',
  [T.notifSubCatDescWorkspaceCreated]:
    '{{creator_name}} hat Arbeitsbereich {{workspace_name}} erstellt.',

  [T.notifSummaryWorkspaceAssigned]:
    'Sie wurden zu {{workspace_name}} als {{role}} hinzugefügt.',
  [T.notifSubCatDescWorkspaceAssigned]:
    'Sie wurden zum neuen Arbeitsbereich {{workspace_name}} als {{role}} hinzugefügt.',

  [T.notifSummaryRoleChanged]:
    'Ihre Rolle in {{workspace_name}} wurde zu {{new_role}} geändert.',
  [T.notifSubCatDescRoleChanged]:
    'Ihre Rolle im Arbeitsbereich {{workspace_name}} wurde zu {{new_role}} geändert.',

  [T.notifSummaryUserAdded]:
    'Sie wurden zu {{workspace_name}} als {{role}} hinzugefügt.',
  [T.notifSubCatDescUserAdded]:
    'Sie wurden zum Arbeitsbereich {{workspace_name}} als {{role}} hinzugefügt.',

  [T.notifSummaryUserRemoved]:
    'Ihr Zugriff auf {{workspace_name}} wurde widerrufen.',
  [T.notifSubCatDescUserRemoved]:
    'Ihr Zugriff auf Arbeitsbereich {{workspace_name}} wurde widerrufen.',

  [T.notifSummaryWorkflowCompleted]:
    'Workflow {{workspace_name}} abgeschlossen: {{status_summary}}.',
  [T.notifSubCatDescWorkflowCompleted]:
    'Workflow abgeschlossen mit {{status_summary}}.',

  [T.notifSummaryWorkflowFailed]:
    'Workflow {{workspace_name}} bei Schritt {{N}} fehlgeschlagen: {{error_summary}}.',
  [T.notifSubCatDescWorkflowFailed]:
    'Workflow {{workspace_name}} bei Schritt {{N}} fehlgeschlagen: {{error_summary}}.',

  [T.notifSummaryApprovalRequired]:
    'Workflow {{workspace_name}} erfordert Ihre Genehmigung bei Schritt {{step_name}}.',
  [T.notifSubCatDescApprovalRequired]:
    'Workflow {{workspace_name}} erfordert Ihre Genehmigung bei Schritt {{step_name}}.',

  [T.notifSummaryApprovalReminder]:
    'Ausstehende Genehmigungsanfrage für {{workflow_name}} erfordert Maßnahmen.',
  [T.notifSubCatDescApprovalReminder]:
    'Genehmigungsanfrage-Erinnerung oder Eskalation.',
  // Workflows
  [T.generateWithAiComingSoon]: 'Mit KI generieren (Demnächst verfügbar)',
  [T.createWithAi]: 'Erstellen (Demnächst verfügbar)',
  [T.addCondition]: 'Bedingung hinzufügen',
  [T.ifElseConditionTitle]: 'IF/Else-Bedingung',
  [T.branchExecution]: 'Verzweigungsausführung',
  [T.conditionsLabel]: 'Bedingungen',
  [T.executeThisBranchIf]: 'Diesen Zweig ausführen, wenn',
  [T.elseIf]: 'Sonst wenn',
  [T.removeCondition]: 'Bedingung entfernen',
  [T.removingConditionsDisabled]:
    'Das Entfernen von Bedingungen ist deaktiviert',
  [T.fieldLabel]: 'Feld',
  [T.operatorLabel]: 'Operator',
  [T.matchText]: 'Vergleichstext',
  [T.opEquals]: 'Gleich',
  [T.opNotEquals]: 'Ungleich',
  [T.opContains]: 'Enthält',
  [T.opLessThan]: 'Kleiner als',
  [T.opLessThanOrEqual]: 'Kleiner oder gleich',
  [T.opGreaterThan]: 'Größer als',
  [T.opGreaterThanOrEqual]: 'Größer oder gleich',
  [T.firstMatchWinsSequential]: 'Erste Übereinstimmung gewinnt (sequenziell)',
  [T.allowMultipleConditions]: 'Mehrere Bedingungen zulassen',
  [T.stopTheWorkflow]: 'Workflow anhalten',
  [T.continueUsingErrorMessage]: 'Mit der Fehlermeldung als Ausgabe fortfahren',
  [T.continueOnNewErrorPath]: 'Auf neuem Fehlerpfad fortfahren',
  [T.regenerateNoun]: '{{noun}} neu generieren?',
  [T.regenerateWarning]:
    'Der aktuelle Wert wird ungültig. Alles, was ihn verwendet, funktioniert nicht mehr, bis es aktualisiert wird. Diese Aktion kann nicht rückgängig gemacht werden.',
  [T.regeneratingEllipsis]: 'Wird neu generiert…',
  [T.secretNoun]: 'Geheimnis',
  [T.passwordNoun]: 'Passwort',
  [T.workflowSaveFailed]: 'Speichern des Workflows fehlgeschlagen',
  [T.wfStartOrder]: 'Bestellung starten',
  [T.wfWorkflows]: 'Arbeitsablauf',
  [T.wfOrderPlaced]: 'Bestellung aufgegeben',
  [T.wfPreparingOrder]: 'Bestellung wird vorbereitet',
  [T.wfCancelOrder]: 'Bestellung stornieren',
  [T.wfOutForDelivery]: 'In Zustellung',
  [T.wfOrderDelivered]: 'Bestellung geliefert',
  [T.wfUntitledWorkflow]: 'Unbenannter Workflow',
  [T.wfCreatedSuccessfully]: 'Workflow erfolgreich erstellt',
  [T.wfCreatedButEditorFailed]:
    'Workflow erstellt, aber der Editor konnte nicht geöffnet werden. Aktualisieren Sie bei Bedarf die Liste.',
  [T.wfCreateFailed]: 'Erstellen des Workflows fehlgeschlagen',
  [T.wfNameAlreadyExists]: 'Ein Workflow mit diesem Namen existiert bereits.',
  [T.wfInvalidSearchQuery]:
    'Die E-Mail-Suchanfrage ist ungültig. Prüfen Sie Anführungszeichen und Klammern und verwenden Sie nur die unterstützten Operatoren.',
  [T.wfCreditLimitExceeded]:
    'Workflow-Ausführung gestoppt, monatliches Limit für credits erreicht.',
  [T.wfRunsLimitExceeded]:
    'Monatliches Limit für Workflow-Ausführungen erreicht.',
  [T.wfBackToConfigurations]: 'Zurück zum Bearbeitungsmodus',
  [T.wfDescriptionLabel]: 'Beschreibung',
  [T.wfAbortRunTooltip]: 'Lauf abbrechen und zur Bearbeitung zurückkehren',
  [T.wfResetRunTooltip]: 'Lauf zurücksetzen und zur Bearbeitung zurückkehren',
  [T.wfRename]: 'Umbenennen',
  [T.wfDuplicate]: 'Duplizieren',
  [T.wfDelete]: 'Löschen',
  [T.wfRenamedSuccessfully]: 'Workflow erfolgreich umbenannt',
  [T.wfRenameFailed]: 'Umbenennen des Workflows fehlgeschlagen',
  [T.wfDuplicatedSuccessfully]: 'Workflow erfolgreich dupliziert',
  [T.wfDuplicateFailed]: 'Duplizieren des Workflows fehlgeschlagen',
  [T.wfDeleteConfirmTitle]: 'Workflow löschen!',
  [T.wfDeleteConfirmMessage]:
    'Sind Sie sicher, dass Sie den Workflow löschen möchten?',
  [T.wfDeletedSuccessfully]: 'Workflow erfolgreich gelöscht',
  [T.wfDeleteFailed]: 'Löschen des Workflows fehlgeschlagen',
  [T.wfDeleteDisabledActive]:
    'Deaktivieren Sie den Workflow, bevor Sie ihn löschen',
  [T.wfInvalidWorkflowTitle]: 'Workflow nicht gefunden',
  [T.wfInvalidWorkflowMessage]:
    'Dieser Workflow konnte nicht geladen werden — er wurde möglicherweise gelöscht oder der Link ist ungültig. Sie können mit Ihren vorhandenen Workflows fortfahren.',
  [T.wfProcessWorkflowGrid]: 'Mit vorhandenen Workflows verarbeiten',
  [T.wfHubSubtitle]:
    'Entwerfen, automatisieren und orchestrieren Sie Ihre Geschäftsprozesse',
  [T.wfNoWorkflowsMatchSearch]: 'Keine Workflows entsprechen Ihrer Suche.',
  [T.wfNoWorkflowsToShow]: 'Keine Workflows zum Anzeigen.',
  [T.wfNoWorkflowsByStatus]: 'Keine {{statusFilter}}-Workflows zum Anzeigen.',
  [T.wfLoadFailed]:
    'Workflows konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
  [T.wfBlocks]: 'Blöcke',
  [T.wfCost]: 'Kosten',
  [T.wfRuns]: 'Ausführungen',
  [T.wfNode]: 'Knoten',
  [T.wfLoopStart]: 'Schleifenstart',
  [T.wfBlockType]: 'Blocktyp',
  [T.wfLoop]: 'Schleife',
  [T.wfArrayToLoopOver]: 'Zu durchlaufendes Array',
  [T.wfArrayToLoopOverPlaceholder]:
    'Text eingeben oder {{  }} verwenden, um auf Daten aus vorherigen Knoten zu verweisen',
  [T.wfLoopVariable]: 'Schleifenvariable',
  [T.wfCollectBlockOutputs]: 'Blockausgaben sammeln',
  [T.wfMaxIterations]: 'Maximale Iterationen',
  [T.wfHardcodedProcessorNoEditableFields]:
    'Fest codierter Prozessor ohne bearbeitbare Felder.',
  [T.wfHardcodedNoEditableFields]: 'Fest codiert ohne bearbeitbare Felder.',
  [T.wfCode]: 'Code',
  [T.wfPythonCodePlaceholder]: 'Python-Code',
  [T.wfErrorHandling]: 'Fehlerbehandlung',
  [T.wfOnError]: 'Bei Fehler',
  [T.wfStopWorkflow]: 'Workflow stoppen',
  [T.wfContinueUsingErrorOutput]: 'Mit Fehlerausgabe fortfahren',
  [T.wfOutputNodeDescription]:
    'Dieser Knoten speichert einen Wert als Ausgabe des Workflow-Laufs. Sie können mehrere Ausgabeknoten haben, die jeweils einen Wert unter ihrem eindeutigen Slug speichern.',
  [T.wfOutputValue]: 'Ausgabewert',
  [T.wfOutputUrlPlaceholder]: 'https://... oder Arbeitsbereichspfad',
  [T.wfAgent]: 'Agent',
  [T.wfSelectExisting]: 'Vorhandene auswählen',
  [T.wfModelRequired]: 'Modell*',
  [T.wfPromptRequired]: 'Prompt*',
  [T.wfAddTool]: 'Werkzeug hinzufügen',
  [T.wfTools]: 'Werkzeuge',
  [T.wfKnowledge]: 'Wissen',
  [T.wfAddKnowledge]: 'Wissen hinzufügen',
  [T.wfSelectFromNodes]: 'Aus Knoten auswählen',
  [T.wfStructuredOutput]: 'Strukturierte Ausgabe',
  [T.wfAddStructuredField]: 'Strukturiertes Feld hinzufügen',
  [T.wfRemoveField]: 'Feld entfernen',
  [T.wfMaxSteps]: 'Max. Schritte',
  [T.wfMaxStepsLimitExceeded]: 'Maximal zulässiger Wert ist 20',
  [T.wfNoCodeOutputConfigured]: '*Keine Code-Ausgabe konfiguriert.*',
  [T.wfCreateNewWorkflow]: 'Neuen Workflow erstellen',
  [T.wfGiveWorkflowDescriptiveName]:
    'Geben Sie Ihrem Workflow einen klaren Namen und eine Beschreibung, damit er sich später leicht identifizieren und wiederverwenden lässt.',
  [T.wfEnter]: 'Eingeben',
  [T.wfCreating]: 'Wird erstellt…',
  [T.wfProvideWorkflowName]: 'Geben Sie einen Workflow-Namen an',
  [T.wfDescriptionOptional]: 'Beschreibung (optional)',
  [T.wfDescribeWorkflowPurpose]: 'Beschreiben Sie den Zweck dieses Workflows.',
  [T.wfChooseFirstNode]: 'Ersten Knoten auswählen',
  [T.wfTrigger]: 'Auslöser',
  [T.wfTriggerSubtitle]: 'Mit einem Formular-/Upload-Auslöser starten',
  [T.wfWebhookSubtitle]: 'Mit einem externen Webhook starten',
  [T.wfIntegrationTrigger]: 'Integrations-Auslöser',
  [T.wfIntegrationTriggerSubtitle]:
    'Mit einem externen Integrationsereignis starten',
  [T.wfWebhookBlockDesc]: 'Von externen Apps oder APIs auslösen',
  [T.wfScheduledBlock]: 'Geplant',
  [T.wfScheduledBlockDesc]: 'Automatisch nach Zeitplan ausführen',
  [T.wfSchedule]: 'Zeitplan',
  [T.wfScheduleTypeLabel]: 'Zeitplantyp',
  [T.wfScheduleTypeCustom]: 'Benutzerdefiniert',
  [T.wfScheduleTypeEvery1Hour]: 'Jede Stunde',
  [T.wfScheduleTypeEvery2Hours]: 'Alle 2 Stunden',
  [T.wfScheduleTypeEvery6Hours]: 'Alle 6 Stunden',
  [T.wfScheduleTypeEvery12Hours]: 'Alle 12 Stunden',
  [T.wfScheduleTypeDailyMidnight]: 'Täglich um Mitternacht',
  [T.wfScheduleTypeDaily6Am]: 'Täglich um 6:00 Uhr',
  [T.wfScheduleTypeDaily9Am]: 'Täglich um 9:00 Uhr',
  [T.wfScheduleTypeEveryMonday]: 'Jeden Montag',
  [T.wfScheduleTypeEverySunday]: 'Jeden Sonntag',
  [T.wfScheduleTypeMonthly1st]: 'Monatlich am 1.',
  [T.wfRunEvery]: 'Ausführen alle',
  [T.wfInvalidTypedDate]:
    'Ungültiges Datum. Verwenden Sie ein Format wie {{example}}',
  [T.wfIntervalUnitMinute]: 'Minute/n',
  [T.wfIntervalUnitHour]: 'Stunde/n',
  [T.wfIntervalUnitDay]: 'Tag/e',
  [T.wfIntervalUnitWeek]: 'Woche/n',
  [T.wfIntervalUnitMonth]: 'Monat/e',
  [T.wfRunEverySummary]: 'Alle {{interval}} {{unit}}',
  [T.wfTimezone]: 'Zeitzone',
  [T.wfSearchTimezone]: 'Zeitzone suchen',
  [T.wfNoTimezoneMatchSearch]: 'Keine Zeitzone entspricht Ihrer Suche.',
  [T.wfStartsAt]: 'Beginnt am',
  [T.wfEndsAt]: 'Endet am',
  [T.wfEndsAtNever]: 'Nie',
  [T.wfEndsAtOnDate]: 'Datum und Uhrzeit festlegen',
  [T.wfPreview]: 'Vorschau',
  [T.wfPreviewRunNumber]: '#{{number}}',
  [T.wfNoUpcomingRuns]: 'Keine anstehenden Ausführungen',
  [T.wfSelectDateTime]: 'Datum und Uhrzeit auswählen',
  [T.wfTest]: 'Test',
  [T.wfManualTrigger]: 'Manuell',
  [T.wfManualTriggerDesc]: 'Workflow manuell starten',
  [T.wfFormBlock]: 'Formular',
  [T.wfFormBlockDesc]: 'Durch Formularübermittlung auslösen',
  [T.wfIntegrationBlock]: 'Integration',
  [T.wfIntegrationBlockDesc]: 'Mit externen Apps verbinden',
  [T.wfIfElseBlock]: 'WENN/SONST',
  [T.wfIfElseBlockDesc]: 'Ablauf basierend auf Bedingungen leiten',
  [T.wfLoopBlockDesc]: 'Aktionen für jedes Element wiederholen',
  [T.wfAgentBlockDesc]: 'KI-Agent zur Aufgabenausführung',
  [T.wfCodeBlockDesc]: 'Benutzerdefinierte Codelogik ausführen',
  [T.wfOutputBlockDesc]: 'Ergebnisse anzeigen oder exportieren',
  [T.wfPdfProcessorBlockDesc]: 'PDF-Daten extrahieren und verarbeiten',
  [T.wfCategoryTrigger]: 'Auslöser',
  [T.wfCategoryLogic]: 'Logik',
  [T.wfCategoryOthers]: 'Sonstige',
  [T.wfCategoryProcessors]: 'Prozessoren',
  [T.wfAddBlock]: 'Block hinzufügen',
  [T.wfNoBlocksMatchSearch]: 'Keine Blöcke entsprechen Ihrer Suche.',
  [T.wfNoPastRuns]: 'Noch keine früheren Ausführungen.',
  [T.wfNoPastRunSteps]: 'Keine Daten für diesen Durchlauf verfügbar.',
  [T.wfNoDeployVersions]: 'Noch keine früheren Bereitstellungsversionen.',
  [T.wfLetsStart]: "Los geht's",
  [T.wfNewField]: 'Neues Feld',
  [T.wfRemoveField2]: 'Feld entfernen',
  [T.wfLabel]: 'Bezeichnung',
  [T.wfFieldTypeText]: 'Text',
  [T.wfFieldTypeMultilineText]: 'Mehrzeiliger Text',
  [T.wfFieldTypeCheckbox]: 'Kontrollkästchen',
  [T.wfFieldTypeTextarea]: 'Textbereich',
  [T.wfFieldTypeNumber]: 'Zahl',
  [T.wfAllowMultipleFiles]: 'Mehrere Dateien zulassen',
  [T.wfDefaultValue]: 'Standardwert',
  [T.wfNodeConfig]: 'Knotenkonfiguration',
  [T.wfNodeLabel]: 'Knotenbezeichnung',
  [T.wfFields]: 'Felder',
  [T.wfAddField]: 'Feld hinzufügen',
  [T.wfPastRuns]: 'Vergangene Ausführungen',
  [T.wfTotalRuns]: 'Gesamtausführungen',
  [T.wfTotalCost]: 'Gesamtguthaben',
  [T.wfRunNumber]: 'Ausführung Nr. {{runNumber}}',
  [T.wfPastDeployVersions]: 'Frühere Bereitstellungsversionen',
  [T.wfLive]: 'Live',
  [T.wfRestore]: 'Wiederherstellen',
  [T.wfRestoreVersionTitle]: 'Diese Version wiederherstellen?',
  [T.wfRestoreVersionDesc]:
    'Die Wiederherstellung auf Version {{version}} überschreibt Ihren aktuellen Workflow. Diese Aktion kann nicht widerrufen werden.',
  [T.wfUploadField]: '{{name}} hochladen',
  [T.wfUnsupportedField]: 'Nicht unterstütztes Feld: {{type}}',
  [T.wfRunWorkflow]: 'Workflow ausführen',
  [T.wfRunWorkflowInstructions]:
    'Wählen Sie Dateien aus, um den Upload automatisch zu starten, und führen Sie dann den Workflow aus.',
  [T.wfPreparingUpload]: 'Upload wird vorbereitet…',
  [T.wfUploadingBatch]:
    'Batch {{batchIndex}} von {{totalBatches}} wird hochgeladen — {{percent}} %',
  [T.wfUploadedFilesToWorkspace]:
    '{{count}} Datei(en) in Arbeitsbereichs-Pfade hochgeladen.',
  [T.wfUploadingFiles]: '{{done}}/{{total}} Datei(en) werden hochgeladen…',
  [T.wfUploadedFilesSuccess]: '{{count}} Datei(en) erfolgreich hochgeladen.',
  [T.wfFilesFailedToUpload]:
    '{{failed}} von {{total}} Datei(en) konnten nicht hochgeladen werden.',
  [T.wfUploadFailedRetry]: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
  [T.wfNoFilesUploaded]: 'Noch keine Dateien hochgeladen.',
  [T.wfRemoveUnsupportedFilesToRun]:
    'Entfernen Sie nicht unterstützte Dateien, um den Workflow auszuführen.',
  [T.wfFileAlreadyAdded]: 'Diese Dateien wurden bereits hinzugefügt.',
  [T.wfFileSizeKb]: '{{size}} KB',
  [T.wfRun]: 'Ausführen',
  [T.wfDeploy]: 'Bereitstellen',
  [T.wfAuthenticationLabel]: 'Authentifizierung: {{label}}',
  [T.wfNoAuthentication]: 'Keine Authentifizierung',
  [T.wfBearerToken]: 'Bearer Token',
  [T.wfBasicAuth]: 'Basic',
  [T.wfApiKey]: 'API-Schlüssel',
  [T.wfWebhook]: 'Webhook',
  [T.wfConnectOutlook]: 'Outlook verbinden',
  [T.wfConnectingEllipsis]: 'Verbinden…',
  [T.wfCopiedToClipboard]: 'In die Zwischenablage kopiert',
  [T.wfDeployWorkflow]: 'Workflow bereitstellen',
  [T.wfNewVersion]: 'Neue Version',
  [T.wfMinor]: 'Minor',
  [T.wfMajor]: 'Major',
  [T.wfDescribeChangesPlaceholder]:
    'Beschreiben Sie die Änderungen, die Sie in dieser Version vorgenommen haben.',
  [T.wfChanges]: 'Änderungen',
  [T.wfBriefDetails]: 'Kurzbeschreibung',
  [T.wfDescribeBriefPlaceholder]: 'Beschreiben Sie diese Version kurz.',
  [T.wfNoChangesToDeploy]: 'Keine Änderungen zum Bereitstellen.',
  [T.wfGoToBlock]: 'Zum Block gehen',
  [T.wfDeleted]: 'Gelöscht',
  [T.wfAdded]: 'Hinzugefügt',
  [T.wfEdgeRemoved]: 'Verbindung entfernt',
  [T.wfChangedLabel]: 'Geändert: {{label}}',
  [T.wfResetNodePositions]: 'Knotenpositionen zurücksetzen',
  [T.wfUndo]: 'Rückgängig',
  [T.wfRedo]: 'Wiederholen',
  [T.wfZoomIn]: 'Vergrößern',
  [T.wfZoomOut]: 'Verkleinern',
  [T.wfFitView]: 'An Ansicht anpassen',
  [T.wfLock]: 'Sperren',
  [T.wfTestExecute]: 'Test ausführen',
  [T.wfStopExecution]: 'Ausführung stoppen',
  [T.wfRenameWorkflow]: 'Workflow umbenennen',
  [T.wfWorkflowResult]: 'Workflow-Ergebnis',
  [T.wfOutputLabel]: 'Ausgabe: {{outputField}}',
  [T.wfDownloadOutputFile]: 'Ausgabedatei herunterladen',
  [T.wfTriggerPdfs]: 'Trigger-PDFs',
  [T.wfInput]: 'Eingabe',
  [T.wfOutput]: 'Ausgabe',
  [T.wfBody]: 'Rumpf',
  [T.wfCollapse]: 'Einklappen',
  [T.wfQueued]: 'In Warteschlange',
  [T.wfSavedInEditorTooltip]:
    'Im Editor gespeichert – mit der Hauptschaltfläche „Speichern“ auf dem Server sichern',
  [T.wfUnsaved]: 'Nicht gespeichert',
  [T.wfBlocksCount]: '{{blocks}} Blöcke',
  [T.wfCostLabel]: '$ {{cost}} Kosten',
  [T.wfFlowRunsCount]: '{{flowRuns}} Ausführungen',
  [T.wfTotalRunsCount]: '{{totalRuns}} Ausführungen',
  [T.wfVersionLabel]: 'Version {{version}}',
  [T.wfVersionShort]: '{{version}} Ver',
  [T.wfClosesLoopVariable]: 'Schließt: {{loopVariable}}',
  [T.wfInnerAgents]: 'Innere Agenten',
  [T.wfVariableLabel]: 'Variable: ',
  [T.wfProvideArrayToIterate]: 'Array zum Iterieren angeben',
  [T.error]: 'Fehler',
  [T.wfWorkflowFailed]: 'Workflow fehlgeschlagen',
  [T.wfWorkflowFailedAtNode]: 'Workflow fehlgeschlagen bei {{node}}',
  [T.wfNodeExecutionFailed]: 'Knotenausführung fehlgeschlagen',
  [T.wfAuthenticationMethod]: 'Authentifizierungsmethode',
  [T.wfUsername]: 'Benutzername',
  [T.wfPassword]: 'Passwort',
  [T.wfWebhookSecret]: 'Webhook-Geheimnis',
  [T.wfWebhookCurl]: 'Webhook-cURL',
  [T.wfTypeHerePlaceholder]: 'Hier eingeben',
  [T.wfHide]: 'Ausblenden',
  [T.wfShow]: 'Anzeigen',
  [T.wfName]: 'Name',
  [T.wfNameMaxLengthReached]: 'Maximale Zeichenanzahl erreicht',
  [T.wfEditDetails]: 'Details bearbeiten',
  [T.wfEditWorkflowDetails]: 'Workflow-Details bearbeiten',
  [T.wfDetailsUpdated]: 'Workflow-Details aktualisiert',
  [T.wfDetailsUpdateFailed]:
    'Workflow-Details konnten nicht aktualisiert werden',
  [T.wfFieldTypeFile]: 'Datei',
  [T.wfClose]: 'Schließen',
  [T.wfCopyWebhookSecret]: 'Webhook-Geheimnis kopieren',
  [T.wfRevealToCopy]: 'Zum Kopieren anzeigen',
  [T.wfCopyWebhookUrl]: 'Webhook-URL kopieren',
  [T.wfAcceptedTypesPlaceholder]: '.pdf,.docx',
  [T.wfCompleteRequiredFields]:
    'Füllen Sie die erforderlichen Felder aus, bevor Sie den Workflow ausführen: {{fields}}.',
  [T.wfDownload]: 'Herunterladen',
  [T.wfOutputUrl]: 'Ausgabe-URL',
  [T.wfLoopToEnd]: 'Schleifenende',
  [T.wfLoop]: 'Schleife',
  [T.wfAddOutputField]: 'Ausgabefeld hinzufügen',
  [T.wfFieldType]: 'Feldtyp',
  [T.wfFieldPurposePlaceholder]: 'Beschreiben Sie den Zweck dieses Feldes.',
  [T.wfRequiredFieldHint]:
    'Dieses Feld muss in der Agent-Ausgabe enthalten sein.',
  [T.wfStructuredOutputHint]:
    'Die Ausgabe wird in einem unstrukturierten Format generiert, wenn der Schalter aus ist.',
  [T.wfSelectModel]: 'Modell auswählen',
  [T.wfInsertContext]: 'Kontext einfügen',
  [T.wfInsert]: 'Einfügen',
  [T.wfRunBlock]: 'Block ausführen',
  [T.wfReRunBlock]: 'Block erneut ausführen',
  [T.wfRunBlockToGenerate]:
    'Klicken Sie auf „Block ausführen“, um Daten zu generieren, die Sie als Kontext für die Eingabe verwenden können.',
  [T.wfNoUpstreamNodes]: 'Keine vorherigen Knoten verfügbar.',
  [T.wfEnterFieldLabel]: 'Feldbezeichnung eingeben',
  [T.wfStructuredOutputAdded]: 'Strukturierte Ausgabe hinzugefügt',
  [T.wfAdd]: 'Hinzufügen',
  [T.wfAddStructuredOutput]: 'Strukturierte Ausgabe hinzufügen',
  [T.wfAllowMultipleUploads]: 'Mehrere Uploads zulassen',
  [T.wfArrayProvided]: 'Array bereitgestellt',
  [T.wfBlockTypeForm]: 'Formular',
  [T.wfButtonLabel]: 'Schaltflächenbeschriftung',
  [T.wfCloses]: 'Schließt:',
  [T.wfCodeIsWritten]: 'Code ist geschrieben.',
  [T.wfConstructingPrompt]: 'Prompt wird erstellt',
  [T.wfDeactivate]: 'Deaktivieren',
  [T.wfExtractingTextTables]: 'Text/Tabellen werden extrahiert',
  [T.wfFieldDescriptionPlaceholder]: 'Beschreiben Sie den Zweck dieses Feldes.',
  [T.wfFormFieldAdded]: 'Formularfeld hinzugefügt.',
  [T.wfFormFieldRequired]: 'Formularfeld erforderlich.',
  [T.wfFieldNameDuplicate]: 'Ein Feld mit diesem Namen existiert bereits.',
  [T.wfFormFields]: 'Formularfelder',
  [T.wfLoopEnd]: 'Schleifenende',
  [T.wfNextIteration]: 'Nächste Iteration',
  [T.wfOutputNodeHint]:
    'Dieser Knoten speichert einen Wert als Ausgabe des Workflow-Laufs. Sie können mehrere Ausgabeknoten haben, die jeweils einen Wert unter ihrem eindeutigen Slug speichern.',
  [T.wfOutputValueWritten]: 'Ausgabewert ist geschrieben.',
  [T.wfPdfProcessor]: 'PDF-Prozessor',
  [T.wfPreviousIteration]: 'Vorherige Iteration',
  [T.wfProcessing]: 'Verarbeitung',
  [T.wfProcessingItem]: 'Element {{current}} wird verarbeitet',
  [T.wfProcessingItemOf]: 'Element {{current}} von {{total}} wird verarbeitet',
  [T.wfTemplateFieldPlaceholder]:
    'Text eingeben oder {{ }} verwenden, um auf Daten aus vorherigen Knoten zu verweisen',
  [T.wfPromptWritten]: 'Prompt ist geschrieben.',
  [T.wfReplace]: 'Ersetzen',
  [T.wfRequired]: 'Erforderlich',
  [T.wfRunningScript]: 'Skript wird ausgeführt',
  [T.wfSpinningUpSandbox]: 'Sandbox wird gestartet',
  [T.wfSubmit]: 'Senden',
  [T.wfThinking]: 'Denkt nach…',
  [T.wfUserEndCustomization]: 'Anpassung durch den Benutzer',
  [T.wfValidatingFields]: 'Felder werden validiert',
  [T.wfWorkflowComplete]: 'Workflow abgeschlossen',
  [T.wfWriteCode]: 'Code schreiben',
  [T.wfWriteOutputValue]: 'Ausgabewert schreiben.',
  [T.wfWritePrompt]: 'Prompt schreiben',
  [T.wfIfElseLabel]: 'WENN/SONST',
  [T.wfNoBranchesConfigured]: 'Keine Zweige konfiguriert',
  [T.wfBranchCount]: '{{count}} Zweig(e)',
  [T.wfIfOneTitle]: 'WENN 1',
  [T.wfElseIfNTitle]: 'SONST WENN {{number}}',
  [T.wfElseRowTitle]: 'SONST',
  [T.wfElseSummary]: 'Sonst',
  [T.wfErrorPathBadge]: 'Fehlerpfad',
  [T.wfDetailsRequiredFor]: 'Details erforderlich für {{title}}',
  [T.wfAddIfElse]: 'WENN/SONST hinzufügen',
  [T.wfIntegration]: 'Integration',
  [T.wfSelectApplication]: 'Wählen Sie eine Anwendung.',
  [T.wfApplicationConnected]: 'Anwendung verbunden',
  [T.wfApplication]: 'Anwendung',
  [T.wfAction]: 'Aktion',
  [T.wfConnectedAs]: 'Verbunden: {{email}}',
  [T.wfDisconnect]: 'Trennen',
  [T.wfDisconnectConfirmDescription]:
    'Das Trennen dieser Anwendung entfernt ihren Trigger aus dem Workflow',
  [T.wfYesDisconnect]: 'Ja, trennen',
  [T.wfRemoveAll]: 'Alle entfernen',
  [T.wfRemoveTrigger]: 'Trigger entfernen',
  [T.wfYesRemoveTrigger]: 'Ja, Trigger entfernen',
  [T.wfRemoveTriggerConfirmDescription]:
    'Das Entfernen dieses Triggers trennt die Anwendung von diesem Workflow',
  [T.wfCopyFailed]: 'Kopieren in die Zwischenablage fehlgeschlagen',
  [T.wfSaveWorkflowBeforeCopy]:
    'Speichern Sie den Workflow, bevor Sie seine Formular-URL kopieren.',
  [T.wfDeployBeforeCopyUrl]:
    'Sie müssen den Workflow bereitstellen, um „URL kopieren“ zu aktivieren.',
  [T.wfAddBlockToRun]: 'Fügen Sie einen Block hinzu, um ihn auszuführen',
  [T.wfConnectOutlookFailed]: 'Verbindung mit Outlook fehlgeschlagen',
  [T.wfConnectAccountFirst]:
    'Bitte verbinden Sie zuerst ein Konto unter Schnittstellen.',
  [T.wfTriggerTypeNotSupported]: 'Dieser Triggertyp wird nicht unterstützt.',
  [T.wfTeamsChannelIdsRequired]:
    'Team-ID und Kanal-ID sind für einen Teams-Kanal-Trigger erforderlich.',
  [T.wfTeamsTeamIdIsConversationId]:
    'Die Team-ID ist eine Unterhaltungs-ID. Geben Sie die Gruppen-ID (GUID) des Teams ein oder fügen Sie den Kanallink aus Teams ein.',
  [T.wfTeamsInvalidTeamId]:
    'Die Team-ID ist ungültig. Geben Sie die Gruppen-ID (GUID) des Teams ein oder fügen Sie den Kanallink aus Teams ein.',
  [T.wfTeamsInvalidChannelId]:
    'Die Kanal-ID ist ungültig. Geben Sie eine ID wie 19:…@thread.tacv2 ein oder fügen Sie den Kanallink aus Teams ein.',
  [T.wfTeamsChatIdRequired]:
    'Die Chat-ID ist für einen Teams-Chat-Trigger erforderlich.',
  [T.wfTeamsInvalidChatId]:
    'Die Chat-ID ist ungültig. Geben Sie eine ID wie 19:…@thread.v2 ein.',
  [T.wfTeamsChannelNotFound]:
    'Teams-Kanal nicht gefunden. Überprüfen Sie Team-ID und Kanal-ID.',
  [T.wfTeamsChannelAccessDenied]:
    'Das verbundene Microsoft-Konto hat keinen Zugriff auf diesen Teams-Kanal.',
  [T.wfTeamsChatNotFound]:
    'Teams-Chat nicht gefunden. Überprüfen Sie die Chat-ID.',
  [T.wfTeamsChatAccessDenied]:
    'Das verbundene Microsoft-Konto hat keinen Zugriff auf diesen Teams-Chat.',
  [T.wfConnectApplication]: 'Verbinden Sie die Anwendung.',
  [T.wfIntegrationConnectFailed]:
    'Verbindung des Integrations-Triggers fehlgeschlagen für Provider "{{provider}}", Trigger "{{trigger}}"',
  [T.wfWebhookRegenerateFailed]:
    'Webhook-Anmeldedaten konnten nicht neu generiert werden',
  [T.wfWebhookAuthUpdateFailed]:
    'Authentifizierungsmethode konnte nicht aktualisiert werden',
  [T.wfMaxFilesPerRun]:
    'Sie können pro Ausführung maximal {{max}} Dateien hochladen.',
  [T.wfFileExceedsLimit]:
    '„{{name}}“ überschreitet das Limit von {{maxMb}} MB pro Datei.',
  [T.wfUploadLimitsCaption]:
    'Bis zu {{maxFiles}} Dateien. Die Größenlimits variieren je nach Dateityp.',
  [T.deleteDisabledDuringUpload]:
    'Löschen nicht möglich, während Dateien in diesen Ordner hochgeladen werden',

  //skills
  [T.skills]: 'Fähigkeiten',
  [T.skillsToolDescription]:
    'Rufen Sie eine Ihrer Fähigkeiten auf und chatten Sie',
  [T.skillHeaderDescription]:
    'Erweitern Sie Ihre Möglichkeiten mit wiederverwendbaren Funktionen, die auf EmpowerGPT Skills basieren.',
  [T.manageSkills]: 'Fähigkeiten verwalten',
  [T.loadMore]: '',
  [T.noSkillsCreatedYet]: 'Sie haben noch keine Fähigkeiten erstellt',
  [T.noSkillsFound]: 'Keine Fähigkeiten gefunden',
  [T.noSharedSkillsTitle]: 'Noch keine geteilten Fähigkeiten',
  [T.noSharedSkillsDescription]:
    'Von anderen mit Ihnen geteilte Fähigkeiten werden hier angezeigt.',
  [T.noDefaultSkillsTitle]: 'Keine Standardfähigkeiten verfügbar',
  [T.noDefaultSkillsDescription]:
    'Systemfähigkeiten werden hier angezeigt, sobald sie verfügbar sind.',
  [T.install]: 'Installieren',
  [T.createSkill]: 'Fähigkeit erstellen',
  [T.createWithChat]: 'Mit Chat erstellen',
  [T.createWithChatDescription]: 'Erstellen Sie eine Fähigkeit mit Empower GPT',
  [T.writeSkillInstructions]: 'Anweisungen für Fähigkeit schreiben',
  [T.writeSkillInstructionsDescription]: 'Individuell und einfach',
  [T.uploadSkill]: 'Fähigkeit hochladen',
  [T.uploadSkillMenuDescription]: '.zip- oder .md-Datei hochladen',
  [T.writeSkillInstructionsModalDescription]:
    'Schreiben Sie Beschreibung und Anweisungen der Fähigkeit für beste Ergebnisse.',
  [T.skillName]: 'Name der Fähigkeit',
  [T.skillNamePlaceholder]: 'ui-ux-assurance',
  [T.skillDescriptionPlaceholder]:
    "Erstellen Sie eine kurze Beschreibung für eine Fähigkeit wie 'UI-UX Assurance', die bei UX-Audits vom Design bis zur Entwicklung hilft...",
  [T.charactersCount]: '{{current}} / {{max}} Zeichen',
  [T.skillActions]: 'Fähigkeitsaktionen',
  [T.uploadSkillTitle]: 'Fähigkeit hochladen',
  [T.uploadSkillModalDescription]:
    'Laden Sie eine SKILL.md-Datei hoch oder importieren Sie ein .zip-/.skill-Archiv. Stellen Sie sicher, dass die SKILL.md YAML-Frontmatter mit Name und Beschreibung enthält.',
  [T.dragAndDropToUpload]: 'Zum Hochladen ziehen und ablegen oder klicken',
  [T.uploadSkillDropzoneHint]:
    'Sie können eine einzelne SKILL.md-Datei oder ein .zip-/.skill-Archiv hochladen.',
  [T.skillZipStructureTitle]: 'Zip-Struktur',
  [T.skillZipStructureDescription]:
    'Folgen Sie dem Agent-Skills-Format: eine einzelne SKILL.md oben und optionale Ordner. Legen Sie Dateien direkt in einen Ordner (keine Unterordner). Nur Textdateien, z. B. .md, .py, .json oder .yaml.',
  [T.skillZipStructureSkillMd]: 'Erforderlich: Name, Beschreibung und Anweisungen',
  [T.skillZipStructureScripts]: 'Optional: Code, den der Agent ausführen kann, z. B. .py',
  [T.skillZipStructureReferences]: 'Optional: Dokumentation',
  [T.skillZipStructureAssets]: 'Optional: Vorlagen und andere Ressourcen',
  [T.skillZipStructureLearnMore]: 'Mehr über Agent Skills erfahren',
  [T.uploadingSkill]: 'Fähigkeit wird hochgeladen',
  [T.uploadingSkillDescription]:
    'Ihre Fähigkeit wird hochgeladen. Dies dauert nur einen Moment.',
  [T.skillDescription]: 'Beschreibung der Fähigkeit',
  [T.noDescriptionProvided]: 'Keine Beschreibung vorhanden.',
  [T.moreOptions]: 'Weitere Optionen',
  [T.rawView]: 'Rohtext',
  [T.unsupportedSkillFile]:
    'Nicht unterstützter Dateityp. Laden Sie eine SKILL.md-Datei oder ein .zip-/.skill-Archiv hoch.',
  [T.skillArchiveEmpty]:
    'Das Archiv ist leer. Fügen Sie eine SKILL.md-Datei hinzu und versuchen Sie es erneut.',
  [T.skillArchiveOnlyMd]:
    'Legen Sie SKILL.md oben ab und weitere Dateien direkt in Ordner wie scripts/ oder references/. Verschieben oder entfernen: {{files}}',
  [T.skillArchiveReadError]:
    'Archiv konnte nicht gelesen werden. Bitte laden Sie eine gültige .zip-/.skill-Datei hoch.',
  [T.you]: 'Sie',
  [T.enterMdFormat]: 'Bitte im Markdown-Format eingeben',
  [T.skillCreatedSuccessfully]: 'Skill erfolgreich erstellt.',
  [T.skillCreateFailed]:
    'Skill konnte nicht erstellt werden. Bitte versuche es erneut.',
  [T.deleteTheSkill]: 'Skill löschen',
  [T.deleteSkillConfirmation]:
    'Bist du sicher, dass du den Skill löschen möchtest?',
  [T.yesDeleteIt]: 'Ja, löschen',
  [T.skillDeletedSuccessfully]: 'Skill erfolgreich gelöscht.',
  [T.skillDeleteFailed]:
    'Skill konnte nicht gelöscht werden. Bitte versuche es erneut.',
  [T.skillFetchFailed]:
    'Skill-Details konnten nicht geladen werden. Bitte versuche es erneut.',
  [T.editSkillInstructions]: 'Skill-Anweisungen bearbeiten',
  [T.skillUpdatedSuccessfully]: 'Skill erfolgreich aktualisiert.',
  [T.skillUpdateFailed]:
    'Skill konnte nicht aktualisiert werden. Bitte versuche es erneut.',
  [T.skillEnabledSuccessfully]: 'Skill erfolgreich aktiviert.',
  [T.skillDisabledSuccessfully]: 'Skill erfolgreich deaktiviert.',
  [T.skillInstalledSuccessfully]: 'Skill erfolgreich installiert.',
  [T.skillInstallFailed]:
    'Installation des Skills fehlgeschlagen. Bitte erneut versuchen.',
  [T.skillDisabledByOwnerError]:
    'Dieser Skill wurde vom Eigentümer deaktiviert und kann nicht installiert werden.',
  [T.skillNotInstalledByOwnerError]:
    'Dieser Skill wurde vom Eigentümer noch nicht installiert. Bitten Sie den Eigentümer, ihn zuerst zu installieren.',
  [T.skillUninstalledSuccessfully]: 'Skill erfolgreich deinstalliert.',
  [T.skillUninstallFailed]:
    'Deinstallation des Skills fehlgeschlagen. Bitte erneut versuchen.',
  [T.uninstall]: 'Deinstallieren',
  [T.installed]: 'Installiert',
  [T.uninstalled]: 'Deinstalliert',
  [T.copyFailed]: 'Kopieren in die Zwischenablage fehlgeschlagen',
  [T.filterBy]: 'Filtern nach',
  [T.skillNameFormatError]:
    'Der Skill-Name darf nur Kleinbuchstaben (a–z), Zahlen (0–9) und Bindestriche (-) enthalten.',
  [T.skillNameStartEndHyphenError]:
    'Der Skill-Name darf nicht mit einem Bindestrich beginnen oder enden.',
  [T.skillNameConsecutiveHyphensError]:
    'Der Skill-Name darf keine aufeinanderfolgenden Bindestriche (--) enthalten.',
  [T.skillNameAlreadyExistsError]:
    'Eine Fertigkeit mit diesem Namen existiert bereits.',
  [T.skillNameExistsAsDeprecatedError]:
    'Eine gelöschte Fertigkeit mit diesem Namen existiert bereits. Bitte wählen Sie einen anderen Namen.',
  [T.skillZipRequired]:
    'Zum Erstellen eines Skills ist eine ZIP-Datei erforderlich, die die Datei „SKILL.md“ enthält.',
  [T.skillZipValidationError]:
    'Die Validierung des Skill-Pakets ist fehlgeschlagen. Überprüfen Sie das Format Ihrer SKILL.md-Datei (Name, Beschreibung und gültiger Markdown-Inhalt) und versuchen Sie es erneut.',
  [T.skillPublicationError]:
    'Aktualisierung des Skill-Status in DocLM fehlgeschlagen. Bitte erneut versuchen.',
  [T.skillPublicationJudgeFailedError]:
    'Die Veröffentlichung des Skills wurde vom Prüfprozess abgelehnt. Bitte überarbeiten Sie die Skill-Anweisungen und versuchen Sie es erneut.',
  [T.skillNotRegisteredInDocLMError]:
    'Dieser Skill ist nicht in DocLM registriert und kann nicht aktiviert oder deaktiviert werden.',
  [T.skillZipMissingSkillFileError]:
    'Keine SKILL.md im hochgeladenen Archiv gefunden. Legen Sie SKILL.md im Stammverzeichnis der ZIP-Datei ab oder in einem einzigen Ordner, der den gleichen Namen wie der Skill trägt.',
  [T.skillZipMultipleSkillsError]:
    'Das Archiv enthält mehrere Skills. Jeder Skill muss als separate ZIP-Datei hochgeladen werden – packen Sie jeden Skill-Ordner einzeln.',
  [T.skillZipUnsafeError]:
    'Die hochgeladene ZIP-Datei hat die Sicherheitsprüfung nicht bestanden und kann nicht verarbeitet werden. Stellen Sie sicher, dass es sich um ein einfaches ZIP-Archiv ohne Symlinks oder verschlüsselte Einträge handelt.',
  [T.skillZipInvalidPackageError]:
    'Das Skill-Paket ist ungültig. Prüfen Sie, ob SKILL.md einen gültigen Frontmatter-Block mit einem Kleinbuchstaben-Namen (nur Buchstaben, Ziffern, Bindestriche) und einer Beschreibung enthält, gefolgt von einem nicht leeren Markdown-Text.',
  [T.skillInstructionsFrontmatterError]:
    'Anleitungen sollten keinen YAML-Frontmatter (---) enthalten. Verwenden Sie stattdessen die Felder „Name“ und „Beschreibung“ weiter oben.',
  [T.skillSharedSuccessfully]: 'Die Fähigkeit wurde erfolgreich weitergegeben.',
  [T.skillShareFailed]:
    'Das Teilen der Fähigkeit ist fehlgeschlagen. Bitte versuche es erneut.',
  [T.skillDownloadFailed]:
    'Herunterladen des Skills fehlgeschlagen. Bitte erneut versuchen.',
  [T.skillDownloadedSuccessfully]:
    'Die Fähigkeit wurde erfolgreich heruntergeladen.',
  [T.replaceSkillTitle]: 'Skill "{{name}}" ersetzen?',
  [T.replaceSkillConfirmation]:
    'Es gibt bereits einen Skill mit demselben Namen. Durch das Hochladen dieses Skills wird der vorhandene Skill ersetzt und kann nicht wiederhergestellt werden.',
  [T.uploadAndReplace]: 'Hochladen und ersetzen',
  [T.removePremissionsSuccess]:
    '{{username}} wurde erfolgreich aus den Skill-Berechtigungen entfernt.',
  [T.removePremissionsFailed]:
    'Der Benutzer {{username}} konnte nicht aus den Skill-Berechtigungen entfernt werden.',

  [T.wfLogUpdateNameFailed]: 'updateWorkflowName fehlgeschlagen:',
  [T.wfLogToggleActiveFailed]: 'handleToggleWorkflowActive fehlgeschlagen:',
  [T.wfLogRenameFailed]: 'renameWorkflow fehlgeschlagen:',
  [T.wfLogDeleteFailed]: 'deleteWorkflow fehlgeschlagen:',
  [T.wfLogDuplicateFailed]: 'duplicateWorkflow fehlgeschlagen:',
  [T.wfLogCreateFailed]: 'createWorkflow fehlgeschlagen:',
  [T.wfLogSaveFailed]: 'saveWorkflow fehlgeschlagen:',
  [T.wfLogWebhookRegenerateFailed]: 'Webhook-Regenerierung fehlgeschlagen:',
  [T.wfLogWebhookAuthUpdateFailed]:
    'Webhook-Authentifizierungsaktualisierung fehlgeschlagen:',
  [T.wfLogWebhookAuthTaskFailed]:
    'Webhook-Authentifizierungsaufgabe fehlgeschlagen:',
  [T.wfLogKnowledgeUploadFailed]: 'Wissens-Upload fehlgeschlagen:',
  [T.wfLogRunFailed]: 'runWorkflow fehlgeschlagen:',
  [T.wfLogRunUploadFailed]: 'Datei-Upload für Ausführung fehlgeschlagen:',
  [T.wfLogGraphParseFailed]: 'parseGraphField: fehlerhaftes Graph-JSON',
  [T.wfLogHydrationFailed]: 'Workflow-Hydration fehlgeschlagen:',
  [T.wfMcpConnected]: '{{name}} erfolgreich verbunden',
  [T.wfMcpConnectFailed]:
    '{{name}} konnte nicht verbunden werden. Die Verbindung wurde nicht abgeschlossen – bitte versuchen Sie es erneut.',
  [T.wfMcpDisconnected]:
    'Die Verbindung zu {{name}} wurde getrennt. Die Tools bleiben im Workflow, werden aber erst nach erneutem Verbinden ausgeführt.',
  [T.wfLogMcpConnectStarted]: 'MCP-Verbindung gestartet:',
  [T.wfLogMcpConnected]: 'MCP-Connector verbunden:',
  [T.wfLogMcpConnectFailed]: 'MCP-Verbindung nicht abgeschlossen:',
  [T.wfLogMcpVerifyFailed]: 'Prüfung der MCP-Verbindung fehlgeschlagen:',
  [T.wfLogMcpDisconnected]: 'MCP-Kategorie getrennt:',
  [T.wfLogDownloadFallback]:
    'Blob-Download fehlgeschlagen; Rückfall auf window.open',
  [T.wfAiActionAriaLabel]: 'KI',
  [T.wfMoreActionsAriaLabel]: 'Mehr',
  [T.wfSkippedStatus]: 'Übersprungen',
  [T.wfCollapseAriaLabel]: 'Einklappen',
  [T.wfOperatorContains]: 'enthält',
  [T.wfMaxIterationsShort]: 'max',
  [T.wfWorkflowActionsAriaLabel]: 'Workflow-Aktionen',
  [T.wfShareWorkflowAriaLabel]: 'Workflow teilen',
  [T.wfFavoriteWorkflowAriaLabel]: 'Workflow favorisieren',
  [T.wfFieldTypeString]: 'Zeichenkette',
  [T.wfFieldTypeBoolean]: 'Wahrheitswert',
  [T.wfFieldTypeObject]: 'Objekt',
  [T.wfFieldTypeArray]: 'Array',
  [T.wfEditField]: 'Feld bearbeiten',
  [T.wfAcceptedFileTypes]: 'Akzeptierte Dateitypen',
  [T.wfEnterNamePlaceholder]: 'Name eingeben',
  [T.wfNewEmailAction]: 'Neue E-Mail passend zur Suche',
  [T.wfSearchQuery]: 'Suchanfrage',
  [T.wfSearchQueryPlaceholder]: 'Suchanfrage eingeben',
  [T.wfSearchQueryTooltip]:
    'Outlook-Suchanfrage, der die E-Mail entsprechen muss. Beispiele',
  [T.wfSearchQueryTooltipExample]: 'from:johndoe@example.com',
  [T.wfSearchQueryTooltipDetails]:
    ', subject:invoice, body:"due date", NOT from:noreply. Filter mit AND, OR, NOT und Klammern kombinieren. Unterstützte Operatoren: from:, to:, cc:, bcc:, subject:, body:, participants:, recipients:. Weitere Informationen hier:',
  [T.wfGmailSearchQueryTooltip]:
    'Gmail-Suchanfrage, der die E-Mail entsprechen muss. Beispiele',
  [T.wfGmailSearchQueryTooltipExample]: 'from:johndoe@example.com',
  [T.wfGmailSearchQueryTooltipDetails]:
    ', subject:invoice, {from:amy from:david}, -from:noreply. Filter mit AND, OR, - (ausschließen) und Klammern kombinieren. Unterstützte Operatoren: from:, to:, cc:, bcc:, subject:. Weitere Informationen hier:',
  [T.wfTeamsNewChannelMessage]: 'Neue Kanalnachricht',
  [T.wfTeamsNewChatMessage]: 'Neue Chatnachricht',
  [T.wfTeamsNewMeetingTranscript]: 'Neues Besprechungstranskript',
  [T.wfTeamsChannelId]: 'Kanal-ID',
  [T.wfTeamsChatId]: 'Chat-ID',
  [T.wfTeamsChannelIdTooltipDetails]:
    'Um die Kanal-ID zu finden, den gewünschten Kanal in Microsoft Teams öffnen und den Kanal-Link kopieren. Die Kanal-ID ist der Teil der URL zwischen channel und dem nächsten Schrägstrich. Diesen Wert kopieren und in das Feld einfügen.',
  [T.wfTeamsChatIdTooltipDetails]:
    'Um die Chat-ID zu finden, den gewünschten Chat in Microsoft Teams öffnen und den Chat-Link kopieren. Die Chat-ID ist der Teil der URL zwischen chat und conversations. Diesen Wert kopieren und in das Feld einfügen.',
  [T.wfTeamsTeamId]: 'Team-ID',
  [T.wfTeamsFilterKeyword]: 'Filterschlüsselwort',
  [T.wfNoFilesAttachedYet]: 'Noch keine Dateien angehängt.',
  [T.wfToggleAriaLabel]: 'Umschalten',
  [T.wfFormTriggerLabel]: 'Formular-Trigger',
  [T.wfUploadDocumentLabel]: 'Dokument hochladen',
  [T.wfSaveBeforeRunning]:
    'Speichern Sie den Workflow, bevor Sie ihn ausführen.',
  [T.wfNoInputProvided]:
    'Es wurden keine Eingaben gemacht. Füllen Sie die Formularfelder aus oder laden Sie Dateien hoch und versuchen Sie es erneut.',
  [T.wfRunWorkflowFailedGeneric]: 'Workflow-Ausführung fehlgeschlagen',
  [T.wfRunScheduledWorkflowNoInput]:
    'Dieser Workflow wird nach Zeitplan ausgeführt und benötigt keine Eingaben. Führen Sie ihn jetzt aus, um ihn zu testen.',
  [T.wfUnknownTime]: 'Unbekannte Zeit',
  [T.wfPendingStatus]: 'Ausstehend',
  [T.wfSuccessStatus]: 'Erfolgreich',
  [T.wfWorkflowSavedSuccessfully]: 'Workflow erfolgreich gespeichert',
  [T.wfWorkflowDeployedSuccessfully]: 'Workflow erfolgreich bereitgestellt',
  [T.wfNotAvailable]: 'N/A',
  [T.wfNoDescriptionAvailable]: 'Keine Beschreibung verfügbar.',
  [T.wfPromptFieldLabel]: 'Prompt',
  [T.wfStructuredOutputFieldLabel]: 'Strukturiertes Ausgabefeld',
  [T.wfBranchConditionsLabel]: 'Verzweigungsbedingungen',
  [T.wfConnectedApplicationLabel]: 'Verbundene Anwendung',
  [T.wfFormFieldLabel]: 'Formularfeld',
  [T.wfChangeCount]: '{{count}} Änderung(en)',
  [T.wfViewingRunNumber]: 'Durchlauf #{{number}} wird angezeigt',
  [T.disableSSOConfirmTitle]: 'Single Sign-On (SSO) deaktivieren?',
  [T.disableSSOConfirmDescription]:
    'Über Active Directory oder SSO angemeldete Benutzer werden abgemeldet und können sich erst wieder anmelden, wenn SSO erneut aktiviert wird.',
  [T.disableSSOConfirmButton]: 'SSO deaktivieren',

  // Upload Sessions
  [T.sessionHistory]: 'Sitzungsverlauf',
  [T.pinned]: 'Angeheftet',
  [T.completed]: 'Abgeschlossen',
  [T.paused]: 'Pausiert',
  [T.pinThisSession]: 'Diese Sitzung anheften',
  [T.unpinSession]: 'Anheftung der Sitzung aufheben',
  [T.retryFailedItems]: 'Fehlgeschlagene Elemente erneut versuchen',
  [T.cancelSession]: 'Sitzung abbrechen',
  [T.deleteThisSession]: 'Diese Sitzung löschen?',
  [T.deleteConfirmationMessage]:
    'Diese Aktion löscht die Sitzung dauerhaft. Sie kann nicht rückgängig gemacht werden.',
  [T.others]: 'Sonstige',
  [T.xOfYFiles]: '{{uploaded}}/{{total}} Dateien',
  [T.xPercentYOfZFilesUploaded]:
    '{{percent}}% - {{uploaded}} von {{total}} Dateien hochgeladen',
  [T.noTimeEstimation]: '~ Keine Zeitschätzung',
  [T.viewInFolder]: 'Im Ordner anzeigen',
  [T.noSession]: 'Sie haben keine Sitzung!',
  [T.noSessionDescription]:
    'Laden Sie Ordner oder Dateien in einen beliebigen Workspace hoch. Ihre Sitzung wird hier vorübergehend gespeichert und kann auch dauerhaft gespeichert werden.',
  [T.noActiveSession]: 'Sie haben keine aktive Sitzung!',
  [T.noActiveSessionDescription]:
    'Ihre laufende Sitzung wird hier sowie oben in der Liste aller Sitzungen angezeigt.',
  [T.noPinnedSession]: 'Sie haben keine angeheftete Sitzung!',
  [T.noPinnedSessionDescription]:
    'Angeheftete Sitzungen werden hier angezeigt und bleiben oben in Ihrer Liste. Heften Sie eine Sitzung über den Tab „Alle“ an, damit sie jederzeit leicht erreichbar ist.',
  [T.noCompletedSession]: 'Sie haben keine abgeschlossene Sitzung!',
  [T.noCompletedSessionDescription]:
    'Abgeschlossene Sitzungen werden hier angezeigt.',
  [T.noFailedOrPausedSession]:
    'Sie haben keine fehlgeschlagenen oder pausierten Sitzungen!',
  [T.noFailedOrPausedSessionDescription]:
    'Fehlgeschlagene und pausierte Sitzungen werden hier angezeigt.',
  [T.backToAllSessions]: 'Zurück zu allen Sitzungen',
  [T.backToWorkspaces]: 'Zurück zu den Workspaces',
  [T.sessionsInProgress]: '{{count}} Sitzungen in Bearbeitung',
  [T.etaSeconds]: '{{count}}s verbleibend',
  [T.etaMinutes]: '{{count}} Min. verbleibend',
  [T.etaHours]: '{{count}}h verbleibend',
  [T.etaHoursMinutes]: '{{hours}}h {{minutes}}m verbleibend',
  [T.lockedFolderTitle]:
    'Sie können "{{folderName}}" nicht bearbeiten, verschieben oder löschen',
  [T.lockedFolderDescription]:
    '{{userName}} lädt Dateien in diesen Ordner in der Sitzung "{{sessionName}}" hoch. Warten Sie, bis der Upload abgeschlossen ist, oder sehen Sie sich die Sitzung für Details an.',
  [T.lockedFolderDescriptionGeneric]:
    'Jemand lädt Dateien in diesen Ordner hoch. Warten Sie, bis der Upload abgeschlossen ist, oder sehen Sie sich die Sitzung für Details an.',
  [T.lockedTooltipGeneric]:
    'Dieser Ordner ist gesperrt, da jemand in diesen Arbeitsbereich hochlädt.',
  [T.loadingSession]: 'Sitzung wird geladen...',
  [T.sessionNotFound]: 'Sitzung nicht gefunden',
  [T.loadingFiles]: 'Dateien werden geladen...',
  [T.noFilesInSession]: 'Keine Dateien in dieser Sitzung',
  [T.filesCount]: 'Dateien ({{count}})',
  [T.columnName]: 'Name',
  [T.columnSize]: 'Größe',
  [T.columnStatus]: 'Status',
  [T.columnFormat]: 'Format',
  [T.fileStatusWaiting]: 'Wartend',
  [T.fileStatusUploading]: 'Hochladen',
  [T.fileStatusUploaded]: 'Hochgeladen',
  [T.fileStatusFailed]: 'Fehlgeschlagen',
  [T.fileStatusMissing]: 'Fehlend',
  [T.fileStatusCancelled]: 'Abgebrochen',
  [T.uploadDetail]: 'Upload-Details',
  [T.syncingFilesTo]: 'Dateien synchronisieren nach {{path}}',
  [T.totalFiles]: 'Gesamtdateien',
  [T.existingFiles]: 'Vorhandene Dateien',
  [T.newFiles]: 'Neue Dateien',
  [T.downloadFilesDetail]: 'Details zu den Download-Dateien',
  [T.csvFileName]: 'Dateiname',
  [T.csvFullPath]: 'Vollständiger Pfad',
  [T.csvSizeBytes]: 'Größe (Bytes)',
  [T.csvLocalModified]: 'Lokal geändert',
  [T.csvServerModified]: 'Auf Server geändert',
  [T.csvStatus]: 'Status',
  [T.csvType]: 'Typ',
  [T.csvTypeFile]: 'Datei',
  [T.csvTypeFolder]: 'Ordner',
  [T.filesAlreadyExist]:
    '{{count}} Dateien existieren bereits an diesem Ort. Möchten Sie die vorhandenen Dateien durch neue ersetzen oder überspringen?',
  [T.replaceExistingFiles]: 'Vorhandene Dateien ersetzen',
  [T.filesBeingUploadedConflict]:
    '{{count}} Dateien werden gerade von {{owner}} an diesen Ort hochgeladen. Sie können jetzt nicht hochladen!',
  [T.sameFilesUploadingTitle]:
    'Dieselben Dateien werden in einer anderen Sitzung hochgeladen.',
  [T.sameFilesUploadingDescription]:
    'Bitte warten Sie, bis die zuletzt hinzugefügten Dateien verarbeitet wurden, bevor Sie eine neue Upload-Sitzung starten.',
  [T.syncFolderToServer]: 'Ordner mit Server synchronisieren',
  [T.syncDescription]:
    'Neue Dateien in Ihrem lokalen Ordner werden auf den Server hochgeladen. Vorhandene Dateien auf dem Server werden nicht geändert, unabhängig davon, ob Sie sie bearbeitet haben oder nicht. Dies ist die Standardeinstellung.',
  [T.openAdvancedOptions]: 'Erweiterte Optionen öffnen',
  [T.thisSyncWill]: 'Diese Synchronisierung wird',
  [T.addNewFilesOnly]: 'Nur neue Dateien hinzufügen',
  [T.addAndUpdate]: 'Hinzufügen und aktualisieren',
  [T.mirror]: 'Spiegeln',
  [T.deleteAndAdd]: 'Löschen und hinzufügen',
  [T.alreadyIdentical]: 'Bereits identisch',
  [T.newWillUpload]: 'Neu - wird hochgeladen',
  [T.editedWillSkip]: 'Bearbeitet - wird übersprungen',
  [T.editedWillReplace]: 'Bearbeitet - wird ersetzt',
  [T.onlyOnServerKept]: 'Nur auf Server - behalten',
  [T.onlyOnServerDelete]: 'Nur auf Server - löschen',
  [T.advancedOptions]: 'Erweiterte Optionen',
  [T.mirrorLocalFolderExactly]: 'den lokalen Ordner exakt spiegeln',
  [T.advancedOptionsDescription]:
    'Diese Optionen ändern Dateien, die bereits auf dem Server vorhanden sind. Beide sind standardmäßig deaktiviert.',
  [T.replaceEditedFilesOnServer]: 'Bearbeitete Dateien auf dem Server ersetzen',
  [T.replaceEditedFilesDescription]:
    '{{count}} Dateien. Die Serverkopie wird mit Ihrer lokalen Version überschrieben.',
  [T.deleteServerFilesMissingLocally]:
    'Serverdateien löschen, die lokal fehlen',
  [T.deleteServerFilesDescription]:
    '{{count}} Dateien. Aktivieren Sie beide Optionen, um Ihren lokalen Ordner exakt zu spiegeln.',
  [T.filesWillBeRemoved]:
    '{{count}} Dateien werden dauerhaft vom Server entfernt. Sie werden im nächsten Schritt zur Bestätigung aufgefordert.',
  [T.uploadXFiles]: '{{count}} Dateien hochladen',
  [T.syncXFiles]: '{{count}} Dateien synchronisieren',
  [T.mirrorXFiles]: '{{count}} Dateien spiegeln',
  [T.exportFileList]: 'Dateiliste exportieren',
  [T.deleteFilesFromServer]: '{{count}} Dateien vom Server löschen?',
  [T.deleteFilesFromServerDescription]:
    'Beim Spiegeln werden diese Dateien entfernt, da sie in Ihrem lokalen Ordner nicht mehr vorhanden sind. Sie können danach nicht mehr vom Server wiederhergestellt werden.',
  [T.yesDeleteFiles]: 'Ja, Dateien löschen',
  [T.noKeepFiles]: 'Nein, Dateien behalten',
  [T.startedOn]: 'Gestartet am',
  [T.expiredOn]: 'Abgelaufen am',
  [T.trialUsage]: 'Testnutzung',
  [T.trialUsageTooltip]:
    'Verbrauchte Credits im Vergleich zu den in Ihrem Testzeitraum enthaltenen Credits.',
  [T.chatStopGenerating]: 'Generierung stoppen',
  [T.chatStopping]: 'Antwort wird gestoppt',
  [T.chatResponseTerminated]: 'Diese Antwort wurde vom Benutzer abgebrochen.',
  [T.chatBranchedFrom]: 'Abgezweigt von',
  [T.chatBranchedFromFallback]: 'einem früheren Chat',
  [T.yesterday]: 'Gestern',
  [T.projectChatViewerReadOnly]:
    'Dieser Chat ist schreibgeschützt – Sie haben nur Leserechte für dieses Projekt.',
  [T.fileDeletedOrInaccessibleLabel]: 'Nicht zugänglich',
  [T.dataAnalyst]: 'Datenanalyst',
  [T.noAnalysisFound]: 'Keine Analyse gefunden',
  [T.questionnaireUpdatedSuccess]: 'Fragebogen erfolgreich aktualisiert.',
  [T.wfSettingsDescription]: 'Workflows für Ihre Organisation anpassen',
  [T.wfSettingsPlan]: 'Tarif',
  [T.wfSettingsResetsOn]: 'Zurücksetzung am {{date}}',
  [T.wfSettingsRuns]: 'Ausführungen: {{used}} / {{total}}',
  [T.wfSettingsLimits]: 'Limits',
  [T.wfSettingsUsageCap]: 'Nutzungsobergrenze',
  [T.wfSettingsUsageCapDescription]:
    'Maximale Nutzung von KI-Credits über alle Workflows hinweg.',
  [T.wfSettingsSetCap]: 'Obergrenze festlegen',
  [T.wfSelectedFiles]: 'Ausgewählte Dateien',
  [T.wfFormSubmitting]: 'Wird gesendet',
  [T.wfFormSubmitFailed]: 'Formular konnte nicht gesendet werden.',
  [T.wfFormSubmitted]: 'Formular gesendet!',
  [T.wfFormSubmittedDescription]:
    'Formular gesendet! Ihre Antwort wurde erfasst.',
  [T.professionalPlanHeadline]: 'Verwaltete Enterprise-Cloud',
  [T.professionalPlanSubheading]: 'Enterprise-KI ohne eigene Infrastruktur',
  [T.professionalPlanDescription]:
    'Führen Sie KI schnell in Abteilungen und Geschäftsbereichen ein – mit einer vollständig verwalteten Enterprise-Plattform.',
  [T.professionalPlanFootnote]:
    'Inklusive 5 € Enterprise-KI-Guthaben • Keine Kreditkarte erforderlich',
  [T.professionalPlanCta]: 'Upgrade',
  [T.professionalFeature1]: 'Flexibles Monats- oder Jahresabonnement',
  [T.professionalFeature2]: '15 € KI-Guthaben pro Nutzer inklusive',
  [T.professionalFeature3]:
    'Nahtlos weiter mit transparenter Pay As You Go-Abrechnung',
  [T.professionalFeature4]: 'Gemeinsamer Enterprise-KI-Guthabenpool',
  [T.professionalFeature5]: 'Customer Success inklusive',
  [T.professionalFeature6]: 'Eine Plattform. Alle Funktionen inklusive.',
  [T.enterprisePlanHeadline]: 'Dedizierte Enterprise-Bereitstellung',
  [T.enterprisePlanSubheading]:
    'Enterprise-KI, zugeschnitten auf Ihre Organisation',
  [T.enterprisePlanDescription]:
    'Betreiben Sie EmpowerGPT in der Umgebung, dem Betriebsmodell und der Größenordnung, die zu Ihrem Unternehmen passen.',
  [T.enterprisePlanFootnote]:
    'Zugeschnitten auf Ihre Bereitstellungs- und Geschäftsanforderungen',
  [T.enterprisePlanCta]: 'Vertrieb kontaktieren',
  [T.enterpriseFeature1]:
    'Public-, Dedicated-, Hybrid- oder On-Premises-Bereitstellung',
  [T.enterpriseFeature2]: 'Enterprise-Kapazitätsplanung',
  [T.enterpriseFeature3]: 'Dedizierter Customer Success',
  [T.enterpriseFeature4]: 'Individuelle Integrationen & Enterprise-Support',
  [T.enterpriseFeature5]: 'Jährliche Enterprise-Vereinbarung',
  [T.perUserPerMonthExclVat]: '/pro Nutzer / Monat (zzgl. MwSt.)',
  [T.workflowAddOnTitle]: 'Workflows',
  [T.workflowAddOnBadge]: 'Add-on',
  [T.workflowAddOnBasic]: 'Basis',
  [T.workflowAddOnAdvanced]: 'Erweitert',
  [T.workflowAddOnIncludedInProfessional]: 'In Professional enthalten',
  [T.workflowAddOnPerMonth]: '/Monat',
  [T.workflowAddOnPerYear]: '/Jahr',
  [T.workflowAddOnProfessionalRuns]: '6.000 Workflow-Ausführungen pro Monat',
  [T.workflowAddOnEnterpriseRuns]: '50.000 Workflow-Ausführungen pro Monat',
  [T.workflowAddOnFeatureUsers]: 'Unbegrenzte Nutzer',
  [T.workflowAddOnFeatureBlocks]: 'Unbegrenzte Blöcke pro Workflow',
  [T.workflowAddOnFeatureHistory]:
    'Alle Workflow-Funktionen inklusive, z. B. historische Ausführungen',
  [T.workflowAddOnFeaturePayg]:
    'Credits werden nach dem Pay-as-you-go-Modell abgerechnet',
  [T.workflowAddOnCta]: 'Jetzt starten',
  [T.addOnCancel]: 'Abonnement kündigen',
  [T.addOnReactivate]: 'Reaktivieren',
  [T.addOnPurchaseConfirmTitle]: 'Workflow-Add-on kaufen?',
  [T.addOnPurchaseConfirmDescription]:
    'Ihre hinterlegte Karte wird sofort mit dem anteiligen Betrag belastet.',
  [T.addOnCancelConfirmTitle]: 'Workflow-Add-on kündigen?',
  [T.addOnCancelConfirmDescription]:
    'Das Add-on bleibt bis zum Ende des aktuellen Abrechnungszeitraums aktiv und wird nicht erneut berechnet.',
  [T.addOnPurchaseSuccess]: 'Workflow-Add-on aktiviert',
  [T.addOnReactivateSuccess]: 'Workflow-Add-on reaktiviert',
  [T.addOnCancelSuccess]:
    'Workflow-Add-on wird zum Ende des aktuellen Zeitraums gekündigt',
  [T.addOnNotEligibleError]:
    'Add-ons erfordern einen aktiven Essential- oder Professional-Plan',
  [T.addOnAlreadyActiveError]: 'Dieses Add-on ist bereits aktiv',
  [T.addOnNotFoundError]: 'Kein aktives Add-on zum Kündigen vorhanden',
  [T.addOnPurchaseError]:
    'Das Add-on konnte nicht gekauft werden. Bitte versuchen Sie es erneut.',
  [T.addOnCancelError]:
    'Das Add-on konnte nicht gekündigt werden. Bitte versuchen Sie es erneut.',
  // ── ChatV2 ────────────────────────────────────────────────────────────────
  [T.assistantNotFound]: 'Assistent nicht gefunden',
  [T.noPermissionToEditAssistant]:
    'Keine Berechtigung zum Bearbeiten dieses Assistenten',
  [T.projectNotFound]: 'Projekt nicht gefunden',
  [T.attachmentsNotAvailableInPreview]:
    'Anhänge sind in der Vorschau nicht verfügbar',
  [T.sendMessage]: 'Nachricht senden',
  [T.addToThisMessage]: 'Zu dieser Nachricht hinzufügen',
  [T.skills]: 'Skills',
  [T.startVoiceInput]: 'Spracheingabe starten',
  [T.voiceInputUnavailable]: 'Spracheingabe nicht verfügbar',
  [T.stopVoiceInput]: 'Spracheingabe beenden',
  [T.world]: 'Welt',
  [T.featureComingSoon]: '{{feature}} sind bald verfügbar',
  [T.removeItem]: '{{name}} entfernen',
  [T.shareChat]: 'Chat teilen',
  [T.continueWithThisModel]: 'Mit diesem Modell fortfahren',
  [T.resizeChatAndDocumentPanes]:
    'Größe der Chat- und Dokumentbereiche anpassen',
  [T.jumpToLatestMessage]: 'Zur neuesten Nachricht springen',
  [T.conversationMessages]: 'Nachrichten der Unterhaltung',
  [T.sharedConversationMessages]: 'Nachrichten der geteilten Unterhaltung',
  [T.shareProject]: 'Projekt teilen',
  [T.startNewChatInThisProject]: 'Einen neuen Chat in diesem Projekt starten',
  [T.shareProjectDescription]:
    'Jede Person, die Sie hinzufügen, erhält Zugriff auf dieses Projekt und alle seine Chats, einschließlich dieses Chats.',
  [T.mcpOAuthOwnerManaged]:
    'Diese Verbindung wird vom Eigentümer des Assistenten verwaltet. Bitten Sie ihn, sie herzustellen, bevor Sie diese Aktion ausführen.',
  [T.confirmActionHeading]: 'Möchten Sie diese Aktion bestätigen?',
  [T.connectAccountHeading]: 'Verbinden Sie Ihr Konto, um fortzufahren',
  [T.connectAccountDescription]:
    'Für diese Aktion ist Zugriff auf Ihr Konto erforderlich. Stellen Sie die Verbindung her, und der Agent macht von hier aus weiter.',
  [T.editMessage]: 'Nachricht bearbeiten',
  [T.otherEllipsis]: 'Sonstiges ...',
  [T.addSpecificDetailsHere]: 'Fügen Sie hier konkrete Angaben hinzu',
  [T.likedResponse]: 'Antwort mit „Gefällt mir“ bewertet',
  [T.dislikedResponse]: 'Antwort mit „Gefällt mir nicht“ bewertet',
  [T.likeResponse]: 'Antwort mit „Gefällt mir“ bewerten',
  [T.dislikeResponse]: 'Antwort mit „Gefällt mir nicht“ bewerten',
  [T.stopReading]: 'Vorlesen beenden',
  [T.readAloud]: 'Vorlesen',
  [T.feedbackReportDisclaimer]:
    'Wenn Sie diese Meldung absenden, wird die aktuelle Unterhaltung zur künftigen Verbesserung unserer Modelle an Empower GPT übermittelt.',
  [T.minimizeImage]: 'Verkleinern',
  [T.toggleSidebar]: 'Seitenleiste ein-/ausblenden',
  [T.rotateClockwise]: 'Im Uhrzeigersinn drehen',
  [T.fitToWidth]: 'An Breite anpassen',
  [T.print]: 'Drucken',
  [T.fileSize]: 'Dateigröße',
  [T.keywords]: 'Schlagwörter',
  [T.pdfProducer]: 'PDF-Ersteller',
  [T.pdfVersion]: 'PDF-Version',
  [T.pageCount]: 'Seitenanzahl',
  [T.pageSize]: 'Seitengröße',
  [T.fastWebView]: 'Schnelle Webansicht',
  [T.yes]: 'Ja',
  [T.no]: 'Nein',
  [T.documentProperties]: 'Dokumenteigenschaften',
  [T.pageNumber]: 'Seitenzahl',
  [T.previousPage]: 'Vorherige Seite',
  [T.nextPage]: 'Nächste Seite',
  [T.documentNavigation]: 'Dokumentnavigation',
  [T.thumbnails]: 'Miniaturansichten',
  [T.outline]: 'Gliederung',
  [T.currentZoom]: 'Aktueller Zoom',
  [T.twoPageView]: 'Zweiseitenansicht',
  [T.noFileOpen]: 'Keine Datei geöffnet',
  [T.closeTab]: '{{name}} schließen',
  [T.pageWithNumber]: 'Seite {{page}}',
  [T.creatingLink]: 'Link wird erstellt',
  [T.shareChatLinkDisclaimer]:
    'Jede Person mit diesem Link kann die Unterhaltung sehen. Neue Nachrichten sind nicht sichtbar. Teilen Sie private oder sensible Informationen nur mit Personen, denen Sie vertrauen.',
  [T.shareUsingCopyLink]: 'Über einen kopierten Link teilen',
  [T.onlyMessagesUpToThisPoint]:
    'Es werden nur die Nachrichten bis zu diesem Punkt geteilt.',
  [T.sessionIsPrivate]: 'Diese Sitzung ist privat',
  [T.sharedSessionReadOnlyNotice]:
    'Sie sehen eine schreibgeschützte Momentaufnahme, die mit Ihnen geteilt wurde. Das Bearbeiten, Neugenerieren und Bewerten von Nachrichten ist deaktiviert.',
  [T.viewMoreFilesCount]: 'Weitere Dateien anzeigen ({{count}})',
  [T.openSource]: '{{name}} öffnen',
  [T.performedOneStep]: '1 Schritt ausgeführt',
  [T.performedStepsCount]: '{{count}} Schritte ausgeführt',
  [T.script]: 'Skript',
  [T.searchingTheWorkspaces]: 'Arbeitsbereiche werden durchsucht',
  [T.searchingTheWeb]: 'Das Internet wird durchsucht',
  [T.runningAScript]: 'Ein Skript wird ausgeführt',
  [T.executingTheCode]: 'Der Code wird ausgeführt',
  [T.deepResearch]: 'Tiefenrecherche',
  [T.callingASubAgent]: 'Ein Subagent wird aufgerufen',
  [T.checkingFiles]: 'Dateien werden geprüft',
  [T.toolSearch]: 'Tool-Suche',
  [T.waitingForConfirmation]: 'Warten auf Bestätigung',
  [T.failedDoingAction]: 'Aktion fehlgeschlagen',
  [T.working]: 'In Arbeit',
  [T.suggestedQuestions]: 'Vorgeschlagene Fragen',
  [T.hiHowCanIAssistYouToday]: 'Hallo, wie kann ich Ihnen heute helfen?',
  [T.howCanIAssistYouToday]: 'Wie kann ich Ihnen heute helfen?',
  [T.askAnythingAboutProject]:
    'Fragen Sie alles über {{projectName}} und seine Wissensdatenbank.',
  [T.assistantUpdatedByController]:
    'Der Controller hat den Assistenten aktualisiert, daher kann Ihr Nutzungserlebnis abweichen.',
  [T.assistantModelDisabledMessage]:
    'Der Administrator hat das KI-Modell des Assistenten deaktiviert. Controller-Nutzer können ein neues Modell zuweisen; vorerst wechseln wir Sie zu {{model}}.',
  [T.latestAndMostUsedModelNamed]:
    'unserem neuesten und meistgenutzten KI-Modell, {{model}}',
  [T.latestAndMostUsedModel]: 'unserem neuesten und meistgenutzten KI-Modell',
  [T.assistantFilesNoPermission]:
    'Sie haben keine Berechtigung, mit bestimmten Dateien in der Wissensdatenbank dieses Assistenten zu chatten.',
  [T.assistantFilesLimitedAccess]:
    'Ihr Zugriff auf seine Wissensdatenbank ist eingeschränkt, daher können die Antworten begrenzt sein.',
  [T.assistantFilesLimitedAccessLong]:
    'Ihr Zugriff auf die Wissensdatenbank des Assistenten ist eingeschränkt, daher können die Antworten entsprechend begrenzt sein!',
  [T.assistantUpdatedByCreator]:
    'Der Assistent wurde von seinem Ersteller aktualisiert, möglicherweise wegen gelöschter oder neu hinzugefügter Dateien. Die Antworten spiegeln diese Änderungen wider.',
  [T.assistantUpdatedByCreatorShort]:
    'Er wurde von seinem Ersteller aktualisiert – möglicherweise wurden Dateien hinzugefügt oder entfernt –, daher spiegeln die Antworten diese Änderungen wider.',
  [T.reconnectingToChatService]:
    'Verbindung zum Chat-Dienst wird wiederhergestellt (Versuch {{attempt}}) …',
  [T.chatConnectionLost]:
    'Die Verbindung zum Chat-Dienst wurde unterbrochen. Mit Ihrer nächsten Nachricht wird die Verbindung wiederhergestellt – bis dahin werden Antworten möglicherweise nicht gestreamt.',
  [T.attachmentUploadFailed]: 'Upload fehlgeschlagen',
  [T.skippedFilesWarning]:
    'Einige Dateien wurden übersprungen, weil sie nicht unterstützt werden, zu groß sind, das Anhangslimit überschreiten oder nicht hochgeladen werden konnten.',
  [T.openingEllipsis]: 'Wird geöffnet …',
  [T.citationSourcePending]:
    'Die Quellen sind verfügbar, sobald die Antwort abgeschlossen ist.',
  [T.citationSourceUnresolved]:
    'Die Quelle dieses Zitats ist in dieser Antwort nicht aufgeführt.',
  [T.citationSourceReadOnly]: 'Quellen können hier nicht geöffnet werden.',
  [T.openCitation]: 'Zitat {{label}} öffnen: {{name}}',
  [T.citationWithTitle]: 'Zitat {{label}} – {{title}}',
  [T.viewSource]: 'Quelltext anzeigen',
  [T.viewDiagram]: 'Diagramm anzeigen',
  [T.downloadDiagram]: 'Diagramm herunterladen',
  [T.copyCode]: 'Code kopieren',
  [T.waitForResponseToFinish]: 'Warten Sie, bis die Antwort abgeschlossen ist',
  [T.filesAreStillUploading]: 'Dateien werden noch hochgeladen',
  [T.filesAreStillBeingProcessed]: 'Dateien werden noch verarbeitet',
  [T.waitForBothAnswersToFinish]:
    'Warten Sie, bis beide Antworten abgeschlossen sind',
  [T.pickModelForEachColumn]:
    'Wählen Sie für jede Spalte ein Modell zum Vergleichen aus',
  [T.nameYourAssistantToTryItOut]:
    'Benennen Sie Ihren Assistenten, um ihn auszuprobieren',
  [T.pickAModelToTryItOut]: 'Wählen Sie ein Modell aus, um es auszuprobieren',
  [T.assistantModelDisabledClause]:
    'Sein KI-Modell wurde deaktiviert, daher haben wir Sie zu {{model}} gewechselt.',
  [T.hiComma]: 'Hallo,',
  [T.assistantActionsAriaLabel]: '{{name}} – Assistenten-Aktionen',
  [T.shareChatTrustTitle]: 'Vertrauen Sie der Person, mit der Sie teilen?',
  [T.shareProjectTitle]: 'Sie teilen das gesamte Projekt',
  [T.feedbackDislikeTitle]:
    'Was hat Ihnen an dieser Antwort nicht gefallen? (optional)',
  [T.developerRelease]: 'Entwickler-Release',
  [T.totalDocumentsProcessed]:
    'Dokumente insgesamt · {{percent}} % verarbeitet',
  [T.moreCount]: '{{count}}+ weitere',
  [T.aiModelsInfo]:
    'Jeder Chat in diesem Zeitraum, aufgeschlüsselt nach dem KI-Modell, das ihn beantwortet hat.',
  [T.chatTabLabel]: 'Chat',
  [T.chatsPerDayAvg]: 'Chats pro Tag (Durchschnitt)',
  [T.activeMembersWithChat]: 'Aktive Mitglieder (1+ Chat)',
  [T.chatKnowledge]: 'Chat-Wissen',
  [T.chatKnowledgeInfo]:
    'Chats sind begonnene Unterhaltungen; Nachrichten sind einzelne Anfragen darin. An einem geschäftigen Tag kann es wenige Chats, aber viele Nachrichten geben.',
  [T.dailyActivity]: 'Tägliche Aktivität',
  [T.lessLabel]: 'Weniger',
  [T.moreLabel]: 'Mehr',
  [T.chatsByModules]: 'Chats nach Modulen',
  [T.chatsByModulesInfo]:
    'Wie oft der Chat in jedem Modul genutzt wurde. Zum Beispiel in Chat, innerhalb von Projekten, über Assistenten oder von Smart Meet und Workflows aus.',
  [T.moduleColumn]: 'Modul',
  [T.toolUsage]: 'Tool-Nutzung',
  [T.toolUsageInfo]:
    'Tools, die in den Chats Ihres Teams verwendet wurden. Welche Tools der Assistent beim Erstellen von Antworten genutzt hat, Tag für Tag. Dies zeigt, wodurch die Antwort zustande kam, nicht was der Nutzer eingegeben hat.',
  [T.enterpriseSearch]: 'Unternehmenssuche',
  [T.moreOthers]: 'Weitere',
  [T.documentsInfo]:
    'Wie viele Dokumente in Ihrem Workspace verarbeitet wurden. Verarbeitete Dokumente sind durchsuch- und zitierbar; unverarbeitete werden noch gelesen.',
  [T.appsInfo]:
    'Nutzung der integrierten Apps in diesem Zeitraum, mit der Veränderung gegenüber dem vorherigen Zeitraum.'
};

export default deJSON;
